import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useRef } from "react";
import OwlCarousel from "react-owl-carousel";
import VideoYoutube from "../partials/home/VideoYoutube";
import BannerTextAI from "../partials/home/BannerTextAI";

import InterviewCall from "../partials/home/InterviewCall";
import MentorsProfile from "../partials/home/MentorsProfile";
import { useIsVisible } from "../hooks/useIsVisible";
import HiringOrganizations from "../partials/home/HiringOrganizations";
import Projects from "../partials/home/Projects";
import CareerServicesAI from "../partials/home/CareerServicesAI";
import Certificates from "../partials/home/Certificates";
import CourseReview from "../partials/home/CourseReview";

function DataScienceCourseBangalore() {

    const [toggle, setTg] = useState();
    
    const [activeSection, setActiveSection] = useState("");
    const sectionRef = useRef(null);
    const [countdownText, setCountdownText] = useState("");
  
    const [isNavFixed, setIsNavFixed] = useState(false);
    const [isNavFixed2, setIsNavFixed2] = useState(false);
    const navRef = useRef(null);
    const navRef2 = useRef(null);
  
    const overviewSection = useRef();
    const isVisibleOverview = useIsVisible(overviewSection);
  
    const overview1Section = useRef();
    const isVisible1verview = useIsVisible(overview1Section);
  
    const overviewSectionIntroduction = useRef();
    const isVisibleOverviewIntroduction = useIsVisible(overviewSectionIntroduction);
  
    const overviewSectionInclude = useRef();
    const isVisibleOverviewInclude = useIsVisible(overviewSectionInclude);
  
    const overviewSectionOffer = useRef();
    const isVisibleOverviewOffer = useIsVisible(overviewSectionOffer);
  
  
    const curriculumSection = useRef();
    const isVisibleCurriculum = useIsVisible(curriculumSection);
  
    const curriculum0Section = useRef();
    const isVisible0Curriculum = useIsVisible(curriculum0Section);
  
    const curriculum2ndSection = useRef();
    const isVisible2ndCurriculum = useIsVisible(curriculum2ndSection);
  
    const curriculum3rdSection = useRef();
    const isVisible3rdCurriculum = useIsVisible(curriculum3rdSection);
  
    const curriculum4thSection = useRef();
    const isVisible4thCurriculum = useIsVisible(curriculum4thSection);
  
    const curriculum5thSection = useRef();
    const isVisible5thCurriculum = useIsVisible(curriculum5thSection);
  
    
    const placementSection = useRef();
    const isVisiblePlacement = useIsVisible(placementSection);
  
    const syllabusInDetail = useRef();
    const isVisibleSyllabus = useIsVisible(syllabusInDetail);
  
    const syllabusInView = useRef();
    const isVisibleSyllabusView = useIsVisible(syllabusInView);
    
    const certificationSection = useRef();
    const isVisibleCertification = useIsVisible(certificationSection);
    const mentorSection = useRef();
    const isVisibleMentor = useIsVisible(mentorSection);
  
    const coursereviewSection = useRef();
    const isVisibleCoursereview = useIsVisible(coursereviewSection);
  
    const coursere1viewSection = useRef();
    const isVisible1Coursereview = useIsVisible(coursere1viewSection);
  
    const feeSection = useRef();
    const isVisibleFee = useIsVisible(feeSection);
  
    const feeDetails = useRef();
    const isVisibleFeeDetails = useIsVisible(feeDetails);
  
    const faqSection = useRef();
    const isVisibleFaq = useIsVisible(faqSection);
  
    const faqDetails = useRef();
    const isVisibleFaqDetails = useIsVisible(faqDetails);
  
    const contactSection = useRef();
    const isVisibleContact = useIsVisible(contactSection);
  
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
          setWidth(window.innerWidth);
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);
    
      useEffect(() => {
        const activeItem = document.querySelector('.scrollble-tab-li.active');
        if (activeItem) {
          const list = document.getElementById('scrollble-ul-page');
          const scrollLeft = activeItem.offsetLeft - (list.offsetWidth / 2) + (activeItem.offsetWidth / 2);
          setTimeout(() => {
            list.scrollLeft = scrollLeft;
          }, 750)
          
        }
      }, [
        isVisibleOverview, isVisibleOverviewIntroduction, isVisible1verview, isVisibleCurriculum, isVisible0Curriculum, isVisible2ndCurriculum, isVisible3rdCurriculum, isVisible4thCurriculum, isVisible5thCurriculum, isVisibleFeeDetails, isVisibleFaqDetails, isVisibleOverviewInclude, isVisibleSyllabus, isVisibleSyllabusView, isVisibleOverviewOffer, isVisiblePlacement, isVisibleCertification, isVisibleMentor, isVisibleCoursereview, isVisible1Coursereview, isVisibleFee, isVisibleFaq, isVisibleContact
      ])
    
      useEffect(() => {
    
        const navContainer = navRef.current;
    
        const toggleSyllabusButtonsVisibility = (entries) => {
          const isVisible = entries[0].isIntersecting;
          navContainer.classList.toggle("sticky-section", isVisible);
        };
    
    
        const isSmallScreen = window.innerWidth < 767;
    
        if (isSmallScreen) {
          const navContainerHeight = navContainer.clientHeight;
          const navThreshold = 200 / navContainerHeight;
    
    
          const options = {
            threshold: [navThreshold],
          };
    
          if (navThreshold <= 0.5) {
            const navObserver = new IntersectionObserver(
              toggleSyllabusButtonsVisibility,
              options
            );
            navObserver.observe(navContainer);
          } else {
            console.error("Syllabus threshold exceeds 1. Please adjust the value.");
          }
    
    
        }
    
        // Return empty cleanup function if not a small screen
        return () => {
          const navObserver = new IntersectionObserver(
            toggleSyllabusButtonsVisibility
          );
          navObserver.unobserve(navContainer);
        };
      }, []);
    
      useEffect(() => {
    
        const navContainer2 = navRef2.current;
    
        const toggleSyllabusButtonsVisibility = (entries) => {
          const isVisible = entries[0].isIntersecting;
          navContainer2.classList.toggle("sticky-section", isVisible);
        };
    
    
        const isSmallScreen = window.innerWidth < 767;
    
        if (isSmallScreen) {
          const navContainer2Height = navContainer2.clientHeight;
          const navThreshold = 200 / navContainer2Height;
    
    
          const options = {
            threshold: [navThreshold],
          };
    
          if (navThreshold <= 0.5) {
            const navObserver = new IntersectionObserver(
              toggleSyllabusButtonsVisibility,
              options
            );
            navObserver.observe(navContainer2);
          } else {
            console.error("Syllabus threshold exceeds 1. Please adjust the value.");
          }
    
    
        }
     
        return () => {
          const navObserver = new IntersectionObserver(
            toggleSyllabusButtonsVisibility
          );
          navObserver.unobserve(navContainer2);
        };
      }, []);

      useEffect(() => {
        const countDownDate = new Date("April 27, 2023 10:00:00").getTime();
    
        const interval = setInterval(() => {
          const now = new Date().getTime();
          const distance = countDownDate - now;
    
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
          if (distance < 0) {
            clearInterval(interval);
            document.getElementById("time_counter").innerHTML = "<h1>Batch for Data Science & AI Live classes starts on</h1> <div class='days'><h3>11th May</h3></div>";
          } else {
    
            {
            setCountdownText(
    
    
              `<h3>Live Classes for the Data Science & AI Master Course Starts From</h3> 
              <div class='days'><h3>11th May</h3><span></span></div>`
            
            );
            }
    
    
            {
    
              setCountdownText(
    
    
                `<h3>Live Classes for the Data Science & AI Course Starts in</h3> 
              <div class='days'><h3>${days}</h3><span>Days</span></div>
              <div class='hours'><h3>${hours}</h3><span>Hours</span></div>
              <div class='minutes'><h3>${minutes}</h3><span>Minutes</span></div>
              <div class='second'><h3>${seconds}</h3><span>Seconds</span></div>`
              );
            }
    
          }
        }, 1000);
    
        return () => clearInterval(interval);
      }, []);

   
        
return (
    <div>
      <title>Data Science Course in Bangalore with Job Assistance</title>
      <meta
        name="description"
        content="Join our Data Science Course in Bangalore to help you master Python, ML, and AI with placement assistance. Become a certified Data Scientist in 7 months."
      />
      <link
        rel="canonical"
        href="https://logicmojo.com/datascience-course/"
      />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Data Science Course Online (2024)"
      />
      <meta
        property="og:description"
        content="Join our online Data Science Course to help you master Python, ML, and AI with placement assistance. Become a certified Data Scientist in 7 months."
      />
      <meta
        property="og:url"
        content="https://logicmojo.com/datascience-course"
      />
      <meta property="og:site_name" content="Logicmojo" />
      <meta
        property="article:modified_time"
        content="2024-01-5T11:45:44+00:00"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:image"
        content="https://logicmojo.com/assets/dist/new_pages/images/datas.png"
      />
      <meta name="twitter:label1" content="Est. reading time" />
      <meta name="twitter:data1" content="1 minute" />

      <div className="fulltrakmenu sticky secondmenu " id="secondmenu">
        <div className="container d-flex justify-content-between align-items-center" style={{ paddingTop: 10 + "px" }}>
          <a className="navbar-brand" href="/">
            <img width={150} src="assets/images/LogicmojoLogo.png" alt="" className="new_logo " />
          </a>
          <div className="ml-auto">
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
              className="enroll-btn btn btn-danger"
            >
              <b>Apply Now</b>
            </a>
          </div>
        </div>
      </div>

      <div className="banner-ai">
        <div className="container  position-relative">
          <div className="banner-ai-inner">
            <div className="banner-ai-links">
              <ul>
                <li style={{ fontsize: 14 }}>
                  <Link to="https://logicmojo.com">Home</Link>
                </li>
                <li style={{ fontsize: 14 }}>
                  <a href="">Data Science Course in Bangalore</a>
                </li>
              </ul>
            </div>
            <div className="bestsaller">
              <span>
                <i className="fa fa-star" aria-hidden="true"></i> Bestseller
              </span>
            </div>
            <div className="bestsaller">
              <div className="ratinglink">
                Review 4.8
                <div className="ratingstarfa">
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                </div>
                <a href="#coursereview">(14395 Ratings)</a>
              </div>
            </div>
            <BannerTextAI />
            <div className="banner-ai-btngrp">
              <a
                target="_default"
                href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"

                //data-toggle="modal"
                className="counsbtn btnstyle002"
              >
                Apply For Live Classes
              </a>

            </div>
            {/* <div className="banner-ai-experts">
              <p style={{ fontsize: 14 }}>
                Data Science & AI Master Course Starts From{" "}
                <u>
                  <b>11th May</b>
                </u>
              </p>
            </div> */}
            <div className="banner-ai-experts">
              <p style={{ fontsize: 14 }}>Ranked #1 Data Science Course in Bangalore With Industry Experts From</p>
              <a href="">
                <img src="assets/images/amazonwhite.png" alt="" />
              </a>
              <a href="">
                <img alt="" src="assets/images/googlewhite.png" />
              </a>
              <a href="">
                <img alt="" src="assets/images/microsoftwhite.png" />
              </a>
              <a href="">
                <img src="assets/images/metawhite.png" alt="" />
              </a>
              <a href="">
                <img src="assets/images/flipcart.png" alt="" />
              </a>
              <a href="">
                <img src="assets/images/intelwhite.png" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="banner-aistrip" ref={overview1Section}>
        <div className="container ">
          <ul>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon1.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14}}><b>120% Average Hike</b></div>
                <div style={{ fontsize: 14 }}>in Job Switch</div>
              </div>
            </li>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon2.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14 }}><b>7 Months</b></div>
                <div style={{ fontsize: 14 }}>Weekend Live Classes</div>
              </div>
            </li>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon3.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14 }}><b>Project Based Learning</b></div>
                <div style={{ fontsize: 14 }}>Real Time Projects</div>
              </div>
            </li>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon4.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14 }}><b>Job Assistance</b></div>
                <div style={{ fontsize: 14 }}>100% Placements</div>
              </div>
            </li>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon5.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14 }}><b>Starts at INR 4,500/month*</b></div>
                <div style={{ fontsize: 14 }}>EMI Options Available</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
     

     

      <div className="itfeaturevideorow" ref={overviewSectionIntroduction}>
        <div className="container ">
          <h3>
          What Experts Say About<b style={{ fontSize: 28, color:"#9769ef" }}> Data Science</b>
          </h3>
          <br />
          <br />
          {/* <div className="itfeaturevideo">
            <iframe
              loading="lazy"
              src="https://www.youtube.com/embed/MZ6eHbNnngk"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen=""
              width="100%"
              height="450"
              frameBorder="0"
            ></iframe>
          </div> */}

          <div className="video-wrap">
            <div className="video">
              <iframe
                loading="lazy"
                src="https://www.youtube.com/embed/aiqdypMW64I"
                // src="https://www.youtube.com/embed/MZ6eHbNnngk"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen=""
                width="40%"
                height="450"
                frameBorder="0"
              ></iframe>
              
            </div>
          </div>
        </div>
      </div>
          
      <section className="btn-center-section" id="placement">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href=""
            className=""
          >
           
          </a>
        </div></center>
      </section>

      <div className="container">
      <center><h3 style={{ fontSize: 25}}>Get Assured Data Scientist Calls from Top Recruiters in Bangalore</h3></center>
      <center><h4>Over <b style={{ fontSize: 25, color:"#9769ef" }}>500+ Hiring Partners</b></h4></center><br/>
      <HiringOrganizations />
      </div>



      <section
        className="sec-navbar"
      >
        {/* <div className="container  d-md-none d-flex justify-content-between align-items-center" style={{ paddingTop: 10 + "px" }}>
          <a className="navbar-brand" href="/">
            <img width={150} src="assets/images/LogicmojoLogo.png" alt="" className="new_logo d-md-none d-block" />
          </a>
          <div>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
              className="enroll-btn btn btn-danger"
            >
              <b>Apply Now</b>
            </a>
          </div>
        </div> */}


        <nav className="container d-flex justify-content-between align-items-center">
          <ul id="scrollble-ul-page">
            <li className={`scrollble-tab-li ${isVisibleOverview || isVisibleOverviewInclude|| isVisibleOverviewOffer || isVisibleOverviewIntroduction || isVisible1verview && !isVisibleCurriculum ?"active" : ""}`}>
              <a href="#Overview">Overview</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleCurriculum || isVisible2ndCurriculum || isVisible3rdCurriculum || isVisible4thCurriculum || isVisible5thCurriculum || isVisible0Curriculum && !isVisibleSyllabus ? "active" : ""}`}>
              <a href="#curriculum">Curriculum</a>
            </li>

            <li className="">
              <a
                target="_default"
                href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view"
              >
                Course Brochure
              </a>
            </li>
  
            <li className={`scrollble-tab-li ${isVisibleSyllabus||isVisibleSyllabusView ? "active" : ""}`}>
              <a href="#curriculum">Syllabus</a>
            </li>
           
            <li className={`scrollble-tab-li ${isVisibleMentor && !isVisibleCoursereview ? "active" : ""}`}>
              <a href="#mentor">Mentor</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleCoursereview  || isVisible1Coursereview && !isVisibleFee ? "active" : ""}`}>
              <a href="#coursereview">Reviews</a>
            </li>
            <li className={`scrollble-tab-li ${isVisiblePlacement && !isVisibleCertification ? "active" : ""}`}>
              <a href="#placement">Placement</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleCertification && !isVisibleMentor ? "active" : ""}`}>
              <a href="#certification">Certification</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleFee || isVisibleFeeDetails ? "active" : ""}`}>
              <a href="#fee">Fee</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleFaq || isVisibleFaqDetails ? "active" : ""}`}>
              <a href="#faq">FAQs</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleContact ? "active" : ""}`}>
              <a href="#contact">Contact</a>
            </li>
          </ul>


          {/* <ul id="scrollble-ul-page">
            <li className={`scrollble-tab-li ${activeSection === "courseoverview" ? "active" : ""}`}>
              <a href="#courseoverview">Overview</a>
            </li>
            <li className={`scrollble-tab-li ${activeSection === "curriculum" ? "active" : ""}`}>
              <a href="#curriculum">Curriculum</a>
            </li>
            <li className={`scrollble-tab-li ${activeSection === "placement" ? "active" : ""}`}>
              <a href="#placement">Placement</a>
            </li>
            <li className={`scrollble-tab-li ${activeSection === "certification" ? "active" : ""}`}>
              <a href="#certification">Certification</a>
            </li>

            <li className={`scrollble-tab-li ${activeSection === "mentor" ? "active" : ""}`}>
              <a href="#mentor">Mentor</a>
            </li>
            <li className={`scrollble-tab-li ${activeSection === "coursereview" ? "active" : ""}`}>
              <a href="#coursereview">Reviews</a>
            </li>
            <li className={`scrollble-tab-li ${activeSection === "fee" ? "active" : ""}`}>
              <a href="#fee">Fee</a>
            </li>
            <li className={`scrollble-tab-li ${activeSection === "faq" ? "active" : ""}`}>
              <a href="#faq">FAQs</a>
            </li>
            <li className={`scrollble-tab-li ${activeSection === "contact" ? "active" : ""}`}>
              <a href="#contact">Contact</a>
            </li>

          </ul> */}
          {/* -- this one 
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/career-counselling-live-classes?month=2024-03"
              className="enroll-btn btn btn-danger"
            >
              <b>Register Yourself!</b>
            </a>
          </div>
      */}
        </nav>
      </section>
      {/*
      <center><br /><br /><h2><span>Course Reviews</span></h2></center>

      <div className="review-courses-block">
        <div className="container">
          <div className="reclogoinfo">
            <ul>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.switchup.org/bootcamps/logicmojo"><img src="assets/images/switchup.jpg" border="0" alt="" /></a>
                </div>
                <p style={{ fontsize: 14 }}>
                  4.9<span className="fa fa-star checked"></span>
                </p>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.google.com/search?q=logicmojo&oq=logicmojo+&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg8MgcIAhAAGIAEMgYIAxAjGCcyBggEEEUYQTIGCAUQRRg8MgYIBhBFGDwyBggHEEUYPNIBCTIyMjc0ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x3bae15239d632ad3:0x8248087353e6d723,1,,,,"><img src="assets/images/googlereview.jpg" border="0" alt="" /></a>
                </div>
                <p style={{ fontsize: 14 }}>
                  4.8<span className="fa fa-star checked"></span>
                </p>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.trustpilot.com/review/logicmojo.com"><img src="assets/images/trustpilot.jpg" border="0" alt="" /></a>
                </div>
                <p style={{ fontsize: 14 }}>
                  4.7<span className="fa fa-star checked"></span>
                </p>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.justdial.com/Bangalore/Logic-Mojo-Kadubeesanahalli/080PXX80-XX80-220129215746-F5U9_BZDET"><img src="assets/images/justdial.jpg" border="0" alt="" /></a>
                </div>
                <p style={{ fontsize: 14 }}>
                  4.7<span className="fa fa-star checked"></span>
                </p>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.ambitionbox.com/reviews/logicmojo-academy-reviews"><img src="assets/images/ambitionbox.jpg" border="0" alt="" /></a>
                </div>
                <p style={{ fontsize: 14 }}>
                  5<span className="fa fa-star checked"></span>
                </p>
              </li>

              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.quora.com/What-is-your-review-after-subscribing-to-the-Data-Structure-Algorithms-System-Design-online-course-by-Logicmojo"><img src="assets/images/Quora.jpg" border="0" alt="" /></a>
                </div>


              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://priyaasingh.medium.com/why-logicmojo-is-the-best-choice-for-working-professionals-to-learn-data-science-6d895e3648fb"><img src="assets/images/medium.jpg" border="0" alt="" /></a>
                </div>

              </li>
            </ul>
          </div>
        </div>

      </div>
      
      <div
        id="time_counter"
        dangerouslySetInnerHTML={{ __html: countdownText }}
      ></div>
    */}
    


      <section ref={overviewSection} className="btn-center-section" id="Overview">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>



     

      <div className="ourclientbg-new" >
        <div className="container">
          <h3 style={{ fontSize: 25}}>Where Our <b style={{ fontSize: 25, color:"#9769ef" }}>Alumni</b> Work?</h3>

          <OwlCarousel
            className="owl-theme"
            loop
            margin={20}
            nav
            navText={[
              " ",
              " ",
            ]}
            responsive={{
              0: {
                items: 1
              },
              600: {
                items: 1
              },
              1000: {
                items: 3
              }
            }}
          >
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/makemytrip.jpeg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/vmware.jpg" alt="" />
              <img src="assets/images/intuit.jpg" alt="" />
              <img src="assets/images/meta.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/oracle.jpg" alt="" />
              <img src="assets/images/ciscologo.jpg" alt="" />
              <img src="assets/images/adobe.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/intel.jpg" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/paypal.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/sony.jpg" alt="" />
            </div>
          </OwlCarousel>

        </div>
      </div>

     

      <section ref={overviewSectionOffer} className="whymakesnew" id="Overview">
        <div className="container ">
          <h2 style={{ fontSize: 30 }}>
          Data Science Course in Bangalore -<b style={{ fontSize: 30, color:"#9769ef" }}>What is it like?</b> 
          </h2>
          <br></br>
          <p style={{ fontSize: 14 }}>
          Join our live instructor-led Data Science Course in bangalore and become a skilled data scientist in 7 months! 
          Gain expertise in in-demand skills like <a href="https://logicmojo.com/python-for-data-science">Python</a>, <a href="https://logicmojo.com/sql-interview-questions">SQL</a>, <a href="https://logicmojo.com/machine-learning-interview-questions">Machine Learning</a>, <a href="https://logicmojo.com/tableau-interview-questions">Tableau</a>, Generative AI, <a href="https://logicmojo.com/what-is-deep-learning">Deep Learning</a>, and more. Benefit from our industry-aligned data science syllabus, 10+ <a href="https://logicmojo.com/data-science-projects"> data science projects</a>, mock interviews, and job referrals. Elevate your Data Science career with our dedicated Career Service in Bangalore.
          </p><br/>
          
          <p style={{ fontSize: 25}}><b>Key Features</b></p>
          
          <div className="coursesbg liveprogrambg">
        <div className="container">
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active m-0"
                id="pills-home-tab002"
                data-toggle="pill"
                href="#pills-home002"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                Course Overview
              </a>
            </li>
          </ul>

          <div className="tab-content" id="pills-tabContent">
           
              <div className="liveprogram-innerbg">
                {/*
              <h1>
                  What are the <span>Course Overview</span> for
                  you
                </h1>
              */}

                <div className="row align-items-center justify-content-center" ref={overviewSection}>
                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/live-interactive.png"
                            alt=""
                          />
                          <h3>Live Interactive Sessions at Bangalore</h3>
                        </div>
                        <div className="flip-card-back">
                        Get Trained by Expert Data Scientists in Live Classes
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-1.png"
                            alt=""
                          />
                          <h3> Practical Experience through Projects</h3>
                        </div>
                        <div className="flip-card-back">
                          Practical experience through real-time 15+ projects
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-2.png"
                            alt=""
                          />
                          <h3> 1:1 doubt clearing sessions</h3>
                        </div>
                        <div className="flip-card-back">
                          Personalized programs with Live classes and 1:1 doubt
                          clearing sessions/mentorship sessions.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-3.png"
                            alt=""
                          />
                          <h3>Job Assistance Program</h3>
                        </div>
                        <div className="flip-card-back">
                          Job Referrals in Product Companies in Bangalore, Resume Preparation
                          Session and Mock interviews
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-4.png"
                            alt=""
                          />
                          <h3>Missed Classes ?</h3>
                        </div>
                        <div className="flip-card-back">
                          Attend multiple batches with multiple trainers in various locations at Bangalore.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-5.png"
                            alt=""
                          />
                          <h3>Life Time Access</h3>
                        </div>
                        <div className="flip-card-back">
                          Missed Classes, get lifetime access recorded lectures
                          of all classes
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-6.png"
                            alt=""
                          />
                          <h3>peer to Peer Learning?</h3>
                        </div>
                        <div className="flip-card-back">
                          Slack group for peer-to-peer learning & discussion
                          with batchmates. Case studies & GitHub for
                          Code review.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-7.png"
                            alt=""
                          />
                          <h3>Flexible Pay</h3>
                        </div>
                        <div className="flip-card-back">
                          Flexible EMI options on Credit cards and Debit cards.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/selfpaced-2.png"
                            alt=""
                          />
                          <h3>Assignments for Practise After Class</h3>
                        </div>
                        <div className="flip-card-back">
                          Solve Assignments after every classes. Data Science Study Materials & project work.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/selfpaced-6.png"
                            alt=""
                          />
                          <h3>Data Science Weekly tests</h3>
                        </div>
                        <div className="flip-card-back">
                          Evaluate yourself in competitive tests with
                          your batchmates in Data Science
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           
          </div>
          <br/>
   
       
        </div>

   
   <br/>

        <div style={{ width: "250px", margin: "0 auto" }}>
          {/* <a
            target="_default"
            href="https://calendly.com/logicmojo/career-counselling-live-classes?month=2023-08"
            className="counsbtn2"
          >
            Apply For Live Classes{" "}
            <i className="fa fa-angle-right arrowclass" aria-hidden="true"></i>
          </a> */}

          
        </div>
      </div>
          {/*
          <div className="row">
            <div className="col-md-4 col-6">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon1.png" alt="" />
                <h4>1-on-1 Dedication</h4>
                <p style={{ fontsize: 14 }}>
                  Experience personalized learning and growth with live
                  interactive sessions led by industry experts
                </p>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon2.png" alt="" />
                <h4> Practical Experience through Real-Time Projects</h4>
                <p style={{ fontsize: 14 }}>
                  Gain invaluable real-world experience by working on live
                  projects. Switch your domain to Data Science &amp; AI with
                  real time projects.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon3.png" alt="" />
                <h4>Life Time Access </h4>
                <p style={{ fontsize: 14 }}>
                  Life Time accessibility of the Content. Get Access of all
                  Recording of All Classes for Download in Slack Channel.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="whymakes-box">
                <img src="assets/images/studyassigment.png" alt="" />
                <h4>60+ Case Studies &amp; Assignments</h4>
                <p style={{ fontsize: 14 }}>
                  Work on 60+ Case studies ad assignments on Data Science
                </p>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="whymakes-box">
                <img src="assets/images/industries.png" alt="" />
                <h4>18+ Industry Relevant Projects</h4>
                <p style={{ fontsize: 14 }}>
                  Work on 18+ Projects and have practical experience on Data Science
                </p>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon3.png" alt="" />
                <h4>Tied-up with 150+ Companies</h4>
                <p style={{ fontsize: 14 }}>
                  More than 150+ companies tied up for placements as Data scientist and ML Engineer
                </p>
              </div>
            </div>
          </div>
          */}
        </div>
      </section>
      <section className="btn-center-section" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>
     
      <section  ref={curriculumSection} id="faq" className="faqnewbg py-0">
        <div className="container clearfix">
          <h2 style={{ fontSize: 30 }}>
            About Logicmojo's <b style={{ fontSize: 30, color:"#9769ef" }}>Data Science Course</b> in Bangalore
          </h2>
          <div className="faqnewbg-inner">
            <div className="faqnew">
              <div className="accordion" id="accordionExample2">

                    <div className="card">
                      <div className="card-header" id="heading000">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse000"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Data Science Course in Bangalore - What is it like?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse000"
                        className="collapse"
                        aria-labelledby="heading000"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>The Logicmojo Data Science course in Bangalore is a comprehensive training
program designed with an industry-based curriculum to help you gain expertise in
<a target="_default" href="https://logicmojo.com/data-science-introduction"> Data Science</a>, <a target="_default" href="https://logicmojo.com/machine-learning-interview-questions">Machine Learning</a>, <a target="_default" href="https://logicmojo.com/what-is-deep-learning">Deep learning</a>, and <a target="_default" href="https://logicmojo.com/applications-of-artificial-intelligence">Artificial Intelligence</a> with theoretical and
practical knowledge. This data science training program will cover different data
science technologies like ML algorithms, <a target="_default" href="https://logicmojo.com/artifical-neural-network">neural networks</a>, <a href="https://logicmojo.com/generative-ai-course/">generative AI</a>, and 10+
data science projects based on them. As one of the top data science institutes in
Bangalore, we provide expert-led instruction and support placement assistance to
help you secure a job in the IT industry:</p>
<p>Bangalore is renowned as Silicon Valley for its reputation in the IT domain. Bangalore
with high-tech industries and dynamic start-ups has contributed significantly to the
rise in data science job opportunities. The tech ecosystem of Bangalore offers
opportunities for professionals in the data science field to explore and advance. A
survey from Nasscom for Bangalore reported that there has been a 45% rise in the
data science job role within the last year.</p>
<p>This certified data science course help you evaluate your career with our dedicated
career service in Bangalore. Through this Data Science Course, you will master the
following concepts:</p>
                          
                          <br />
                        <div>
                          <li style={{ fontsize: 14 }}>Data Science Foundation</li><br/>
                        <li>Fundamentals of math and probability</li><br/>
                        <li>Machine Learning algorithms</li><br/>
                        <li>Techniques of evaluation, experimentation, and project deployment</li><br/>
                        <li>Python with Data Science
                        </li><br/>
                        <li >Generative AI</li><br/>
                        <li >Deep Learning Algorithm and Natural Networks</li><br/>
                        <li >Deploying Machine Learning models on Clouds (MLOps).</li><br/>
                        <li>Data visualization with Tableau
                        </li><br/>
                        <li>Natural Language Processing and its Applications</li><br/>
                       <li>Data analysis and Data transformation
                       </li><br/>
                        <li>Data Science projects, analytics, and recommender systems</li><br/>
                        </div>

                        </div>
                      </div>
                    </div>

                    

                    <div className="card">
                      <div className="card-header" id="heading020">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse020"
                            aria-expanded="false"
                          >
                             <i className="fa fa-angle-down"></i> Ideal Data science course in Bangalore: Structural Analysis
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse020"
                        className="collapse"
                        aria-labelledby="heading020"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                        <p style={{ fontsize: 14 }}> Our data science course with placement in Bangalore provides an interactive
learning experience, designed with some premium features. with personalized
mentorship, flexible learning options, and industry-relevant experience we ensure
that you get the maximum from our Data science training in Bangalore, including:
                        </p><br/>
                         
                          <div>
                            <li>
                            <b>Industry-relevant Curriculum</b>: The data science curriculum is structured
according to the patterns and demands of the data science sector in
Bangalore, providing you with the necessary knowledge to stand out in high-
tech industries.
                            </li><br/>
                            <li>
                            <b>Personalized mentorship</b>:Get a personalized mentor to track your progress,
guide you throughout the project inception and deployment, and help you
with job placement.
                            </li><br/>
                           
                            <li>
                            <b>Live Interactive Sessions</b>: Get live interactive classes with experts having over
                            6 years of industry experience.
                            </li><br/>
                            <li>
                            <b>Hands-on project with real-world applications</b>: Get practical experience by
                            working on 10+ real-world projects under mentor guidance.
                            </li><br/>
                            <li>
                            <b>One-to-one doubt-clearing sessions</b>: Get 1:1 doubt-clearing and Q&amp;A
                            sessions with our mentors to clarify your doubts.
                            </li><br/>
                            <li>
                            <b>Job Assistance Program</b>: Our data science course will help you with resume
                            preparation and mock interviews to get placement in top companies.
                            </li><br/>
                            
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is Logicmojo Data Science course in Bangalore also for beginners?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                       
                          <div>
                            <li>
                            Whether you are a beginner or professional, Logicmojo offers data science
certification in Bangalore to help inspiring data scientists establish their careers in
this emerging field.
                            </li><br/>
                            <li>
                            This course curriculum covers the essential tools and principles required to begin a
career in data science, the course starts with basics like <a href="">Python language</a> and
gradually moves to advanced topics like generative AI and deep learning.
                            </li><br/>
                            <li>
                            This course is carefully structured to help you with the fundamentals of data
science, including Python programming, data visualization, and basic machine
learning techniques. There are live interactive sessions guided by working
professionals and all sessions are covered practically with real-time industrial
projects and case studies.
                           </li><br/>
                           <li>
                           Logicmojo Data Science Course fee in Bangalore location is INR 54,000.
                           </li><br/>
                           
                          </div>
                         
                           
                          
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading030">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse030"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How is Logicmojo the best data science institute in Bangalore for placement?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse030"
                        className="collapse"
                        aria-labelledby="heading030"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          One of the best features of our foundation course is the placement assistance.
Logicmojo is committed to helping you start your career in <a target="_default" href="https://logicmojo.com/data-science-introduction">data science</a>.There are
mentors to guide you to build a resume, prepare for an interview, and land a job that
aligns with your skills and career goals.
                          </p>
                          <p style={{ fontsize: 14 }}>
                          <b>Highlights of the Data Science Foundation program in Bangalore:</b>
                         </p>

                          <div>
                            <li>
                            Online interactive classes by industry experts
                            </li><br/>
                            <li>
                            Consist of 110+ hours of live sessions
                           </li><br/>
                           
                            <li>
                            10+ real-time industry-based projects
                            </li><br/>
                           
                            <li>
                            One-to-one doubt-clearing sessions
                           </li><br/>
                            <li>
                            Lifetime accessibility to recorded live session videos
                           </li><br/>
                           <li>
                           Job assistance program after course completion
                           </li><br/>
                            
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading030">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse030"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>  Logicmojo is the best data science institute in Bangalore with job placement
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse030"
                        className="collapse"
                        aria-labelledby="heading030"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          One of the best features of our foundation course is the placement assistance.
Logicmojo is committed to helping you start your career in <a target="_default" href="https://logicmojo.com/data-science-introduction">data science</a>.There are
mentors to guide you to build a resume, prepare for an interview, and land a job that
aligns with your skills and career goals.
                          </p>
                          <p style={{ fontsize: 14 }}>
                          <b>Highlights of the Data Science Foundation program in Bangalore:</b>
                         </p>

                          <div>
                            <li>
                            Online interactive classes by industry experts
                            </li><br/>
                            <li>
                            Consist of 110+ hours of live sessions
                           </li><br/>
                           
                            <li>
                            10+ real-time industry-based projects
                            </li><br/>
                           
                            <li>
                            One-to-one doubt-clearing sessions
                           </li><br/>
                            <li>
                            Lifetime accessibility to recorded live session videos
                           </li><br/>
                           <li>
                           Job assistance program after course completion
                           </li><br/>
                            
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading0987">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse03985"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>  Data Science Trends in Bangalore ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse03985"
                        className="collapse"
                        aria-labelledby="heading0987"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          Bangalore City is touted as the Silicon Valley of India, it is the leading hub for many IT
giants, start-ups, and educational institutes. Bangalore is one of the top cities in India
for offering tech jobs with the highest demand for data scientists. As businesses rely
on data-driven decisions, professionals need to stay updated with the data science
trends in Bangalore:
                          </p>
                         

                          <div>
                            <li>
                            <b>Rise of AI and Machine Learning</b>: AI and ML are the core principles of Data science.
Businesses are investing in automating data processes and this increases the
demand for AI and ML professionals in Bangalore.
                            </li><br/>

                            <li>
                            <b>Industry-specific Applications</b>: Many industries in Bangalore like healthcare, finance,
and retail are advancing in specialized data science applications providing
opportunities for professionals to drive innovation and efficiency in various domains.
                           </li><br/>
                           
                            <li>
                            <b>Implementation of Big Data technologies</b>: Industries in Bangalore are turning to big
data technologies due to the data explosion. Tools like Hadoop and Spark are used to
handle and analyze this extensive data, which increases the demand for big data
engineers.
                            </li><br/>
                           
                            <li>
                            <b>Data privacy and security</b>: With data expansion, organizations are prioritizing data
security and privacy in their operations which increases the demand for
professionals with data science and cyber security knowledge.
                           </li><br/>
                           
                            
                          </div>
                        </div>
                      </div>
                    </div>
                   

                    <div className="card">
                      <div className="card-header" id="heading0987">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse038765"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>  Best Data Science Training Institute in Bangalore?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse038765"
                        className="collapse"
                        aria-labelledby="heading07657"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          In a city like Bangalore with its diverse IT culture, finding the right data science
training institute is important to build a successful career in the data science domain.
Logicmojo provides one of the best data science training institutes in Bangalore
which not only provides comprehensive training programs but also offers interview
and job placement support. This course boasts an impressive success rate, with a
large percentage of graduates securing positions in their preferred companies and
domains:
                          </p>
                         

                          <div>
                            <li>
                            As a top data science institute in Bangalore Logicmojo boasts a team of
experts with years of industry experience.
                            </li><br/>

                            <li>
                            Industry-aligned curriculum designed to ensure that students acquire
knowledge and fulfill the requirements of top tech companies.
                           </li><br/>
                           
                            <li>
                            Emphasizes qualitative learning with real-world projects and case studies at
                            affordable prices.
                            </li><br/>
                           
                            <li>
                            A comprehensive data science course with placement in Bangalore, offering
personalized support, resume building, and interview preparation to help
students secure roles in leading companies.
                           </li><br/>
                           <li>
                           Logicmojo has established partnerships with numerous reputed companies in
Bangalore, increasing the likelihood of successful placements for their
graduates.
                           </li><br/>
                           <li>
                           Enroll today for this data science course and start your journey to become a
                           successful data scientist with Logicmojo.
                           </li><br/>
                            
                          </div>
                        </div>
                      </div>
                    </div>



                    <div className="card">
                      <div className="card-header" id="heading0987">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse03888"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>  Why Choose Logicmojo Data Science Course in Bangalore?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse03888"
                        className="collapse"
                        aria-labelledby="heading07876"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          Logicmojo provides top-notch online Data Science courses in Bangalore for
professionals seeking to broaden their knowledge and establish a career in this field.
With qualitative live classes with industry experts and hands-on experience on
practical projects, Logicmojo upgrades your skills and knowledge to excel in data
science.
                          </p>
                          <p>
                          According to a recent report by IBM, the demand for data scientists in India will
surge by 28% by 2024. As many businesses rely on large datasets, the demand for
data scientists is increasing. With the right skills and training, you can build a secure
career in the field of data science. Many leading global companies and prominent IT
companies in India are actively hiring data science professionals, source Glassdoor.
Recent LinkedIn reports indicate that there are over 29,000 data science job
openings in Bangalore.
                          </p>
                          <p>
                          If you are looking to delve into the data science job market in Bangalore, the
Logicmojo Institute provides you with the best data science online training program
with the benefits of mock interviews, networking, and job placement. There are
numerous compelling reasons to select Logicmojo as your preferred training
provider:
                          </p>
                         

                          <div>
                            <li>
                            Inclusive and affordable training
                            </li><br/>

                            <li>
                            Real-time learning with industry experts with years of experience
                           </li><br/>
                           
                            <li>
                            Industry-aligned real-world projects
                            </li><br/>
                           
                            <li>
                            Flexible learning options
                           </li><br/>
                           <li>
                           Career Advancement
                           </li><br/>
                           <li>
                           Real-time exercises, assignments, and projects
                           </li><br/>
                           <li>
                           A large community of like-minded learners
                           </li><br/>
                           <li>
                           Job assistance program
                          </li><br/>
                            
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading09764">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse038888"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>  What are the learning objectives of this Data Science course in Bangalore?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse038888"
                        className="collapse"
                        aria-labelledby="heading09764"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          Data science is one of the most popular professions in the IT industry. To make a
prominent career in data science it is essential to master the necessary skills and
knowledge to stand out in tech companies. Whether you are a beginner or a
professional with a passion for building your career in data science, the Logicmojo
data science course in Bangalore provides you with the best training program with
an inclusive curriculum to understand the core concept of data science from beginning to advanced. The key learning objectives you will achieve with this course
are:
                          </p>
                          <div>
                            <li>
                            <b>Understand Core data science concepts</b>: Build a strong foundation with this
comprehensive data science course, and equip data science principles including data
analysis, visualization, and modeling. Learn to use various tools and techniques like
Python, R, and SQL to work with structured and unstructured data.
                            </li><br/>

                            <li>
                            <b>Proficiency in a programming language</b>: Learn Python which is widely used in data
science due to its readability, extensive library, and large community support, and R
for statistical computing and graphics.
                           </li><br/>
                           
                            <li>
                            <b>Machine learning and its librarie</b>s: Get hands-on experience with machine
learning algorithms, along with supervised and unsupervised learning, deep learning,
and neural networks. Use different machine learning libraries including Scikit-learn,
TensorFlow, Kera, and Caret to develop, evaluate, and deploy machine learning
models.
                            </li><br/>
                           
                            <li>
                            <b>Big Data and Cloud Computing</b>: Get familiar with big data technologies including
Apache Hadoop and Apache Spark for fast processing and storing large datasets
across clusters of computers. Learn to use AWS and Azure for scalable data
processing and storage over the cloud.
                           </li><br/>
                           <li>
                           <b>Data Wrangling and Pre-processing</b>: Acquire skills to use Python and R libraries to
clean, organize, and transform raw data into a usable format for performing analysis.
Learn to use different data science tools to handle large datasets and perform
predictive analysis.
                           </li><br/>
                           <li>
                           <b>Data Visualization</b>: Create visually appealing and informative statistical graphs for
                           data visualization with libraries like Matplotlib and Seaborn
                           </li><br/>
                           <p>The data science training in Bangalore curated by Logicmojo focuses on providing the top
data science skills with live online instructor-led classes or self-paced learning videos. This
training covers the capstone projects which allow you to apply theories and concepts.
Preparing you with the essential skills and knowledge to become proficient in the data
science field and providing job placement support. Logicmojo data science course in
Bangalore represents an optimal choice for you to master data science.</p>
                            
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading099999">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse0388565"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>  What important skills will you acquire with this Data Science course in Bangalore?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse0388565"
                        className="collapse"
                        aria-labelledby="heading099999"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          Enrolling in these online data science training programs in Bangalore will equip you
with the most demanding skills in the job market. This data science online program is
designed to gain expertise in the core concepts of data science such as:
                          </p>
                          <div>
                            <li>
                            Gain proficiency and hands-on experience in Python programming and its
libraries such as Pandas, NumPy, and Matplotlib for data manipulation and
data visualization.
                            </li><br/>

                            <li>
                            Master machine learning to build and deploy machine learning models, and
learn different ML algorithms such as regression, classification, clustering,
and deep learning.
                           </li><br/>
                           
                            <li>
                            Learn data visualization techniques to present data effectively with tools like
<a href="https://logicmojo.com/tableau-interview-questions">Tableau</a> and <a href="https://logicmojo.com/power-bi-interview-questions">Power BI</a>.
                            </li><br/>
                           
                            <li>
                            Gain expertise in <a href="https://logicmojo.com/big-data-analytics">big data technologies</a> and hands-on experience in tools like
Hadoop and Spark.
                           </li><br/>
                           <li>
                           Learn to implement deep learning algorithms and understand in-depth <a href="https://logicmojo.com/artifical-neural-network">neural
network architecture</a>.
                           </li><br/>
                           <li>
                           Learn object-oriented programming, functional programming, data
structures, Gaussian distribution, and fundamentals of math and probability.
                           </li><br/>
                           <li>
                           Learn to clean, manipulate, and apply key statistical techniques to analyze
                           and interpret data.
                           </li><br/>
                           <li>
                           Practice with more than 20 essential tools and various industry projects.
                           </li><br/>
                           <li>
                           Gain expertise to tackle real-world data science challenges and make data-
                           driven decisions.
                           </li><br/>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading0987654">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse0387575"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>  What projects are included in this Data Science course in Bangalore?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse0387575"
                        className="collapse"
                        aria-labelledby="heading0987654"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          This data science training at Bangalore is designed to provide you with hands-on
experience with 10+ practical and industry-relevant <a href="https://logicmojo.com/data-science-projects">projects</a> within the different
domains. These projects are curated carefully to help you apply practical skills to the
real-world scenario. Here are some of the projects you will work on:
                          </p>
                          <p>
                          Capstone Project: Get mentor guidance to generate industry projects. The capstone
project will help you apply theories and concepts and test your decision-making skills
in various areas like exploratory data analysis, NLP, machine learning, and deep
learning. After completing the project earn a project certificate to showcase your
skills and experience to potential employers.
                          </p>
                          <div>
                            <li>
                            Gain proficiency and hands-on experience in Python programming and its
libraries such as Pandas, NumPy, and Matplotlib for data manipulation and
data visualization.
                            </li><br/>

                            <li>
                            Master machine learning to build and deploy machine learning models, and
learn different ML algorithms such as regression, classification, clustering,
and deep learning.
                           </li><br/>
                           
                            <li>
                            Learn data visualization techniques to present data effectively with tools like
<a href="https://logicmojo.com/tableau-interview-questions">Tableau</a> and <a href="https://logicmojo.com/power-bi-interview-questions">Power BI</a>.
                            </li><br/>
                           
                            <li>
                            Gain expertise in <a href="https://logicmojo.com/big-data-analytics">big data technologies</a> and hands-on experience in tools like
Hadoop and Spark.
                           </li><br/>
                           <li>
                           Learn to implement deep learning algorithms and understand in-depth <a href="https://logicmojo.com/artifical-neural-network">neural
network architecture</a>.
                           </li><br/>
                           <li>
                           Learn object-oriented programming, functional programming, data
structures, Gaussian distribution, and fundamentals of math and probability.
                           </li><br/>
                           <li>
                           Learn to clean, manipulate, and apply key statistical techniques to analyze
                           and interpret data.
                           </li><br/>
                           <li>
                           Practice with more than 20 essential tools and various industry projects.
                           </li><br/>
                           <li>
                           Gain expertise to tackle real-world data science challenges and make data-
                           driven decisions.
                           </li><br/>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>

             
            </div>
         
      </section>
      <section  className="careerservices-new" id="placement" ref={syllabusInDetail}>
      <div className="container clearfix">
        <CareerServicesAI />
        </div>
      </section>
      
{/*}
      <section id="curriculum" className="syllabusnewbg" ref={syllabusInDetail}>
        <div className="container ">
          <div className="row">
            <div className="col-lg-7">
              <div className="syllabusheadings">
                <h2 style={{ fontSize: 30 }}>
                  <span>Course Syllabus<b style={{ fontSize: 30, color:"#9769ef" }}> of Data Science</b> Training Program in Bangalore </span>
                </h2>

                <a
                  target="_default"
                  href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view"
                  className="brochbtn"
                >
                  <i className="fa fa-download mr-2" aria-hidden="true"></i>{" "}
                  Download brochure
                </a>

                <p style={{ fontsize: 14 }}>
                  Logicmojo provides Live, Interactive Sessions in Bangalore guided by
                  Professionals working in top MNCs. All sessions are covered
                  practically with real-time industrial projects and case
                  studies.
                </p>
              </div>

              <div className="faqnew">
                <div className="accordion curriculum-accordion" id="accordionExample">
                  <div className="card">
                    <div className="card-header" id="heading00">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse00"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 1 Basic to
                          Advanced Python
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse00"
                      className="collapse"
                      aria-labelledby="heading00"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>Chapter 1: Python deep-dive ( 3 hrs )</h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Working With Numbers, Booleans and Strings</li>
                            <li style={{ fontsize: 14 }}>
                              String types and formatting, String operations
                            </li>
                            <li style={{ fontsize: 14 }}>
                              List, Tuples, Dictionaries Python Lists, Tuples,
                              Dictionaries
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Basic Operations Indexing, Slicing, and Matrixes
                            </li>
                            <li style={{ fontsize: 14 }}>Built-in Functions & Methods</li>
                            <li style={{ fontsize: 14 }}>Exercises on List,Tuples And Dictionary</li>
                            <li style={{ fontsize: 14 }}>Functions & Modules</li>
                            <li style={{ fontsize: 14 }}>Exceptional Handling and Regular Expression</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Library of Python used for ML/AI
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Numpy, Pandas, Matplotlib, Seaborn, Scipy</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 3: Data Analysis Using Numpy
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Introduction to Numpy</li>
                            <li style={{ fontsize: 14 }}>
                              Array Creation, Printing Arrays. Basic Operation
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Indexing, Slicing and Iterating, Shape
                              Manipulation
                            </li>
                            <li style={{ fontsize: 14 }}>Vector stacking, Broadcasting with Numpy</li>
                            <li style={{ fontsize: 14 }}>Numpy for Statistical Operation</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 3: Data Analysis Using Pandas
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Introduction to Pandas</li>
                            <li style={{ fontsize: 14 }}>Pandas Data Frames, Indexing Data Frames</li>
                            <li style={{ fontsize: 14 }}>Basic Operations With Data frame</li>
                            <li style={{ fontsize: 14 }}>Sub setting and filtering a data frame</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 4: Data Visualization using Matplotlib
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>How to use & configure Matplotlib</li>
                            <li style={{ fontsize: 14 }}>plot(), Controlling Line Properties</li>
                            <li style={{ fontsize: 14 }}>
                              Subplot with Functional Method, Multiple Plot
                            </li>
                            <li style={{ fontsize: 14 }}>Working with Multiple Figures</li>
                            <li style={{ fontsize: 14 }}>Histograms</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 4: Data Visualization using Seaborn
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Intro to Seaborn, Visualizing statistical
                              relationships
                            </li>
                            <li style={{ fontsize: 14 }}>Plotting with categorical data</li>
                            <li style={{ fontsize: 14 }}>Visualizing linear relationships</li>
                            <li style={{ fontsize: 14 }}>Seaborn Exercise</li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>1. Resume Screening project with Python Library</p>
                          <p style={{ fontsize: 14 }}>
                            2. Climate Change impacts on the Global Food Supply
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading001">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse001"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 2 -
                          Applied Statistics in Machine Learning
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse001"
                      className="collapse"
                      aria-labelledby="heading001"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>
                            Chapter 1: Fundamentals of Math and Probability ( 3
                            hrs )
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Variables, Random Variables</li>
                            <li style={{ fontsize: 14 }}>
                              Population, Sample, Mean, Population Distribution
                            </li>
                            <li style={{ fontsize: 14 }}>Sample Distribution, Mean, Median, Mode</li>
                            <li style={{ fontsize: 14 }}>Range, Measure of Dispersion, Variance</li>
                            <li style={{ fontsize: 14 }}>Probability Density function</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Statistics, Statistical Thinking
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Standard Normal Distribution, Z Score </li>
                            <li style={{ fontsize: 14 }}>Standard Deviation, Gaussian Distribution</li>
                            <li style={{ fontsize: 14 }}>Cumulative Distribution function</li>
                            <li style={{ fontsize: 14 }}>Hypothesis Testing & Plotting graph</li>
                            <li style={{ fontsize: 14 }}>Central limit theorem, Covariance</li>
                            <li style={{ fontsize: 14 }}>Pearson Correlation Coefficient</li>
                            <li style={{ fontsize: 14 }}>
                              Spearman Rank Coefficient, Hypothesis Testing
                            </li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 3: Advanced Statistics
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Q-Q plot,Skewness of Data </li>
                            <li style={{ fontsize: 14 }}>Discrete & continuous distribution</li>
                            <li style={{ fontsize: 14 }}>Bernoulli & binomial distribution</li>
                            <li style={{ fontsize: 14 }}>Log normal distribution </li>
                            <li style={{ fontsize: 14 }}>Pox cox transformation</li>
                            <li style={{ fontsize: 14 }}>Poisson distribution</li>
                            <li style={{ fontsize: 14 }}>Application of Non Gaussian distribution</li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>
                            1. Statical Analysis of Health Insurance Pricing
                            Forecast
                          </p>
                          <p style={{ fontsize: 14 }}>
                            2. Climate Change Impacts on the Global Food Supply
                          </p>
                          <p style={{ fontsize: 14 }}>
                            3. Statistical analysis of road accident in India
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading002">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse002"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 3 -
                          Machine Learning
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse002"
                      className="collapse"
                      aria-labelledby="heading002"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>
                            Chapter 1: Machine Learning Introduction ( 3 hrs )
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Machine learning elements </li>
                            <li style={{ fontsize: 14 }}>
                              Algorithm, Model, Predictor Variable, Response
                              Variable
                            </li>
                          </ul>

                          <h4>
                            Chapter 2: Regression Supervised Learning( 3 hrs )
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Linear Regression</li>
                            <li style={{ fontsize: 14 }}>Support vector machine(SVC)</li>
                            <li style={{ fontsize: 14 }}>Ridge Regression</li>
                            <li style={{ fontsize: 14 }}>Logistics Regression</li>
                            <li style={{ fontsize: 14 }}>Lasso Regression</li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>
                            1. Stock Price Prediction using Linear regression
                          </p>
                          <p style={{ fontsize: 14 }}>2. Spam mail detector for mailbox</p>
                          <p style={{ fontsize: 14 }}>
                            3. Predict car price using py-torch & SVC egression
                          </p>
                          <p style={{ fontsize: 14 }}>
                            4. Use logistics regression models to predict wine
                            quality
                          </p>
                          <p style={{ fontsize: 14 }}>
                            5. Use logistics regression to predict if loan
                            approved or not
                          </p>

                          <h4 className="mt-3">
                            Chapter 3: Supervised Learning - Classification
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Understanding Decision Trees and Naive Bayes
                            </li>
                            <li style={{ fontsize: 14 }}>Linear classifiers</li>
                            <li style={{ fontsize: 14 }}>Decision boundaries</li>
                            <li style={{ fontsize: 14 }}>K-Nearest Neighbours</li>
                            <li style={{ fontsize: 14 }}>Random forest</li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>
                            1. Credit Card Fraud Detection using Classification
                            algorithms
                          </p>
                          <p style={{ fontsize: 14 }}>
                            2. Build model and evaluate water quality using
                            random forest
                          </p>
                          <p style={{ fontsize: 14 }}>
                            3. Purchase prediction of customer using random
                            forest
                          </p>
                          <p style={{ fontsize: 14 }}>
                            4. Confusion Matrix of Multi Class Classification
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading003">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse003"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 3 -
                          Advance Machine Learning
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse003"
                      className="collapse"
                      aria-labelledby="heading003"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>
                            Chapter 1: Unsupervised Learning Clustering ( 3 hrs
                            )
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>K-Means Clustering</li>
                            <li style={{ fontsize: 14 }}>Hierarchical Clustering</li>
                            <li style={{ fontsize: 14 }}>Mean-shift algorithm</li>
                            <li style={{ fontsize: 14 }}>Principal Component Analysis</li>
                            <li style={{ fontsize: 14 }}>Independent Component Analysis</li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>
                            1. Music recommendation in Spotify using k-means
                            clustering
                          </p>
                          <p style={{ fontsize: 14 }}>
                            2. Topic Modelling for Twitter Customer Reviews
                            clustering
                          </p>
                          <p style={{ fontsize: 14 }}>
                            3. K-Means Clustering model to determine banknote is
                            authentic
                          </p>
                          <p style={{ fontsize: 14 }}>
                            3. Dimension reduction using PCA with clustering
                            Model
                          </p>
                          <p style={{ fontsize: 14 }}>
                            3. e-Commerce Products Dataset For Record Linkage
                          </p>

                          <h4 className="mt-3">
                            Chapter 2: Unsupervised Learning Association
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Introduction to unsupervised learning</li>
                            <li style={{ fontsize: 14 }}>
                              Clustering: Distance metrics, K-means,
                              hierarchical clustering
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Types of Analysis - Descriptive, Predictive, and
                              Prescriptive
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Bias Variance Tradeoff - Overfitting vs
                              Underfitting
                            </li>
                            <li style={{ fontsize: 14 }}>Clustering validation & Generative models</li>
                            <li style={{ fontsize: 14 }}>
                              Dimensionality Reduction: Principal Component
                              Analysis (PCA)
                            </li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>
                            1. Anomaly detection(fraud detection) with
                            clustering
                          </p>
                          <p style={{ fontsize: 14 }}>
                            2. Likeness of Item B being purchased after item A
                            prediction
                          </p>
                          <p style={{ fontsize: 14 }}>3. Fraud Detection in Financial Transactions</p>
                          <p style={{ fontsize: 14 }}>
                            4. Document Clustering in Natural Language
                            Processing
                          </p>

                          <h4 className="mt-3">
                            Chapter 3: Recommendation System
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Recommender systems overview</li>
                            <li style={{ fontsize: 14 }}>Collaborative filtering</li>
                            <li style={{ fontsize: 14 }}>
                              Understanding Collaborative Filtering and Support
                              Vector Machine
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Normalizing co-occurrence matrices and leveraging
                              purchase histories
                            </li>
                            <li style={{ fontsize: 14 }}>The matrix completion task</li>
                            <li style={{ fontsize: 14 }}>Recommender systems ML block diagram</li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>
                            1. Online Movie recommendation system to predict
                            preference
                          </p>
                          <p style={{ fontsize: 14 }}>2. Online Books recommendation System</p>
                          <p style={{ fontsize: 14 }}>
                            3. e-commerce product recommendation like Amazon
                          </p>

                          <h4 className="mt-3">
                            Chapter 4: Reinforced Learning
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Introduction To RL</li>
                            <li style={{ fontsize: 14 }}>RL Techniques and Methods</li>
                            <li style={{ fontsize: 14 }}>
                              Value-Based Methods(Q-Learning,SARSA,Deep
                              Q-Networks)
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Policy-Based Methods(Policy Gradient, REINFORCE,
                              Actor-Critic Methods)
                            </li>
                            <li style={{ fontsize: 14 }}>Exploration and Exploitation</li>
                          </ul>
                          <h5>Ensemble Techniques:</h5>
                          <p style={{ fontsize: 14 }}>Boosting | Gradient</p>
                          <p style={{ fontsize: 14 }}>Boosting | XGBoost</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading004">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse004"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 4 - Deep
                          Learning
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse004"
                      className="collapse"
                      aria-labelledby="heading004"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>Chapter 1: Deep Learning Overview ( 3 hrs )</h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>What is Deep Learning?</li>
                            <li style={{ fontsize: 14 }}>Machine Learning Vs Deep Learning</li>
                            <li style={{ fontsize: 14 }}>Tensorflow I Keras I Pytorch In details</li>
                            <li style={{ fontsize: 14 }}>Overview Caffe and Theano</li>
                            <li style={{ fontsize: 14 }}>Types of file formats in TensorFlow</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: TensorFlow Classification Examples
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Introduction to TensorFlow</li>
                            <li style={{ fontsize: 14 }}>Installing TensorFlow</li>
                            <li style={{ fontsize: 14 }}>Simple Computation, Contents and Variables</li>
                            <li style={{ fontsize: 14 }}>Types of file formats in TensorFlow</li>
                            <li style={{ fontsize: 14 }}>TensorFlow Classification Examples</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Deep Learning Algorithms
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Artificial Neural Networks(ANN)</li>
                            <li style={{ fontsize: 14 }}>Recurrent Neural Networks(RNN)</li>
                            <li style={{ fontsize: 14 }}>Convolutional Neural Networks(CNN)</li>
                            <li style={{ fontsize: 14 }}>Autoencoders and Boltzmann Machine</li>
                            <li style={{ fontsize: 14 }}>Generative Adversarial Networks (GANs)</li>
                            <li style={{ fontsize: 14 }}>Restricted Boltzmann Machines (RBMs)</li>
                          </ul>

                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>1. Speech Recognition with Deep Learning</p>
                          <p style={{ fontsize: 14 }}>
                            2. Build models with high accuracy Identify Human
                            Face
                          </p>
                          <p style={{ fontsize: 14 }}>3. Music Genre Classification using DL</p>
                          <p style={{ fontsize: 14 }}>4. Image Classification with CIFAR Dataset</p>
                          <p style={{ fontsize: 14 }}>5. ChatBot Learning Human-to-Human Dialogue</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading005">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse005"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 5 -
                          Natural Language Processing
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse005"
                      className="collapse"
                      aria-labelledby="heading005"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>Chapter 1: Introduction to NLP ( 3 hrs )</h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Introduction to NLP</li>
                            <li style={{ fontsize: 14 }}>Stop Words, Tokenization</li>
                            <li style={{ fontsize: 14 }}>Text Analytics Vs NLP</li>
                            <li style={{ fontsize: 14 }}>Bag of Words Model, Word Vectorizer</li>
                            <li style={{ fontsize: 14 }}>Types of file formats in TensorFlow</li>
                            <li style={{ fontsize: 14 }}>Introduction to Sequential data</li>
                          </ul>

                          <h4 className="mt-3">Chapter 2: NLP Advanced </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>RNNs and its Mechanisms</li>
                            <li style={{ fontsize: 14 }}>Vanishing & Exploding gradients in RNNs</li>
                            <li style={{ fontsize: 14 }}>NLP libraries: NLTK Text blog</li>
                            <li style={{ fontsize: 14 }}>LSTMs - Long short-term memory</li>
                            <li style={{ fontsize: 14 }}>Neural Machine Translation</li>
                            <li style={{ fontsize: 14 }}>
                              Advanced Language Models: Transformers, BERT,
                              XLNet
                            </li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>
                            1. Text summarization using Natural language
                            processing
                          </p>
                          <p style={{ fontsize: 14 }}>
                            2. Deeper dive project of Automatic Speech
                            Recognition
                          </p>
                          <p style={{ fontsize: 14 }}>
                            3. Newspaper Data Cleaning & Pre-processing using
                            NLP
                          </p>
                          <p style={{ fontsize: 14 }}>
                            4. Text Classification using scikit-learn and NLP
                          </p>
                          <p style={{ fontsize: 14 }}>5. Hate Speech Detection Model</p>
                          <p style={{ fontsize: 14 }}>6. Next Word Prediction Model</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading006">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse006"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 6- Tableau
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse006"
                      className="collapse"
                      aria-labelledby="heading006"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>Chapter 1: Introduction to Tableau ( 3 hrs )</h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Installing Tableau and connecting to data sources
                            </li>
                            <li style={{ fontsize: 14 }}>Creating dashboard pages</li>
                            <li style={{ fontsize: 14 }}>How to create calculated columns</li>
                            <li style={{ fontsize: 14 }}>Data cleaning and reshaping</li>
                            <li style={{ fontsize: 14 }}>Creating a basic visualization</li>
                          </ul>

                          <h4 className="mt-3">Chapter 2: Charts and Graphs</h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Basic charts and Graph Types</li>
                            <li style={{ fontsize: 14 }}>Customizing Charts and Formatting</li>
                            <li style={{ fontsize: 14 }}>Interactive Features and actions</li>
                            <li style={{ fontsize: 14 }}>
                              Advanced chart types (e.g., maps, treemaps,
                              scatter plots)
                            </li>
                          </ul>

                          <h4 className="mt-3">Chapter 3: Tableau (Advance)</h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Mapping</li>
                            <li style={{ fontsize: 14 }}>Coordinate points</li>
                            <li style={{ fontsize: 14 }}>Plotting Latitude and Longitude</li>
                            <li style={{ fontsize: 14 }}>Custom Geocoding</li>
                            <li style={{ fontsize: 14 }}>Polygon Maps</li>
                            <li style={{ fontsize: 14 }}>WMS and Background Image</li>
                          </ul>

                          <h5>Case Study:</h5>
                          <p style={{ fontsize: 14 }}>1. Connecting data source and data cleansing</p>
                          <p style={{ fontsize: 14 }}>2. Working with various Charts</p>
                          <p style={{ fontsize: 14 }}>
                            3. Deployment of Predictive model in visualization
                          </p>

                          <h4 className="mt-3">
                            Chapter 4: Dashboard and Stories
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Working in Views with Dashboards and Stories
                            </li>
                            <li style={{ fontsize: 14 }}>Working with Sheets Fitting Sheets</li>
                            <li style={{ fontsize: 14 }}>Legends and Quick Filters</li>
                            <li style={{ fontsize: 14 }}>Tiled and Floating Layouts</li>
                            <li style={{ fontsize: 14 }}>Floating Objects</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 5: Advanced Chart Types and Analytics
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Creating Advanced Chart types (treemaps, heatmaps)
                            </li>
                            <li style={{ fontsize: 14 }}>Working with Sheets Fitting Sheets</li>
                            <li style={{ fontsize: 14 }}>
                              Using statistical functions and analytics(trend
                              lines, forecasting)
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Creating sets, groups, and bins for data analysis
                            </li>
                          </ul>
                          <h5>Projects:</h5>
                          <p style={{ fontsize: 14 }}>1. Patient Risk Healthcare Dashboard</p>
                          <p style={{ fontsize: 14 }}>2. Sales Forecast Analysis Dashboard</p>
                          <p style={{ fontsize: 14 }}>3. Product Availability Dashboard</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading007">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse007"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 7- Power
                          BI
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse007"
                      className="collapse"
                      aria-labelledby="heading007"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>
                            Chapter 1: Getting Started With Power BI ( 3 hrs )
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Installing Power BI Desktop</li>
                            <li style={{ fontsize: 14 }}>
                              Overview of the Workflow in Power BI Desktop
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Introducing the Different Views of the Data Mode
                            </li>
                            <li style={{ fontsize: 14 }}>Query Editor Interface</li>
                            <li style={{ fontsize: 14 }}>Working on Data Model</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Programming with Power BI
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Working with Time Series</li>
                            <li style={{ fontsize: 14 }}>Understanding aggregation and granularity</li>
                            <li style={{ fontsize: 14 }}>Filters and Slicers in Power BI Maps</li>
                            <li style={{ fontsize: 14 }}>Scatterplots and BI Reports</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Connecting Dataset with Power BI
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Creating a Customer</li>
                            <li style={{ fontsize: 14 }}>Segmentation Dashboard</li>
                            <li style={{ fontsize: 14 }}>Analyzing the Customer</li>
                            <li style={{ fontsize: 14 }}>Segmentation Dashboard</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 4: Advanced features Power BI
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Creating calculated columns and measures with DAX
                            </li>
                            <li style={{ fontsize: 14 }}>Using custom visuals</li>
                            <li style={{ fontsize: 14 }}>
                              Building hierarchical visualizations with
                              drill-downs
                            </li>
                            <li style={{ fontsize: 14 }}>Creating and using templates</li>
                            <li style={{ fontsize: 14 }}>
                              Publishing reports and dashboards to the Power BI
                              Service
                            </li>
                          </ul>

                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>1. Financial Performance Analysis</p>
                          <p style={{ fontsize: 14 }}>
                            2. Anomaly Detection in Credit Card Transactions
                          </p>
                          <p style={{ fontsize: 14 }}>
                            3. AutoML Cashflow Optimization for Insurance
                            Company
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading008">
                      <h3 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse008"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 8 -
                          Computer Vision
                        </button>
                      </h3>
                    </div>

                    <div
                      id="collapse008"
                      className="collapse"
                      aria-labelledby="heading008"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="implementation-content">
                          <h4>
                            Chapter 1: Introduction to Computer Vision ( 3 hrs )
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Human and Machine Vision</li>
                            <li style={{ fontsize: 14 }}>Applications of Computer Vision</li>
                          </ul>
                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>
                            1. Statical Analysis of Health Insurance Pricing
                            Forecast
                          </p>
                          <p style={{ fontsize: 14 }}>
                            2. Climate Change impacts on the Global Food Supply
                          </p>
                          <p style={{ fontsize: 14 }}>
                            3. Statistical analysis of road accident in India
                          </p>

                          <h4 className="mt-3">
                            Chapter 2: Image Formation and Representation
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Image Formation Model</li>
                            <li style={{ fontsize: 14 }}>Digital Images and Color Spaces</li>
                            <li style={{ fontsize: 14 }}>Image Enhancement and Filtering</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Image Features and Feature Detection
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Edge Detection and Feature Detection</li>
                            <li style={{ fontsize: 14 }}>
                              Scale-Space Theory and Laplacian of Gaussian (LoG)
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Scale-Space Theory and Laplacian of Gaussian (LoG)
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 4: Image Segmentation
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Thresholding and Region Growing</li>
                            <li style={{ fontsize: 14 }}>Edge-based and Boundary-based Segmentation</li>
                            <li style={{ fontsize: 14 }}>
                              Watershed Segmentation and Mean Shift Segmentation
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 5: Object Recognition and Classification
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Template Matching and Correlation</li>
                            <li style={{ fontsize: 14 }}>Object Recognition using Features</li>
                            <li style={{ fontsize: 14 }}>
                              Machine Learning Approaches to Object Recognition
                              and Classification
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 6: Deep Learning for Computer Vision
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Convolutional Neural Networks (CNNs)</li>
                            <li style={{ fontsize: 14 }}>Object Detection and Localization</li>
                            <li style={{ fontsize: 14 }}>Image Segmentation using CNNs</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 7: Advanced Topics in Computer Vision
                          </h4>
                          <ul>
                            <li style={{ fontsize: 14 }}>Video Analysis and Tracking</li>
                            <li style={{ fontsize: 14 }}>Object Tracking and Localization</li>
                            <li style={{ fontsize: 14 }}>Medical Image Analysis and Applications</li>
                          </ul>

                          <h5>Project:</h5>
                          <p style={{ fontsize: 14 }}>1. AI based face detection system </p>
                          <p style={{ fontsize: 14 }}>2. Human emotion detection system </p>
                          <p style={{ fontsize: 14 }}>3. Handwritten Digit Recognition</p>
                          <p style={{ fontsize: 14 }}>
                            4. Computer vision system that can detect and locate
                            objects in an image
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="programmright">
                <h3>
                  Program <b>highlights</b>
                </h3>

                <div className="programlist">
                  <ul>
                    <li style={{ fontsize: 14 }}>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon01.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div  style={{ fontSize: 14 }} className="protxts">110+ Hours Live sessions</div>
                      </div>
                    </li>

                    <li style={{ fontsize: 14 }}>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon02.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div style={{ fontSize: 14 }} className="protxts">10+ Projects</div>
                      </div>
                    </li>

                    <li style={{ fontsize: 14 }}>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon03.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div style={{ fontSize: 14 }} className="protxts">1:1 Doubt Session</div>
                      </div>
                    </li>

                    <li style={{ fontsize: 14 }}>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon04.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div style={{ fontSize: 14 }} className="protxts">1 Year Subscription </div>
                      </div>
                    </li>
                  </ul>

                  <ul>
                    <li style={{ fontsize: 14 }}>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon01.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div style={{ fontSize: 14 }} className="protxts">Life time accessibility</div>
                      </div>
                    </li>

                    <li style={{ fontsize: 14 }}>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon02.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div style={{ fontSize: 14 }} className="protxts">Job Assistance Program</div>
                      </div>
                    </li>

                    <li style={{ fontsize: 14 }}>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon03.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div style={{ fontSize: 14 }} className="protxts">Peer to peer Learning</div>
                      </div>
                    </li>

                    <li style={{ fontsize: 14 }}>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon04.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div style={{ fontSize: 14 }} className="protxts">Mock Interview </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <p style={{ float: "left", width: "100%" }}>
                  <a target="_default" href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04" className="applnowbtn mt-4">
                    Talk to our experts
                    <i
                      className="fa fa-angle-right arrowclass"
                      aria-hidden="true"
                    ></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>*/}

      <section ref={syllabusInView} className="projectsnewbg" id="curriculum">
        <div className="container ">

          <center>
            <br/><br/><h2 style={{ fontSize: 30 }}>Data Science project Innovation Labs <b style={{ fontSize: 30, color:"#9769ef" }}>at Bangalore</b> 
            ?</h2>
          </center>
          <br></br>
          <p style={{ fontSize: 14 }}>
            <a href="https://logicmojo.com/data-science-projects">Projects</a> will be a part of your Certification in Data Science
            Course to consolidate your learning.
            It will ensure that you have real-world experience in Data Science
            Field.
          </p>
          <div className="projectsnewbg-practice">
            <ul>
              <li style={{ fontsize: 14 }}>
                <img src="assets/images/practice-icon.png" alt="" />
                <h3 style={{ fontsize: 17,color: "#f91c4b" }}>Practice 20+</h3>
                <p style={{ fontsize: 14 }}>Essential Tools</p>
              </li>
              <li style={{ fontsize: 14 }}>
                <img src="assets/images/designed-icon.png" alt="" />
                <h3 style={{ color: "#2aacf6" }}>Designed by</h3>
                <p style={{ fontsize: 14 }}>Industry Experts</p>
              </li>
              <li style={{ fontsize: 14 }}>
                <img src="assets/images/get-icon.png" alt="" />
                <h3 style={{ color: "#1fcd71" }}>Industry Projects</h3>
                <p style={{ fontsize: 14 }}>Work Experience</p>
              </li>
            </ul>
          </div>

          <div className="projectsnewbg-bottom clearfix" ref={navRef}>
            <ul className="nav nav-tabs sticky-nav center-nav" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab012">
                  Beginner
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab013">
                  Intermediate
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab014">
                  Advance
                </a>
              </li>
            </ul>
            <div className="tab-content">
              <div id="tab012" className="tab-pane active">
                <Projects id="1" />
                {/* <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Face Detection is an initiative to create a computer
                        vision model that can automatically detect and locate
                        human faces within images or video frames.The goal of
                        this project is to enable machines to recognize and
                        analyze human faces in various contexts, such as
                        security, entertainment, or social media.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Artificial intelligence-powered chatbot that can
                        communicate with humans in a natural language.project
                        involves designing, developing, and deploying a chatbot
                        that can perform specific tasks or answer questions for
                        users. The chatbot can be used for various purposes,
                        such as customer support, sales, marketing, or personal
                        assistance
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Restaurant revenue prediction project is an initiative
                        to create a machine learning model that can forecast the
                        revenue of a restaurant based on various factors such as
                        customer footfall, menu items, prices, and marketing
                        promotions. The goal of this project is to help
                        restaurant owners make data-driven decisions to increase
                        their revenue and profitability.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        climate change impacts project on the global food supply
                        is an initiative to investigate how climate change will
                        affect food production, distribution, and consumption
                        worldwide. The project aims to provide insights into how
                        these impacts may vary by region, crop type, and
                        socio-economic factors, and to identify potential
                        strategies for adaptation and mitigation.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Credit card fraud detection using classification
                        algorithms is an initiative to create a machine learning
                        model that can automatically detect fraudulent
                        transactions in credit card transactions. The goal of
                        this project is to enable financial institutions to
                        detect and prevent fraud and protect their customers'
                        financial security.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Water quality project using the random forest algorithm
                        in data science is an initiative to create a machine
                        learning model that can predict water quality parameters
                        such as pH, dissolved oxygen, biochemical oxygen demand
                        (BOD), and total suspended solids (TSS). Predict water
                        quality using datasets.
                      </p>
                    </div>
                  </div>
                </OwlCarousel> */}
              </div>

              <div id="tab013" className="tab-pane fade">
                <Projects id="2" />
                <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                  
                </OwlCarousel>
              </div>
              <div id="tab014" className="tab-pane fade">
                <Projects id="3" />
                <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h4>
                        <span>
                          Online Movie recommendation system to predict
                          preference
                        </span>
                      </h4>
                      <p style={{ fontsize: 14 }}>
                        Movie Recommendation system is a data science solution
                        that predicts the preferences of users for movies and
                        recommends relevant movies to them. The system uses
                        machine learning algorithms to analyze user data and
                        movie metadata to make predictions and recommendations.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h4>
                        <span>Online Books recommendation System</span>
                      </h4>
                      <p style={{ fontsize: 14 }}>
                        Collaborative filtering popular approach to
                        recommendation systems.It involves analyzing the
                        behavior of similar users to predict what a user might
                        like. For example, if User A and User B both read and
                        liked similar books, the system might recommend a new
                        book to User A based on the assumption that they will
                        also like it
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h4>
                        <span>Restaurant Revenue Prediction</span>
                      </h4>
                      <p style={{ fontsize: 14 }}>
                        One popular architecture for speech recognition is the
                        recurrent neural network (RNN), which can model the
                        temporal dependencies in speech.Use the preprocessed
                        data to train your neural network.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h4>
                        <span>Design chatGPT</span>
                      </h4>
                      <p style={{ fontsize: 14 }}>
                        Use ChatGPT deep learning techniques to generate
                        human-like responses to user inputs.ChatGPT uses a
                        variant of the transformer architecture called the
                        Generative Pre-trained Transformer (GPT). This
                        architecture allows the model to process sequences of
                        text and generate new text that is coherent and
                        grammatically correct
                      </p>
                    </div>
                  </div>
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="btn-center-section" id="curriculum">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>
      <section ref={mentorSection} className="mentor" id="mentor">
        <div className="container ">
          <br/><br/><h2 style={{ fontSize: 30 }}>
           Who will teach Data Science? 
          </h2>
          <MentorsProfile ytUrl="https://www.youtube.com/embed/qrjWdidQK-c?si=3hEbSTq0aE7A8rFr" />
          <div className="review_scroll_sec">
            <div className="review_scroll_inner">


            <div className="faculty-box position-relative d-flex flex-column">

                    <div className="body">
                      <h4 className="name">Mohammed Shirhaan</h4>
                      <p className="title">
                        Lead Architect WalMartLabs
                      </p>
                      <p style={{ fontSize: 14 }} className="description">
                      Mohammed Shirhaan is currently working as a Lead Architect at WalMartLabs.
                      He has a vast experience of teaching Data Science.
                      </p>
                    </div>

                    <footer className="d-flex position-relative justify-content-start align-items-center">
                      <img src="https://logicmojo.com/assets/dist/new_index_design/images/InformaticaLogo.png" />
                      <img
                        className="faculty-img position-absolute"
                        src="https://logicmojo.com/assets/dist/new_index_design/images/Mohammed-Shirhaan.png"
                      />
                      <a
                        className="inline-block linkedin-icon position-absolute"
                        href="https://www.linkedin.com/in/mshirhaan/"
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 16 16"
                          class="bg-white text-[#0077B6]"
                          height="18"
                          width="18"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                        </svg>
                      </a>
                    </footer>
                    </div>


                    <div className="faculty-box position-relative d-flex flex-column">

                <div className="body">
                  <h4 className="name">Mohamed Shirhaan</h4>
                  <p className="title">
                    Senior Data Science Mentor
                  </p>
                  <p style={{ fontSize: 14 }} className="description">
                  Shirhaan working as R & D Group of WalmartLabs as senior Developer.
                  </p>
                </div>

                <footer className="d-flex position-relative justify-content-start align-items-center">
                  <img src="assets/images/walmarticon.png" />
                  <img
                    className="faculty-img position-absolute"
                    src="assets/images/mac/Mohammed-Shirhaan.jpeg"
                  />
                  <a
                    className="inline-block linkedin-icon position-absolute"
                    href="https://www.linkedin.com/in/mshirhaan/"
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 16 16"
                      class="bg-white text-[#0077B6]"
                      height="18"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                    </svg>
                  </a>
                </footer>
                </div>

                <div className="faculty-box position-relative d-flex flex-column">

                  <div className="body">
                    <h4 className="name">Sankalp Jain</h4>
                    <p className="title">
                      Senior Mentor Data Scientist
                    </p>
                    <p style={{ fontSize: 14 }} className="description">
                    Sankalp is From IIT Kgp worked as a senior developer in Odin AI as a Data Scientist.
                    Experienced in the field of Data Scientist & AI.
                    </p>
                  </div>

                  <footer className="d-flex position-relative justify-content-start align-items-center">
                    <img style={{ height: "110px",width:"190px" }}
                    src="assets/images/companyLogo/iitKGP.jpeg" />
                    <img
                      className="faculty-img position-absolute"
                      src="assets/images/mac/Sankalp.jpeg"
                    />
                    <a
                      className="inline-block linkedin-icon position-absolute"
                      href="https://www.linkedin.com/in/sankalp-jain-iitkgp/"
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 16 16"
                        class="bg-white text-[#0077B6]"
                        height="18"
                        width="18"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                      </svg>
                    </a>
                  </footer>
                  </div>



                  <div className="faculty-box position-relative d-flex flex-column">

<div className="body">
  <h4 className="name">Ravi Singh</h4>
  <p className="title">
    Senior Mentor Data Scientist
  </p>
  <p style={{ fontSize: 14 }} className="description">
  Ravi has more than 14 years of experience and has worked on multiple projects in data science and machine learning, as well as in business analytics.

  </p>
</div>

<footer className="d-flex position-relative justify-content-start align-items-center">
  <img src="assets/images/walmarticon.png" />
  <img
    className="faculty-img position-absolute"
    src="assets/images/ravi-singh.jpg"
  />
  <a
    className="inline-block linkedin-icon position-absolute"
    href="https://www.linkedin.com/in/ravi-singh-a430ab29/"
  >
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 16 16"
      class="bg-white text-[#0077B6]"
      height="18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
    </svg>
  </a>
</footer>
</div>

            </div>
          </div>
          {/* <OwlCarousel
            className="owl-theme"
            loop
            margin={20}
            nav
            autoPlay={false}
            navText={[
              " ",
              " ",
            ]}
            responsive={{
              0: {
                items: 1
              },
              600: {
                items: 1
              },
              1000: {
                items: 3
              }
            }}
          >


            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="https://logicmojo.com/assets/dist/new_index_design/images/Mohammed-Shirhaan.png" />
                </div>

                <h3 className="name">Mohammed Shirhaan</h3>
                <p className="title">Lead Architect WalMartLabs</p>
                <p className="description">
                  Mohammed Shirhaan is currently working as a Lead Architect at WalMartLabs.
                  He has a vast experience of teaching Data Science.
                </p>
                <p style={{ fontsize: 14 }}>Linked : <a href="https://www.linkedin.com/in/mshirhaan/">Profile</a></p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Mohammed-Shirhaan.jpg" />
                </div>

                <h3 className="name">Mohamed Shirhaan</h3>
                <p className="title">Senior Data Science Mentor </p>
                <p className="description">
                  Shirhaan working as R & D Group of WalmartLabs as senior Developer.
                </p>
                <p style={{ fontsize: 14 }}>Linked : <a href="https://www.linkedin.com/in/mshirhaan/">Profile</a></p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Sankalp.jpeg" />
                </div>
                <h3 className="name">Sankalp Jain</h3>
                <p className="title">Senior Mentor Data Scientist</p>
                <p className="description">
                  Sankalp is From IIT worked as a senior developer in Odin AI as a Data Scientist.
                  Experienced in the field of Data Scientist & AI.
                </p>
                <p style={{ fontsize: 14 }}>Linked : <a href="https://www.linkedin.com/in/sankalp-jain-iitkgp/">Profile</a></p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/ravi-singh.jpg" />
                </div>
                <h3 className="name">Ravi Singh</h3>
                <p className="title">Senior Mentor Architect</p>
                <p className="description">
                  Ravi has more than 14 years of experience and has worked with multiple product organizations.
                  He has worked on multiple projects in data science and machine learning, as well as in business analytics.
                </p>
                <p style={{ fontsize: 14 }}>Linked : <a href="https://www.linkedin.com/in/ravi-singh-a430ab29/">Profile</a></p>
              </div>
            </div>


          </OwlCarousel> */}
        </div>
      </section>

      <section className="datareviewsbg" id="coursereview">
        <div ref={coursereviewSection} className="whatpeoplesaybg" id="Review">

          <div className="container">
            <h2>Data Science<br/><b style={{ fontSize: 32, color:"#9769ef" }}> Career Transitions!</b></h2><br/>
            <div className="d-none text-center mb-5" style={{ fontSize: 18 }}>
              How it has helped candidates to accelerate their careers in data science to the next level.
            </div>
            
            <CourseReview />
          </div>



          <div className="mt-4" style={{ textAlign: "center" }}>
            <a
              target="_default"
              href="https://logicmojo.com/reviews"
              className="btn btn-primary"
            >
              Check Success Story
            </a>
          </div>

        </div>
        <div ref={coursere1viewSection}>
      <VideoYoutube />
      </div>
        {/*
        <div className="container">
          <h3>Learner Reviews for our Data Science Programs</h3>

          <div className="row">
            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/shivam.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Shivam Bajpai</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  I recently wrapped up a data science course and would like to
                  discuss my impressions and insights from the program. Overall,
                  I believe the course is a great asset for those interested in
                  entering the data science field or improving their current
                  abilities. The course curriculum was skillfully crafted,
                  encompassing all key aspects of data science, such as
                  statistics, Python, machine learning, data analysis, and
                  large-scale data processing. The lessons were thoughtfully
                  arranged, beginning with fundamental concepts and gradually
                  advancing to more complex topics, making it simple to
                  comprehend and follow the material.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/puneet.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Puneet</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  I recently completed an online data science course and would
                  like to share my feedback and experiences about the program.
                  The course proved to be an exceptional learning opportunity
                  for those looking to delve into data science or improve their
                  existing skills in the field. The course was meticulously
                  structured, encompassing a broad array of crucial data science
                  topics.The instructors were not only experts in their
                  respective fields but also highly accessible and supportive.
                  They offered clear explanations and promptly addressed any
                  questions or concerns
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/diwakar.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Diwakar Choudhary</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  A key aspect of the data science course was its emphasis on
                  practical, hands-on learning experiences. Throughout the
                  program, students were tasked with completing a variety of
                  assignments, quizzes, and projects, encouraging them to apply
                  their newfound knowledge to real-world scenarios. This
                  approach not only deepened my understanding of the subject
                  matter but also allowed me to build a compelling portfolio to
                  showcase my skills to prospective employers.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/afnaan.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Afnaan Rafique</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  The online format of the data science course provided the
                  flexibility to learn at my own pace and according to my
                  schedule. This was particularly beneficial for individuals,
                  like myself, balancing work, family, and other commitments,
                  making it an appealing option for learners with varying levels
                  of availability.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/piyush.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Piyush Mittal</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  A crucial element of the data science course focused on
                  providing practical, experiential learning opportunities.
                  During the program, students engaged in numerous tasks, tests,
                  and projects that pushed them to utilize their acquired
                  knowledge in real-life situations. This method not only
                  enriched my comprehension of the topics but also enabled me to
                  create an impressive portfolio to demonstrate my abilities to
                  potential employers.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/priya.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Priya Singh</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  The digital structure of the data science course allowed for
                  the adaptability to study at a pace and schedule that suited
                  me. This proved to be especially advantageous for people,
                  including myself, who had to juggle work, family, and other
                  responsibilities, rendering it an attractive choice for
                  students with diverse time commitments.
                </p>
              </div>
            </div>
            <center>
              <a
                target="_default"
                href="https://www.google.com/search?q=logicmojo+review&oq=log&aqs=chrome.1.69i65j69i59j46i39i175i199j69i60l4j69i65.1921j0j7&sourceid=chrome&ie=UTF-8#lrd=0x3bae15239d632ad3:0x8248087353e6d723,1,,,,"
                className="btn btn-link collapsed"
              >
                View more reviews
              </a>
            </center>
          </div>
        </div>
                                */}
      </section>
      
     


      <section className="program-highlights" >
        <div className="container">

          <br/><br/><h2 ref={curriculum0Section}  className="mb-3" style={{ fontSize: 30 }}>Which <b style={{ fontSize: 30, color:"#9769ef" }}>skills</b> will I become an <b style={{ fontSize: 30, color:"#9769ef" }}>expert</b> in after this Course?</h2>
          <p style={{ fontSize: 14 }}>After completing this course, you will become an expert in <a href="https://logicmojo.com/data-science-and-artificial-intelligence">data science and artificial intelligence</a>, 
            Learn, explore, develop & deploy <a href="https://logicmojo.com/data-science-projects">data science projects</a>. You will gain proficiency in both data science and artificial intelligence, as well as machine learning and deep learning. 
            Additionally, you will develop advanced programming skills and a strong foundation in data science principles.
            </p>
          <div className="row" id="curriculum" >

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/idea.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Deep Learning</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/global-communication.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Natural Language Processing</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/bar-chart.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Statistics</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/computer.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Computer Vision</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/brain.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Machine Learning Algorithms</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/networking.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Model Training and Optimization</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/approval.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Model Evaluation and Validation</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/application.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Business Analytics/Data Analytics</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/ai.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Generative AI</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/prompt-engineer.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Data Visualization</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/reinforcement-learning.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Reinforcement Learning</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/voice-recognition.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Speech Recognition</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/chatgpt.png" alt="img" />
                <h3 style={{ fontSize: 14, textAlign: "center" }}>Large Language Model(LLM) & ChatGPT</h3>
              </div>
            </div>

          </div>


          <h2 className="mb-3 mt-5" style={{ fontSize: 30 }}>Which <b style={{ fontSize: 30, color:"#9769ef" }}>Data Science tools</b> would you learn?</h2>
          <p style={{ fontSize: 14 }}>During the preparation process in the course, you'll become proficient with a variety of tools that are essential for data science, <a href="https://logicmojo.com/big-data-analytics">big data</a>, <a href="https://logicmojo.com/power-bi-interview-questions">powerBI</a> and <a href="https://logicmojo.com/tableau-interview-questions">tableau</a>. Here are some of the key tools you will learn</p>

          <div className="row" ref={curriculum2ndSection}>

            <div className="col-md-3 col-4">
              <div className="highlight-card">

                <img src="assets/images/icons/5.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>Python</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">

                <img src="assets/images/icons/12.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>NumPy</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">

                <img src="assets/images/icons/10.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>Scikit-learn</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/4.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>Pytorch</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">

                <img src="assets/images/icons/8.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>Matplotlib</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/6.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>TensorFlow</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/7.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>Keras</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">

                <img src="assets/images/icons/11.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>OpenCV</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/9.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>NLTK</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/3.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>Gbard</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/1.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>ChatGPT</h3>
              </div>
            </div>

            <div className="col-md-3 col-4">
              <div className="highlight-card">
                <img src="assets/images/icons/2.webp" alt="img" />
                <h3 style={{ fontSize: 14 }}>DALL-E-2</h3>
              </div>
            </div>



          </div>

          <h2 ref={curriculum3rdSection} className="mb-3 mt-5" style={{ fontSize: 30 }}>What are the <b style={{ fontSize: 30, color:"#9769ef" }}>Job Roles and Salary Expectations</b> in Data Science?</h2>
          <p style={{ fontSize: 14 }}>Data science offers a variety of roles, including Data Scientist, AI Engineer, Machine Learning Engineer, and <a href="https://logicmojo.com/data-analytics-courses">Data Analytics</a>. These roles involve analyzing complex data, building predictive models, and maintaining data architecture. Below, we mention the average <a href="https://logicmojo.com/data-scientist-salary">Salary</a> offered for various roles in data science</p>                    
          
          <div className="row">
            <div className="col-12">
              <div className="p-3 mt-3 border" style={{ borderRadius: 10 }}>
                <img src="assets/images/salary-graph.png" width={'100%'} alt="" />
                <div className="graph-text">
                  <h3 style={{ fontsize: 11 }}>Data Analytics</h3>
                  <h3 style={{ fontsize: 11 }}>ML Engineer</h3>
                  <h3 style={{ fontsize: 11 }}>AI Engineer</h3>
                  <h3 style={{ fontsize: 11 }}>MLOps</h3>
                  <h3 style={{ fontsize: 11 }}>Data Scientist</h3>
                </div>
                <div className="avg-salery">
                  <div className="box"></div>
                  <p style={{ fontsize: 14 }}>Avg. Salary(LPA)</p>
                </div>
              </div>
            </div>
          </div>

          <h2 ref={curriculum4thSection} className="mb-3 mt-5" style={{ fontSize: 30 }}>Data Science Certification Course<b style={{ fontSize: 30, color:"#9769ef" }}> Learning Path</b></h2>

          <div className="row justify-content-center">

            <div className="col-md-10">

              <div className="learning-path-outer">
                <div className="learning-path-card">
                  <div className="learning-path-card-img">
                    <img src="assets/images/get-trained.png" alt="" />
                  </div>
                  <h3 style={{ fontsize: 14 }}>Get Trained</h3>
                </div>

                <div className="learning-path-card">
                  <div className="learning-path-card-img">
                    <img src="assets/images/submit-assignment.png" alt="" />
                  </div>
                  <h3 style={{ fontsize: 14 }}>Submit Assignments</h3>
                </div>

                <div className="learning-path-card">
                  <div className="learning-path-card-img">
                    <img src="assets/images/real-life-project.png" alt="" />
                  </div>
                  <h3 style={{ fontsize: 14 }}>Work on Real Life AI Projects</h3>
                </div>

                <div className="learning-path-card">
                  <div className="learning-path-card-img">
                    <img src="assets/images/bootcamp.png" alt="" />
                  </div>
                  <h3 style={{ fontsize: 14 }}>Bootcamps</h3>
                </div>

                <div className="learning-path-card last-card">
                  <div className="learning-path-card-img">
                    <img src="assets/images/job-readiness.png" alt="" />
                  </div>
                  <h3 style={{ fontsize: 14 }}>Job Readiness</h3>
                </div>
              </div>

              <div className="bottom-text">
                <h3>Intensive Interview Preparation</h3>
              </div>

            </div>

          </div>

          <h2 ref={curriculum5thSection} className="mb-3 mt-5" style={{ fontSize: 30 }}>Why Logicmojo is your gateway to a
            successful <b style={{ fontSize: 30, color:"#9769ef" }}>Data Science career</b></h2>

          <div className="row">

            <div className="col-md-4 col-6">
              <div className="highlight-card">
                <img src="assets/images/icons/book-stack.png" alt="img" />
                <h3>Industry-Based Course Curriculum</h3>
              </div>
            </div>

            <div className="col-md-4 col-6">
              <div className="highlight-card">
                <img src="assets/images/icons/ux.png" alt="img" />
                <h3>Value Added Course: Projects on Kaggle,Generative AI and MLOps</h3>
              </div>
            </div>

            <div className="col-md-4 col-6">
              <div className="highlight-card">
                <img src="assets/images/icons/app-development.png" alt="img" />
                <h3>Hands-on with <br /> 20+ Assignments</h3>
              </div>
            </div>

            <div className="col-md-4 col-6">
              <div className="highlight-card">
                <img src="assets/images/icons/job.png" alt="img" />
                <h3>Job Readiness Program with our 500+ partner companies</h3>
              </div>
            </div>

            <div className="col-md-4 col-6">
              <div className="highlight-card">
                <img src="assets/images/icons/live-chat.png" alt="img" />
                <h3>Support through Slack, Calls, & Whatsapp</h3>
              </div>
            </div>

            <div className="col-md-4 col-6">
              <div className="highlight-card">
                <img src="assets/images/icons/video.png" alt="img" />
                <h3>Lifetime eLearning Access</h3>
              </div>
            </div>


          </div>

        </div>
      </section>


      <section className="btn-center-section" id="curriculum" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

      

      
{/*
      <div className="itfeaturevideorow">
        <div className="container ">
          <h3>
          Meet Your Mentor <br/><b>Data Science ML/AI Course</b><br/><b>Live Demo Session</b>
          </h3>
          <br />
          <br />
         

          <div className="video-wrap">
            <div className="video">
              <iframe
                loading="lazy"
                src="https://www.youtube.com/embed/qrjWdidQK-c"
                
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen=""
                width="40%"
                height="450"
                frameBorder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
                              */}

<section ref={certificationSection} className="certificate-companies" id="certification">
        <Certificates />

        {/* <hr />
        <div className="container ">
          
          <div className="certificate-companies-text">
            <h2 style={{ fontSize: 29}}>Data Science <b style={{ fontSize: 29, color:"#9769ef"}}>Certification</b></h2>
            <h3 style={{ fontSize: 20}}> Data Science Certification Advantage </h3>
              <br></br>

             
            <ul>
              <h3><li style={{ fontsize: 14 }}>
                <b>Get Ahead with Logicmojo's Master Data Science Certificate</b>
              </li></h3>
              <p style={{ fontSize: 14 }}>
              Earn your professional data science certification with project experience through our accredited data science course. 
              Receive both Data Scientist and Company project certificates to enhance your career prospects in the field of data science. 
              Gain exclusive access to industry-leading expert masterclasses..
              </p>
              <h4><li style={{ fontsize: 14 }}>
                <b>Differentiate yourself with a Masters Certificate</b>
              </li></h4>
              <p style={{ fontSize: 14 }}>
                The understanding and Data Science abilities you've developed
                through projects, simulations, and case studies will put you
                ahead of others.
              </p>
             
            </ul>
            <a target="default" href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view">
              Download Brochure
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </a>
          </div>
          <div className="certificate-companies-img">
            <img style={{ border: '1px solid #000' }} src="assets/images/certificate-companies.png" alt="" />
          </div>
          <br/><br/>

        </div>


        <div className="container">

                  <div className="certificate-companies-text">
                  <ul>
                  <li style={{ fontsize: 14 }}>
                        <b>Project Experience Certification</b>
                      </li>
                      <p style={{ fontSize: 14 }}>
                        Share your Data Science Projects Certification on LinkedIn, Twitter, and
                        Facebook, enhance your resume, or display it proudly - let your
                        friends and colleagues know about your achievement
                      </p>
                  </ul>
                      </div>

                      <div className="certificate-companies-img">
                <img style={{ border: '1px solid #000' }} src="assets/images/Data Science Certification.jpg" alt="" />
                
                </div>


                    
          </div> */}
         
      </section>

      <section ref={placementSection} className="careerservices-new" id="placement">
        <div className="container ">
          <h2 style={{ fontSize: 30 }}>Will I get <b style={{ fontSize: 30, color:"#9769ef" }}>Career Support</b>?</h2>
          <br></br>
          <div className="careerservices-new-left">
            <img src="assets/images/career-services.png" alt="" />
          </div>
          <div className="careerservices-new-right">
            <div className="projectsnewbg-bottom clearfix" ref={navRef2}>
              <ul className="nav nav-tabs sticky-nav center-nav" role="tablist">
              <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#tab020"
                  >
                    Job Assistance
                  </a>
                </li>
                <li className="nav-item">
                 <a className="nav-link" data-toggle="tab" href="#tab021">
                    Interview Preparation
                  </a>
                </li>
                 <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab022">
                    Profile Building
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                <div id="tab020" className="tab-pane active">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h3 style={{ fontSize: 14, color:"#191970" }}><b>Job Assistance starts After Course Completion</b></h3>
                      <p style={{ fontsize: 14 }}>
                        Job referrals start after the completion of a course,
                        with career services professionals offering guidance and
                        support to students as they prepare to enter Data
                        Science & AI domain.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h3 style={{ fontSize: 14, color:"#191970" }}><b>Job Assistance Criteria</b></h3>
                      <p style={{ fontsize: 14 }}>
                        Job Assistance program for our candidates being regular
                        with classes. Get noticed & referred by our 150+ hiring
                        partners for the profile of Data Scientist, Machine
                        Learning Engineer, Data Analytics, MLOps as well as
                        Business Analytics.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
                <div id="tab021" className="tab-pane">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h3 style={{ fontSize: 14, color:"#191970" }}>
                        <b>Build Portfolio of Data Science, AI & ML with Projects</b>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Learn Full Stack AI & Data Scienece topics with 30+ real
                        projects with datasets. Designed & Implement Models,
                        Deploy in the Prod Environment. Make your profile storng
                        in Data Science & AI Field
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h3 style={{ fontSize: 14, color:"#191970" }}><b>Mock Interviews & Mentorship 1 to 1 Sessions</b></h3>
                      <p style={{ fontsize: 14 }}>
                        Attend 1 to 1 Classes with the mentor during mentorship
                        program. Make your progress in the right direction under
                        guidance of mentor having 5+ years experience in DS, AI
                        & ML Domain. Check your progress with mock interviews 1
                        to 1 Online Session , experience the actual interview
                        environment.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
                <div id="tab022" className="tab-pane">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h3 style={{ fontSize: 14, color:"#191970" }}><b>Resume Preparation</b> </h3>
                      <p style={{ fontsize: 14 }}>
                        After completion of the course , we need to prepare
                        candidate resume before applying for IT Data Scientist
                        as well as Data analytics profile" rephrase. Attend 1 to
                        1 session with mentor for resume preparation discussion.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h3 style={{ fontSize: 14, color:"#191970" }}><b>Linkedin Profile Update</b></h3>
                      <p style={{ fontsize: 14 }}>
                        For every candidate profile will be updated in Linkedin
                        Portal. Linked is considered to be the major Hub for
                        hiring Data Scientist as well as ML engineer.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="btn-center-section" id="placement">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

      <section className="network-reach-newbg" id="placement">
        <div className="container ">
          <h2 style={{ fontSize: 30 }}> Where do <b style={{ fontSize: 30, color:"#9769ef" }}>Logicmojo Alumni</b> Work After Course Completion?</h2>
          <br></br>
          <div className="row">
            <div className="col-lg-5">
              <div className="keyfeaturenew">
                <h3>Our Key Features</h3>
                <ul>
                  <h4><li style={{ fontsize: 14 }}>
                    We help you build a strong profile and prepare for MNC
                    interviews.
                  </li></h4>
                 <h4> <li style={{ fontsize: 14 }}>
                    Hassle-free and tailored Course for MAANG company
                    interviews.
                  </li></h4>
                  <h4><li style={{ fontsize: 14 }}>
                    Even after a career break, securing a dream job is
                    achievable.
                  </li></h4>
                  <h4><li style={{ fontsize: 14 }}>
                    A successful career transition even with 0 coding
                    experience.
                  </li></h4>
                </ul>
                {/* <a href="" className="downreportbtn">Download Placement Report <i className="fa fa-long-arrow-right" aria-hidden="true"></i></a> */}
              </div>
            </div>
            <div className="col-lg-7">
              <div className="keyfeaturenew-logo">
                <a href="">
                  <img src="assets/images/featurelogo1.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo2.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo3.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo4.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo5.png" alt="" />
                </a>
 
              </div>
            </div>
          </div>
        </div>
      </section>


      <section ref={certificationSection} className="btn-center-section" id="certification">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

  

      


     

    
      


      <div className="howtoapply-new" ref={feeDetails} id="fee">
        <div className="container ">
          <h2 style={{ fontSize: 25 }}>
          <b style={{ fontSize: 25, color:"#9769ef" }}>How to Register</b> For Logicmojo <b style={{ fontSize: 25, color:"#9769ef" }}>Data Science Course ?</b>
          </h2>
          <div className="row">
            <div className="col-lg-8">
              <div className="howtoapply-new-left">
                <ul>
                  <li style={{ fontsize: 14 }}>
                    <p>Step 1</p>
                    <h3>Submit Application</h3>
                    <p style={{ fontsize: 14 }}>
                      Book calender call with our senior data scientist
                    </p>
                  </li>
                  <li style={{ fontsize: 14 }}>
                    <p>Step 2</p>
                    <h3>Application Review</h3>
                    <p style={{ fontsize: 14 }}>
                      Data scientist will review your profile & answer all your queries
                    </p>
                  </li>
                  <li style={{ fontsize: 14 }}>
                    <p>Step 3</p>
                    <h3>Admission</h3>
                    <p style={{ fontsize: 14 }}>
                      Candidate can apply for Online Live classes for 8 months
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="howtoapply-new-right">
                <center><h3 style={{ fontSize: 25 }}>Apply For Live Course</h3></center>
                <div className="howtoapply-new-rightform">
                  <form>
                    <div className="row">

                      <div className="form-group col-lg-12">
                        <input
                          type="submit"
                          className="submitbtn"
                          value="Apply For Live Classes"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section ref={feeSection} className="programfeenew" id="fee">
        <div className="container ">
          <h2 style={{ fontSize: 30 }}>Data Science <b style={{ fontSize: 30, color:"#9769ef" }}>Course Fee</b> ?</h2>
          <div className="programfeenew-inner">
            <div className="programfeenew-inner-left">
              <div className="programfeenew-inner-price">
                <h3 style={{ fontsize: 14 }}>Total Fee</h3>
                <h4>₹ 54,000</h4>
              </div>
            </div>
            <div className="programfeenew-inner-right">
              <p>No Cost EMI</p>
              <div className="d-flex align-items-center justify-content-between">
                <p>
                  <span>As low as</span> ₹ 4,500/month
                </p>
                <a
                  target="_default"
                  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
                >
                  Apply now
                </a>
              </div>
              <p style={{ fontsize: 14 }}>
                We have partnered with the following financing companies to
                provide competitive finance options at 0% interest rate with no
                hidden costs...
              </p>
              <ul>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo1.png" alt="" />
                </li>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo2.png" alt="" />
                </li>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo3.png" alt="" />
                </li>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo4.png" alt="" />
                </li>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo5.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className="eligibility-criteria-row" id="fee">
        <div className="container ">
          <div className="row">
            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h3 style={{ fontSize: 25 }}>Data Science Course <b style={{ fontSize: 25, color:"#9769ef" }}>Eligibility</b> Criteria in Bangalore</h3>
                <ul className="eligibilitylist1">
                  <h4><li style={{ fontsize: 14 }}>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon1.png"
                        alt=""
                      />
                    </span>
                    A bechelor's degree with an average of 50% or higher marks
                  </li></h4>
                  <h4><li style={{ fontsize: 14 }}>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon2.png"
                        alt=""
                      />
                    </span>
                    Basic understanding of programming concepts and mathematics
                  </li></h4>
                  <h4><li style={{ fontsize: 14 }}>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon3.png"
                        alt=""
                      />
                    </span>
                    2+ years of work experience preferred
                  </li></h4>
                </ul>
              </div>
            </div><br/>

            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h3 style={{ fontSize: 25 }}><b style={{ fontSize: 25, color:"#9769ef" }}>Who can apply</b> for the Data Science course?</h3>
                <ul className="eligibilitylist2">
                  <h4><li style={{ fontsize: 14 }}>Software engineers</li></h4>
                  <h4> <li style={{ fontsize: 14 }}>IT Professionals</li></h4>
                  <h4> <li style={{ fontsize: 14 }}>Data Professionals</li></h4>
                  <h4> <li style={{ fontsize: 14 }}>Business Analysis</li></h4>
                  <h4> <li style={{ fontsize: 14 }}>Product Managers</li></h4>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <section className="btn-center-section" id="fee">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>
      <br />

      <section ref={overviewSectionInclude} className="getcertfiedbgnew" id="Overview">
        <div className="container ">
          <div className="getcertfiedbgnew-inner">
            <center>
              <h2 style={{ fontSize: 25 }}>
              Data Science Course <b style={{ fontSize: 25, color:"#9769ef" }}> Certification </b> in Bangalore
              </h2>
            </center>
            <br />
            <br />
           
            <div className="row justify-content-center">


              <div className="col-md-4 col-6">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-laptop" aria-hidden="true"></i>
                  <h3 style={{ fontsize: 14 }}>100% Live Online Classes</h3>
                  <div style={{ fontsize: 14 }}>
                  Faculty led Live Interactive online course on weekend &amp;
                    Live doubt sessions on Weekdays
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-6">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                  <h3 style={{ fontsize: 14 }}>Build Work Experience</h3>
                  <div style={{ fontsize: 14 }}>
                    Don't just Learn, Apply your learnings - work with companies
                    project.Real-world experience by working on live projects
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-6">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-briefcase" aria-hidden="true"></i>
                  <h3 style={{ fontsize: 14 }}>Assured Job Assistance</h3>
                  <div style={{ fontsize: 14 }}>
                    Secure a guaranteed job referral to leading companies and
                    startups, and kickstart your career in data science, AI
                    &amp; Machine Learning.
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-6">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-check-square" aria-hidden="true"></i>
                  <h3 style={{ fontsize: 14 }}>Domain Specialization</h3>
                  <div style={{ fontsize: 14 }}>
                  Leverage your prior work experience for relevant career transition &amp; Aim for higher salary hikes.
                  </div>
                </div>
              </div>




            </div>
          </div>
        </div>
      </section><br/><br/>
{/*
  Ravi Changes
*/}
      

      <section id="careeropp1" className="fee">
        <div className="container ">
          <div className="careeroppbg-inner">
            <h2 style={{ fontSize: 30 }}>
              What <b style={{ fontSize: 30, color:"#9769ef" }}>roles</b> will you get after completing a <b>data science course</b>?
            </h2> 
            <p style={{ fontsize: 14 }}>
            After completing the course, candidates will become experts in data science engineering as well as artificial intelligence. 
            Consequently, candidates will be eligible for various roles in the data science domain. 
            Below are a few of the roles with their responsibilities and the compensation offered by companies:
            </p>
            <br />
            <br />

            <ul className="nav nav-tabs" role="tablist">
             <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab01">
                  <span>
                    <img src="assets/images/opportunities-icon1.png" alt="" />
                  </span>
                  Machine Learning Engineer
                </a>
              </li>
               <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab02">
                  <span>
                    <img src="assets/images/opportunities-icon2.png" alt="" />
                  </span>
                  Data Scientist
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab03">
                  <span>
                    <img src="assets/images/opportunities-icon3.png" alt="" />
                  </span>
                  MLOps
                </a>
              </li>
               <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab04">
                  <span>
                    <img src="assets/images/opportunities-icon4.png" alt="" />
                  </span>
                  AI Engineer
                </a>
              </li>
            </ul>

            <div className="tab-content">
              <div id="tab01" className="tab-pane">
                <div className="careeroppbg-inner-text">
                  <p style={{ fontsize: 14 }}>
                  According to a report by Glassdoor, professionals in machine learning earn a good amount in the IT sector. 
                  Here are some key roles that a Machine Learning Engineer (MLE) has.
                  </p>
                  <p style={{ fontsize: 14 }}>One of the few key roles that ML engineer has :</p>
                  <ol>
                    <li style={{ fontsize: 14 }}>ML Engineer acquired data about the project and then spent a significant amount of time cleaning, organizing, and preparing this data for use in machine learning models.</li>              
                    <li style={{ fontsize: 14 }}>Based on the problem given to ML engineers, MLEs research and choose appropriate machine learning algorithms. 
                      They then design the architecture of the model, selecting the parameters and defining how the data will flow through the system.</li>
                    <li style={{ fontsize: 14 }}>Machine learning Engineers (MLEs) train the model on the prepared data they collected from the project and then fine tune its parameters to achieve optimal performance. 
                      MLEs also employ various techniques to evaluate the model's accuracy and identify potential biases or errors.</li>
                  <li style={{ fontsize: 14 }}>Once a model performs well, ML Enfineer prepares it for real-world use. 
                    This involves packaging the model code then integrating it with backend systems, and ensuring it can handle large volumes of data in a production environment. 
                    After all computation, it deploys the machine learning model</li>
                  </ol>
                  <h3>Average Salaries of MAchine Learning Engineer</h3>
                  <h3>
                    Rs. 1500K - Rs. 4000K <span>Per annum</span>
                  </h3>
                  <h4>Hiring Compenies</h4>
                  <a href="">
                    <img src="assets/images/microsofticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/walmarticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/googleicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/amazonicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/flipcarticon.png" alt="" />
                  </a>
                </div>
              </div>
              <div id="tab02" className="tab-pane fade active show">
                <div className="careeroppbg-inner-text">
                  <p style={{ fontsize: 14 }}>
                  Few of the key responsibilities of Data Scientist roles:
                  </p>
                  <ol>
                    <li style={{ fontsize: 14 }}>Data scientists are the key players in communicating with the customer. 
                      Also, understand the requirements, and collect the data, logs, customer records, or even external data sources. Data scientists understand the business requirements end to end..</li>
                    <li style={{ fontsize: 14 }}>Generally we have a lot of errors so data scientists spend a significant amount of time in cleaning the data by removing inconsistencies, formatting errors, and handling missing values, etc.</li>
                  <li style={{ fontsize: 14 }}>Data scientists use statistical methods and visualizations to understand patterns, trends, and potential relationships within the data. So Statistics should be very strong for data scientists.</li>
                  <li style={{ fontsize: 14 }}> Based on the business problem and the characteristics of the data, data scientists choose appropriate statistical models or machine learning algorithms. Then data scientists build and train these models to extract meaningful insights from the data.</li>
                  <li style={{ fontsize: 14 }}> Sometimes data scientist need to refine their models, explore new data sources or reframe the problem definition. This iterative approach ensures they're on the right track to delivering valuable insights</li>
                  </ol>
                  <h3>Data Scientist Average Salaries</h3>
                  <h3>
                    Rs. 2000K - Rs. 5000K <span>Per annum</span>
                  </h3>
                  <h4>Hiring Compenies</h4>
                  <a href="">
                    <img src="assets/images/microsofticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/flipcarticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/googleicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/amazonicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/walmarticon.png" alt="" />
                  </a>
                </div>
              </div>
              <div id="tab03" className="tab-pane fade">
                <div className="careeroppbg-inner-text">
                  <p style={{ fontsize: 14 }}>
                  MLOps main responsibility is to check machine learning models developed by data scientists are successfully deployed, managed, and monitored in real-world applications.
Some of the key responsibilities of MLOps:

                  </p>
                  <ol>
                    <li style={{ fontsize: 14 }}>MLOps engineers design and implement automated pipelines that streamline the entire machine learning project pipeline.</li>
                 <li style={{ fontsize: 14 }}>MLOps research and choose appropriate machine learning algorithms.Then they design the architecture of the model and select the parameters. They define how the data will flow through the system</li>
                  <li style={{ fontsize: 14 }}>MLOps engineers train the model on the prepared data, fine-tuning its parameters to achieve optimal performance
                  </li>
                  </ol>
                  <h3>Average Salaries of MLOps</h3>
                  <h3>
                    Rs. 400K - Rs. 2000K <span>Per annum</span>
                  </h3>

                </div>
              </div>
              <div id="tab04" className="tab-pane fade">
                <div className="careeroppbg-inner-text">
                  <p style={{ fontsize: 14 }}>
                  AI engineer job is somewhat more related to an architect level task. The Few responsibilities as an AI architect are 
                  </p>
                  <ol>
                    <li style={{ fontsize: 14 }}>AI engineers select appropriate machine learning algorithms or other AI techniques (e.g., NLP, computer vision) to build the solution. Then AI engineer designs the architecture of the system by considering factors like data pipelines, model training, and integration with existing systems.</li>
                 <li style={{ fontsize: 14 }}>The training process of the AI model, fine-tuning its parameters to achieve optimal performance also one of the day-to-day tasks of the AI Engineer.</li>
                 <li style={{ fontsize: 14 }}>AI Engineer does code optimization in the current module, packaging the model, and integrating it with backend systems to ensure it can function seamlessly within the IT infrastructure.</li>
                 
                 </ol>
                  <h3>Average Salaries of AI Engineer</h3>
                  <h3>
                    Rs. 500K - Rs. 3000K <span>Per annum</span>
                  </h3>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section ref={faqDetails} id="faq" className="faq">
        <div className="container">
          <h2>
          <b style={{ fontSize: 30, color:"#9769ef" }}>Queries Related to</b><b> Logicmojo's Data Science Course</b>
          </h2>
          <p style={{ fontsize: 14 }}>
            Our Data Science course, in partnership with startup Data Science
            certification, is led by experienced instructors who will guide you
            in mastering the field of Data Science. The comprehensive course
            covers various topics such as Python programming, Machine
            Learning, and real-time projects, ensuring you gain practical
            knowledge and skills.
          </p>
          <div className="faqnewbg-inner">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab023">
                  Introduction to Data Science Course
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab025">
                  certification
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab026">
                  job assistance
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab027">
                  mentorships
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab028">
                  support
                </a>
              </li>
            </ul>

            <div className="tab-content">
              <div id="tab023" className="tab-pane active">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">



                    <div className="card">
                      <div className="card-header" id="heading000">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse000"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Why become a data scientist ? 
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse000"
                        className="collapse"
                        aria-labelledby="heading000"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>In the age of AI and machine learning, data is crucial. 
                            The demand for skilled data scientists is at its peak. 
                            Unlike many careers, data science offers plenty of job opportunities. 
                            Organizations view data scientists as essential for growth, ensuring continued demand for these professionals.</p>
                          
                          <br />
                          <p style={{ fontsize: 14 }}>In many places, companies struggle to find enough qualified data scientists. For instance, India has over <a href="https://www.analyticsinsight.net/data-science/data-scientists-will-be-the-most-in-demand-profession-in-the-next-5-years-here-is-why#:~:text=The%20number%20of%20jobs%20requiring,a%20career%20in%20Data%20Science.">97,000 unfilled data scientist </a>positions. According to the <a href="https://www.usdsi.org/data-science-insights/Get-Started-With-The-Perfect-Guide-To-Data-Science-Careers-In-2023#:~:text=According%20to%20the%20US%20Bureau,key%20to%20any%20organization's%20growth.">US Bureau of Labor Statistics</a>, jobs requiring data science skills are expected to grow by 27.9% by 2026. Job security is important when choosing a career, and data scientists seem to have plenty of it.
                          </p>
                          <br/>
                          <img
                            src="assets/images/mac/what-is-data-science.jpeg"
                            style={{ width: "100%" }}
                            alt=""
                          />
                          <br/>
                          <br/>
                          <p style={{ fontsize: 14 }}>Given the clear relationship between job availability and compensation, the absence of highly qualified data science specialists typically permits a high salary. After specialized doctors, it is the highest-paid job in the world. In India, the initial compensation for a data scientist is approximately 10 LPA, and after five years of experience, the salary can rise to 60–70 LPA. These huge numbers are sufficient to show the important role that data scientists play. 
                            Not only is money important, but perks like big bonuses are the icing on the cake.</p>
                          
                          
                        </div>
                      </div>
                    </div>

                    

                    <div className="card">
                      <div className="card-header" id="heading020">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse020"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Who should take this data science course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse020"
                        className="collapse"
                        aria-labelledby="heading020"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                         
                          <ul>
                            <li style={{ fontsize: 14 }}>
                            Beginners who want to learn Machine Learning, Data Science, and Python.
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Programmers looking to expand their skills into Data Science and Machine Learning.
                            </li>
                            <br />
                            <img
                              src="assets/images/mac/Why-Choose-DataSciecne.jpg"
                              style={{ width: "100%" }}
                              alt=""
                            />
                            <br />
                            <br />
                            <li style={{ fontsize: 14 }}>
                            Anyone who wants to learn from industry experts with real-world experience.
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Those seeking a comprehensive course on Machine Learning and Data Science to stay current in the field.
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Learners who want to understand the fundamentals, not just watch coding tutorials.
                            </li>
                            <li style={{ fontsize: 14 }}>
                            People interested in using Deep Learning and Neural Networks in their projects.
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Individuals aiming to add value to their business or workplace with Machine Learning tools.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the prerequisites for this Data Science training?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                         
                          <ul>
                            <li style={{ fontsize: 14 }}>
                            No prior experience is needed (not even Math and Statistics). We start from the very basics.

                            </li>
                            <li style={{ fontsize: 14 }}>
                             No coding experienced required
                            </li>
                            <li style={{ fontsize: 14 }}>
                            All tools used in this course are free for you to use.
                            </li>
                           
                           
                          </ul>
                         
                           
                          
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading030">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse030"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Data Science Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse030"
                        className="collapse"
                        aria-labelledby="heading030"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                          A Data Science course can help you become a skilled Data Science professional in just 7 months. 
                          Considering the increase in the demand for data science and AI every other working professional is 
                          switching their profile to data science. Data science courses are an easy way to do smart preparation 
                          and quickly cover the syllabus. Few of the key features that a course can provide include -
                          </p>
                          <br />
                          <ul>
                            <li style={{ fontsize: 14 }}>
                            Enhances career growth: Opens up new career opportunities and advancements.
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Offers flexibility, freedom, and options: Allows you to learn at your own pace with various learning formats.
                            </li>
                           
                            <li style={{ fontsize: 14 }}>
                            Provides a structured education program: Follows a comprehensive curriculum designed for effective learning
                            </li>
                           
                            <li style={{ fontsize: 14 }}>
                            Teaches the most popular Data Science tools: Equips you with essential tools like Python, R, and SQL.
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Helps you apply theoretical concepts to business problems: Bridges the gap between theory and practical application. 
                            You will work on different domains projects which uses data science and AI to computer and deploy models
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Keeps you updated on the latest industry trends: Ensures you stay current with evolving Data Science practices.
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Training from a data science course will train you to become a data scientist or ML engineer in good product-based IT companies
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Makes it easy to showcase your expertise: Facilitates building a strong portfolio to demonstrate your skills.
                          
                            </li>
                            <li style={{ fontsize: 14 }}>
                            Changing your domain to the data science field will increase your compensation to multifold.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => setTg(!toggle)}
                      className="btn btn-primary mb-3 viewmorebtn"
                    >
                      {toggle ? "View Less" : "View More"}
                    </button>

                    {toggle && (
                      <div className="morefaq">
                        <div className="card">
                          <div className="card-header" id="heading04">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse04"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Is data science a good career?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse04"
                            className="collapse"
                            aria-labelledby="heading04"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                              Yes, data science is considered a good career choice for freshers as well as working professionals. 
                              This field offers immense career opportunities, and with the increasing demand, there are various new internships and job opportunities in the market. 
                              The number of jobs in this area is expected to grow to 27.9% by 2026, according to the <a href="https://www.bls.gov/opub/btn/volume-7/big-data-adds-up.htm">US Bureau of Labour Statistics</a>. 
                              Only a select few people possess the abilities needed for a position in data science.
                              </p>
                              <br/>
                              <br />
                              <img
                                src="assets/images/carrier.jpeg"
                                style={{ width: "100%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>Below are some of the major reasons to consider a career in data science</p>
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                Demand for Data Scientists and ML Engineers has increased over the last few years. Additionally, every industry sector is using data science and AI in some way in their products. As a data scientist, you always have 2 to 3 job offers to choose from.
                                </li>

                                <li style={{ fontsize: 14 }}>
                                As demand increases, you will eventually be offered a very high pay package as a data scientist. Most professionals consider CTC as a major factor in joining the company. So compensation is also one of the major factors in choosing the data science field. In many places, data scientists are getting higher packages than software professionals.
                                </li>

                                <li style={{ fontsize: 14 }}>
                                Data science is used in various sectors and domains. You will be able to choose your desired sector and start working as a data scientist based on your interests. You will get to work on terabytes of data to do data computation and model training.
                                </li>

                                <li style={{ fontsize: 14 }}>
                                Data Science and AI fields are constantly evolving with time. Now, GenAI is the latest technology that every tech company is moving towards. So you will also get a chance to become familiar with these new tools and technogies.

                                </li>

                               
                              </ul>
                             
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading0502">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse0502"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Why you should take this data science course?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse0502"
                            className="collapse"
                            aria-labelledby="heading0502"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                              This comprehensive and project based course will introduce you to all of the modern skills of a Data Scientist and along the way, we will build many real world projects to add to your portfolio. 
                              You will get access to all the code, workbooks and templates (Jupyter Notebooks) on Github, so that you can put them on your portfolio right away! Our hands-on course equips learners with the most in-demand skills, making it one of the best data science courses in India. Benefit from this data science course - 
                              </p>
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                Industry-vetted data science syllabus
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Regular assignments
                                 </li>
                                 <li style={{ fontsize: 14 }}>
                                 15+ data science projects
                                 </li>
                                 <li style={{ fontsize: 14 }}>
                                 Mock interviews
                                 </li>
                                 <li style={{ fontsize: 14 }}>
                                 All the knowledge to get hired as a data scientist
                                 </li>
                                 <li style={{ fontsize: 14 }}>
                                  A community of data science learners
                                  </li>
                              </ul>
                              <p style={{ fontsize: 14 }}>
                              Additionally, learn workplace skills, soft skills, and interview skills with our dedicated Career Services Team. By the end of this course, you will be a complete Data Scientist that can get hired at large companies. 
                              We are going to use everything we learn in the course to build professional real world projects.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading06">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse06"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the average salary of a data scientist in India and the US?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse06"
                            className="collapse"
                            aria-labelledby="heading06"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                             <p style={{ fontsize: 14 }}>Data Scientists are highly in demand skills both in India and the United States because companies and organizations are having tera bytes of data make businessdecisions more and more accurate.
                               However, their salaries can differ a lot based on where they work, the industry they are in, and how experienced they are.</p>
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                Salary of Data Scientists in India - According to salary data from different sources, the average salary for a <a href="https://www.glassdoor.co.in/Salaries/india-data-scientist-salary-SRCH_IL.0,6_IN115_KO7,20.htm">Data Scientist in India</a> is on average around ₹12,00000 or in a more rough estimate about INR 10–20 lakhs per annum.

                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Salary of Data Scientists in the U.S. - In the United States, salaries for Data Scientists tend to be significantly higher. Also, various sources state slightly different average salary for a <a href="https://www.indeed.com/career/data-scientist/salaries">Data Scientist in the United States</a>, but you can say that the average is between 120,000-130,000 US$ per year
                                 </li>
                               </ul>
                               <br />
                               <img
                                src="assets/images/fsalary.jpg"
                                style={{ width: "100%" }}
                                alt=""
                              />
                              <br />
                              <br />
                               <img
                                src="assets/images/esalary.jpg"
                                style={{ width: "100%" }}
                                alt=""
                              />
                              <br />
                             
                              
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading07">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse07"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Is this data science course for beginners?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse07"
                            className="collapse"
                            aria-labelledby="heading07"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                              Even if you are from Non IT background or Freshers just passout from college or Software Developer IT professionals wants to change there Domain from Software to Data Science and Machine Learning then this course is suatbale for you.
This Data Science  course is ideal for beginners, as it starts with the fundamentals and gradually builds up your skills. This course can be pursued by anyone with zero experience (or beginner/junior) who wants to learn Machine Learning, Data Science and Python from industry experts who not only teach but have actually worked in the field. If you see Data Science as a potential career in your future, this is the perfect course to get started with.
                              </p>
                              <br />
                              <img
                                src="assets/images/mac/data-science-course.jpeg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading0800">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse0800"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Is data science need maths?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse0800"
                            className="collapse"
                            aria-labelledby="heading0800"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>Math plays an important role in data science. 
                                It helps in problem-solving and optimizing model performance along with that it also helps interpret complex data to answer business questions. 
                                Data science careers need mathematical study because machine learning algorithms need lots of maths to perform analyses and discovering data insights requires math. While math will not be the only requirement for your educational and career path in data science, it's often one of the most important to excel in data science. Here are a few topics you should be aware of:</p>
                            <ol>
                              <li style={{ fontsize: 14 }}>Statistics and Probability</li>
                              <li style={{ fontsize: 14 }}>Linear Algebra</li>
                              <li style={{ fontsize: 14 }}>Calculus</li>
                              <li style={{ fontsize: 14 }}>Discrete Mathematics</li>
                              <li style={{ fontsize: 14 }}>Optimization</li>
                            </ol>
                            <p style={{ fontsize: 14 }}>
                            How much math you must know also depends on your role. For instance, a junior Data Analyst heavily emphasizes trend analysis. He or she needs to learn how to extract and interpret data but only sometimes works with many complex mathematical concepts. They will use less math, other than when they need to work with machine learning algorithms, compared to a senior-level Data Scientist.
Math is an important part of data science. It can help you solve problems, optimize model performance, and interpret complex data that answers business questions.

                            </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading09">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse09"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> How do I choose a data science course?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse09"
                            className="collapse"
                            aria-labelledby="heading09"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                              When choosing a data science course, the content and curriculum are crucial factors to consider. Here are few things that you can check in a data science course before enrolling -
                              </p>
                              <ul>
                                <li style={{ fontsize: 14 }}>The course should cover a broad range of topics to provide a comprehensive understanding of data science principles and techniques.</li>
                               <li style={{ fontsize: 14 }}>Look for courses that include key concepts such as data manipulation, exploratory data analysis, machine learning algorithms, statistical modeling, data visualization, and big data processing. </li>
                              <li style={{ fontsize: 14 }}>A well-designed curriculum will also expose you to commonly used tools and programming languages in data science, such as Python, R, and SQL.</li>
                              <li style={{ fontsize: 14 }}>An ideal course will incorporate practical exercises and projects to enable the hands-on application of learned concepts. Implementing an eLearning project requires a lot of planning and hard work. To streamline the process, you need to make sure your prospective faculty follows an organized process for course development. </li>
                              </ul>
                              <p style={{ fontsize: 14 }}>
                              Evaluating the course content and curriculum thoroughly will ensure you acquire the necessary skills and knowledge to excel in data science. 
                              In recent years, there has been an increasing number of online data science courses available in India. 
                              Online data science courses such as Data Science with Python and R, Data Science with Python, Data Science and Machine Learning, Advance Data Science and AI Program, are some examples that are popular in India. These online courses are designed for fresh graduates and working professionals who want to learn data science and are not able to attend regular classes
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading10">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse10"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What projects can I do in data science?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse10"
                            className="collapse"
                            aria-labelledby="heading10"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                              In data science, you can undertake a wide range of projects that can help you develop and showcase your skills. Data science projects can include web scraping, exploratory data analysis, machine learning, deep learning, computer vision, natural language processing, and more. Here are some project ideas based on category in data science:
                              </p>
                              <p style={{ fontsize: 14 }}>Machine Learning Projects</p>
                           <ol>
                              <li style={{ fontsize: 14 }}>Credit Risk Assessment</li>
                           <li style={{ fontsize: 14 }}>Customer Churn Prediction</li>
                           <li style={{ fontsize: 14 }}>House Price Prediction</li>
                           <li style={{ fontsize: 14 }}>Spam Email Detection</li>
                           </ol>
                           <p style={{ fontsize: 14 }}>Data Analysis and Visualization Projects</p>
                           <ol>
                            <li style={{ fontsize: 14 }}>Sales Data Analysis</li>
                            <li style={{ fontsize: 14 }}>COVID-19 Data Visualization</li>
                            <li style={{ fontsize: 14 }}>Customer Segmentation</li>
                            <li style={{ fontsize: 14 }}>Climate Change Analysis</li>
                           </ol>
                           <p style={{ fontsize: 14 }}>Web Scraping Projects</p>
                           <ol>
                            <li style={{ fontsize: 14 }}> E-commerce Price Tracker</li>
                            <li style={{ fontsize: 14 }}>Job Listings Aggregator</li>
                            <li style={{ fontsize: 14 }}> Real Estate Data Scraper</li>
                            <li style={{ fontsize: 14 }}> Social Media Sentiment Analysis</li>
                           </ol>
                           <p style={{ fontsize: 14 }}>Time Series Forecasting Projects</p>
                           <ol>
                            <li style={{ fontsize: 14 }}>Stock Price Prediction</li>
                            <li style={{ fontsize: 14 }}>Electricity Demand Forecasting</li>
                            <li style={{ fontsize: 14 }}>Sales Forecasting</li>
                            <li style={{ fontsize: 14 }}>Weather Prediction</li>
                           </ol>
                           <p style={{ fontsize: 14 }}>OpenCV Projects</p>
                           <ol>
                            <li style={{ fontsize: 14 }}>Face Detection and Recognition</li>
                            <li style={{ fontsize: 14 }}>Object Tracking</li>
                            <li style={{ fontsize: 14 }}>Edge Detection</li>
                            <li style={{ fontsize: 14 }}>Augmented Reality</li>
                            </ol>
                            <p style={{ fontsize: 14 }}>Deep Learning Projects</p>
                            <ol>
                              <li style={{ fontsize: 14 }}>Image Classification</li>
                              <li style={{ fontsize: 14 }}>Text Generation</li>
                              <li style={{ fontsize: 14 }}>Voice Recognition</li>
                              <li style={{ fontsize: 14 }}>Generative Adversarial Networks (GANs)</li>
                            </ol>
                            <p style={{ fontsize: 14 }}>NLP Projects</p>
                            <ol>
                              <li style={{ fontsize: 14 }}>Sentiment Analysis</li>
                              <li style={{ fontsize: 14 }}>Chatbot Development</li>
                              <li style={{ fontsize: 14 }}>Text Summarization</li>
                              <li style={{ fontsize: 14 }}>Language Translation</li>
                            </ol>
                            <p style={{ fontsize: 14 }}>These projects cover a broad range of applications and techniques in data science, providing ample opportunities to apply and develop your skills. You should choose a data science project based on your interests, available data, relevance to your goals, and potential impact on solving real-world problems.</p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading11">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse11"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                the intended learning outcomes for this Data
                                Science course ?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse11"
                            className="collapse"
                            aria-labelledby="heading11"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Data Science is currently one of the most
                                in-demand professions, with the United States
                                Bureau of Labor Statistics projecting an
                                unprecedented growth rate of 28% and 11.5
                                million job openings in this field by 2026. To
                                help individuals master the job-critical skills
                                required for this profession, Logicmojo has
                                developed a comprehensive Data Science course in
                                collaboration with IBM
                              </p>
                              <br />
                              <img
                                src="assets/images/mac/Why-LEARN-DATA-SCIENCE.jpeg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>
                                This course covers various topics such as
                                statistics, data mining, decision trees, data
                                visualization, and much more. It includes a
                                combination of live online instructor-led
                                classes and self-paced learning videos, and
                                culminates in a Capstone project that allows
                                learners to apply the knowledge they have
                                acquired to build an industry-relevant product.
                                Completing this course will equip learners with
                                the skills required for the role of a Data
                                Scientist.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading009">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse009"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> The average
                                annual salary of Data Scientists as per Report
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse009"
                            className="collapse"
                            aria-labelledby="heading009"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Average salaries for data scientists in India are:
                                annual compensation that differs by experience
                                geography, sector, and company size. The typical
                                the salary of a data scientist in India.
                                is widely different based on investigations and statistical analysis.
                                16- 17 lakhs INR for entry level roles.
                                Between INR 25 lakh and INR 3.
                                working in top firms. Even greater compensation
                                Some capable and
                                experienced data scientists. It's crucial to
                                keep in mind that these are only approximations, and
                                Actual pay may differ due to specific circumstances.
                                differ.
                              </p>
                              <br />
                              <img
                                src="assets/images/mac/Data-Scientist-Salary.jpg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              <br />
                              <br />
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading039">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse039"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What
                                software/tools are used in a Data Science course
                                ?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse039"
                            className="collapse"
                            aria-labelledby="heading039"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Data science, an interdisciplinary domain,
                                amalgamates various instruments, software, and
                                technologies. Here is an array of prevalent
                                software and tools employed in data science
                                coursework:
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Programming languages: Python, R, and SQL are
                                  indispensable languages for data analysis and
                                  machine learning. Python garners particular
                                  admiration in data science due to its
                                  straightforwardness, comprehensive libraries,
                                  and adaptability. R is extensively employed in
                                  statistical computing, data visualization, and
                                  analysis. SQL facilitates data extraction from
                                  databases.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Data Visualization tools: Tableau, Power BI,
                                  and ggplot2 serve to fashion visual depictions
                                  of data, empowering data scientists to
                                  comprehend and convey insights to stakeholders
                                  effectively.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Machine Learning tools: Scikit-learn,
                                  TensorFlow, and Keras aid in constructing
                                  models capable of learning from data and
                                  generating predictions. These tools excel in
                                  tasks such as image recognition, natural
                                  language processing, and recommendation
                                  systems.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Big Data tools: Hadoop, Spark, and Hive manage
                                  and process sizable datasets, enabling data
                                  scientists to handle vast quantities of data
                                  in a distributed setting.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Version Control tools: Git and Github oversee
                                  and monitor code alterations, proving
                                  invaluable in collaborative data science
                                  endeavors involving multiple contributors.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Cloud Computing platforms: Amazon Web Services
                                  (AWS), Microsoft Azure, and Google Cloud
                                  Platform (GCP) store and process substantial
                                  datasets and deploy machine learning models.
                                </li>
                                <br />
                              </ol>
                              <br />
                              <img
                                src="assets/images/mac/Data-Science-Tools.jpg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>
                                In essence, data science course integrate
                                programming languages, data visualization tools,
                                machine learning tools, big data tools, version
                                control tools, and cloud computing platforms to
                                equip learners with the necessary skills to
                                excel in the data science field.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading049">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse049"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What kind
                                of projects will I work on in a Data Science
                                course?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse049"
                            className="collapse"
                            aria-labelledby="heading049"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                In a Data Science curriculum, students undertake
                                diverse real-world endeavors, applying acquired
                                concepts from coursework. The nature of these
                                projects hinges upon the course and its
                                complexity. The following typify projects
                                commonly encountered in Data Science course:
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Exploratory Data Analysis: Participants may
                                  delve into projects requiring dataset
                                  analysis, gleaning pertinent insights and
                                  crafting data visualizations utilizing tools
                                  like Python, R, or Tableau.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Machine Learning Models: Students might
                                  construct machine learning models to address
                                  real-world conundrums, spanning supervised
                                  learning ventures such as image
                                  classification, regression, and classification
                                  problems, as well as unsupervised learning
                                  projects like clustering.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Natural Language Processing: Projects
                                  involving textual data analysis and processing
                                  through Natural Language Processing
                                  techniques—sentiment analysis, topic modeling,
                                  and named entity recognition—may be
                                  undertaken.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Big Data Analytics: Projects necessitating
                                  large dataset processing and analysis might
                                  employ tools like Apache Spark, Hadoop, or
                                  PySpark.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Data Visualization: Participants could work on
                                  crafting interactive data visualizations via
                                  Tableau, D3.js, or ggplot.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Deep Learning: Students may engage in deep
                                  learning model development using frameworks
                                  like TensorFlow or Keras, encompassing
                                  projects such as image recognition, text
                                  classification, and sequence modeling.
                                </li>
                                <br />
                              </ol>
                              <br />
                              <img
                                src="assets/images/mac/project-data-science.jpeg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>
                                In summary, Data Science course offer a
                                plethora of real-life projects, enabling
                                students to apply course concepts and develop
                                their skills through practical, hands-on
                                experiences.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading059">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse059"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Can I
                                switch my career to Data Science after
                                completing a course ?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse059"
                            className="collapse"
                            aria-labelledby="heading059"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                In fact, changing into a Data Science career
                                This is possible after having relevant course.
                                Data Science Course equip you with.
                                necessary insight and skills to be successful in
                                this domain, encompassing programming,
                                machine learning, statistics analysis, data management
                                visualization facets.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Post-course completion, you may pursue
                                employment in Data Science-related roles, such
                                as Data Scientist, Data Analyst, Business
                                Analyst, Data Engineer, or Machine Learning
                                Engineer. The surging demand for data-driven
                                professionals has prompted many organizations to
                                actively recruit individuals for these
                                positions.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Nevertheless, it should be noted that
                                Data Science profession entails becoming
                                commitment and diligence. Merely finishing a
                                As a result, the current course is insufficient; it should be kept up-to-date.
                                emerging technologies and trends remains
                                paramount. Practical experience, accrued by
                                Participation in real-word activities and completing jigsaw
                                portfolio, is indispensable. Networking with
                                seasoned professionals may yield job
                                opportunities and insights gleaned from
                                their experiences.
                              </p>
                              <br />
                              <img
                                src="assets/images/mac/Career-switch.jpg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>
                                In essence, while a Data Science course equips
                                you with a robust foundation for a career shift,
                                continuous learning and hands-on experience are
                                crucial to thrive in this dynamic field.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading069">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse069"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What Is
                                Data Science?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse069"
                            className="collapse"
                            aria-labelledby="heading069"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Data science, a blend of various,
                                disciplines, employs scientific approaches,
                                methodologies, algorithms, and systems to
                                Distill insights and knowledge from the data. This
                                confluence of statistical knowledge,
                                mathematical prowess, computer science
                                expertise, and domain-specific acumen
                                makes it possible to interpret complicated data.
                                phenomena.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                In order to extract knowledge and insights from
                                data, data scientists use a variety of
                                scientific techniques, procedures, algorithms,
                                and systems. To comprehend and interpret
                                complicated processes in data, it combines
                                knowledge and methods from statistics,
                                mathematics, computer science, and domain
                                experience.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The fundamental process of data science is the
                                gathering, processing, and analysis of enormous
                                and complicated data sets in order to glean
                                important knowledge and insights. Data
                                preparation, data cleaning, exploratory data
                                analysis, modelling, and result interpretation
                                are commonly included in this process' several
                                stages.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The process of gathering and organising data
                                from diverse sources, such as databases,
                                spreadsheets, or sensor networks, is known as
                                data preparation. Data cleaning, or the process
                                of identifying and fixing flaws or
                                inconsistencies in the data, may also be
                                involved in this.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Visualising and examining the data to find
                                patterns, trends, and relationships are part of
                                exploratory data analysis. Statistical methods
                                and tools including regression analysis,
                                hypothesis testing, and descriptive statistics
                                are frequently used in this procedure.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                To anticipate future trends or outcomes based on
                                historical data, modelling entails creating and
                                testing statistical or machine learning models.
                                Depending on the type of data and the research
                                objective, these models may be built using
                                supervised or unsupervised learning techniques.
                              </p>
                              <br />
                              <img
                                src="assets/images/mac/who-is-data-scientist.jpg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>
                                Results interpretation include informing
                                pertinent stakeholders of the conclusions and
                                learnings drawn from the data. This could entail
                                producing reports or visualisations that
                                emphasise the most important discoveries and
                                implications from the study.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                As a whole, the topic under discussion is data science are
                                rapidly and are assuming a greater role
                                in different industries such as finance.
                                healthcare, marketing, and many others. It
                                offers a powerful set of tools and techniques in
                                making considerable inferences from large and
                                complex data sets that can help
                                organisations in the process of better decision making.
                                gaining a competitive edge.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading060">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse060"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Who Is Data
                                Scientist ?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse060"
                            className="collapse"
                            aria-labelledby="heading060"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                A data scientist is a professional who works within
                                responsibility for drawing conclusions and information
                                from data by a variety of instruments measured
                                methods. They can work with large companies and
                                Complex data sets due to the dense
                                backgrounds in statistics, arithmetic, computer
                                science, and domain knowledge.
                              </p>
                              <br />
                              <p style={{ fontsize: 14 }}>
                                The primary function of the data scientist is to
                                they collect, analyze and interpret data to
                                provide insightful solutions to challenging
                                situations. They use different tools.
                                strategies of gathering insight and meaning from
                                the information they handle, which may be generated from
                                Structured and non-structed data sources.
                              </p>
                              <br />
                              <p style={{ fontsize: 14 }}>
                                Data scientists frequently have extensive
                                programming experience, especially with
                                languages such as Python, R or SQL. They might
                                should also be familiar with big data technologies
                                like Hadoop, Spark, and others. In order to
                                models and predict based on
                                Through data, they have a deep knowledge of
                                statistical methods and machine learning
                                algorithms.
                              </p>
                              <br />
                              <p style={{ fontsize: 14 }}>
                                Data scientists have technic competence.
                                In solving problems and effective communication.
                                They should be able to communicate
                                conclusions that were difficult to reconcile for both technical and
                                non-technical audiences in collaboration with
                                Teams from different departments produce insights.
                                which are implementable.
                              </p>
                              <br />
                              <br />
                              <img
                                src="assets/images/mac/who-data-scientist.jpg"
                                style={{ width: "140%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>
                                In organisations spanning many different
                                Banking, healthcare and retail
                                , among others, data scientists typically serve a
                                vital role. They employ their technical
                                the ability to gain knowledge and analytical skills.
                                insightful information from data, assisting
                                organisations have been able to make better decisions by
                                foster development and innovation.
                              </p>
                              <br />
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading099">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse099"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Is Data
                                Science certification being worth pursuing as a
                                career?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse099"
                            className="collapse"
                            aria-labelledby="heading099"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                The feasibility of purchasing a Data Science
                                The certification as a career route depends on
                                Many things, including one’s goals.
                                In light of such a background and the current job market.
                                However, earning a certification in Data
                                Science can be very beneficial to
                                people interested in pursuing a career there.
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Demonstrates Aptitude and Proficiency: A Data
                                  Science certification evidences to potential
                                  the employers that an individual has
                                  skill and performance demanded by excellence
                                  in the field. It may act as an affirmation of
                                  skills that help stand out from the herd.
                                  saturated job market.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Increases Remuneration Potential: Based on
                                  Payscale, however for Data Science professionals contain
                                  Certified individuals, on average, make at least ten percent more
                                  those without one. This can be a notable
                                  contributor to enhancing one's earning
                                  potential.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Broadens Career Options: A certification in
                                  Data Science can increase dramatically the amount of accessible information.
                                  As many companies look for
                                  certified professionals to ensure their capability
                                  to fulfill the role's requirements.
                                  Enhances Job Performance: The requisite
                                  training and education for a Data
                                  Science certification can also aid career growth.
                                  performance to get new
                                  techniques, tools, and methodologies. This can
                                  facilitate improving overall job satisfaction
                                  and accomplishment in the field.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Provides Networking Prospects: Several
                                  certification programs offer networking
                                  opportunities, permitting individuals to
                                  Connect with other colleagues from the profession.
                                  This may further lead to the development of
                                  connections, learning from others, and
                                  possibly creating new jobs.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  In conclusion, despite that Data Science
                                  certification is not required for all.
                                  practitioners of the profession.
                                  It is very beneficial in the aspect of
                                  boosting earning potential, expanding career
                                  options, and enhancing job performance. In the
                                  Finally, it depends on the person’s ambitions
                                  circumstances however attaining certification in
                                  Data Science may be an investment in one.
                                  It is a high-paying career.
                                </li>
                                <br />
                                <img
                                  src="assets/images/mac/How-To -Learn-Data-Science.jpg"
                                  style={{ width: "90%" }}
                                  alt=""
                                />
                                <br />
                                <br />
                              </ol>
                              <p style={{ fontsize: 14 }}>
                                To summarize, although acquiring a Data Science
                                certification is not mandatory for all
                                individuals pursuing a profession in the field,
                                it can be incredibly advantageous in terms of
                                boosting earning potential, expanding career
                                options, and enhancing job performance. In the
                                end, it hinges on the individual's goals and
                                circumstances, but obtaining a certification in
                                Data Science can be an investment in one's
                                career that is well worth it.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading109">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse109"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Is obtaining
                                a certification in data science worth
                                considering ?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse109"
                            className="collapse"
                            aria-labelledby="heading109"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                In fact, data science and analytics are unlocking
                                provide several job opportunities in numerous
                                different industries around the world.
                                Companies these days are aware of the significance
                                analyze past records in order to come up with good decisions
                                decisions and enhance operations. The generation
                                The amount of information has also increased as a result
                                of nearly every sector in trade, which
                                It enables an analysis and interpretation of it. The
                                The demand for Data Science and Analytics
                                In turn, the number of specialists has grown and more
                                However, the income got in this field are
                                high and repute themselves as the best in.
                                industry. The occupation of a Data Scientist is also
                                long and prosperous since it will ever
                                require individuals with these skills
                                the fact that online
                                data collected.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading119">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse119"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Why be a
                                Data Scientist?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse119"
                            className="collapse"
                            aria-labelledby="heading119"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                The United States Bureau of Labour Statistics
                                predicts that the area of data science would
                                grow at an extraordinary pace of 28% and have
                                11.5 million job vacancies by 2026. Furthermore,
                                a Glassdoor poll revealed that, with a typical
                                base compensation of $113,309 annually, data
                                scientist is among the highest-paying
                                professions in the US.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                There are other advantages to pursuing a career
                                in data science in addition to the high demand
                                and good compensation. For instance, a Kaggle
                                survey indicated that 78% of respondents who
                                work as data scientists find their work to be
                                intriguing and challenging, which stimulates
                                their minds.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Additionally, the discipline of data science
                                provides a lot of flexibility and adaptability.
                                Data scientists have the chance to work in
                                several businesses and put their abilities to
                                use solving a number of issues. This implies
                                that there are always fresh obstacles to
                                overcome and chances for progress and
                                advancement in this area.
                              </p>
                              <br />
                              <img
                                src="assets/images/mac/Data-Science-skills.jpg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>
                                Overall, for people who have a passion for
                                analytics and problem-solving, data science is
                                an appealing and fulfilling career choice due to
                                the combination of high demand, competitive
                                compensation, intellectual stimulation, and
                                versatility.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading139">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse139"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Do I need to
                                know statistics before enrolling in a Data
                                Science course ?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse139"
                            className="collapse"
                            aria-labelledby="heading139"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Before enrolling in a Data Science course, it is
                                not strictly necessary to have a background in
                                statistics, however having a fundamental
                                understanding of statistical principles might be
                                useful. This is due to the fact that many Data
                                Science approaches, like hypothesis testing,
                                regression analysis, and machine learning
                                algorithms, are built on the basis of
                                statistics.
                              </p>
                              <br />
                              <img
                                src="assets/images/mac/statistic-analysis-methods.jpg"
                                style={{ width: "90%" }}
                                alt=""
                              />
                              <br />
                              <br />
                              <p style={{ fontsize: 14 }}>
                                Before enrolling in a Data Science course, it
                                may be beneficial for someone who is completely
                                new to statistics to take a basic statistics
                                course or read a statistics textbook. This will
                                assist you in comprehending key ideas like
                                probability, variance, and correlation, which
                                are crucial to comprehending and using data.
                              </p>
                              <p style={{ fontsize: 14 }}></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div id="tab025" className="tab-pane">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading00">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse00"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What does a
                            Data Scientist do ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse00"
                        className="collapse"
                        aria-labelledby="heading00"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            A data connoisseur serves as an adept in deciphering
                            and construing intricate conglomerations of
                            information, employing sophisticated statistical and
                            computational methodologies to acquire enlightenment
                            and formulate resolutions that bolster enterprise
                            efficacy, scientific inquiry, or additional domains
                            of exploration.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            The vocation of a data connoisseur entails several
                            quintessential duties, encompassing:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Procuring and administrating information: Data
                              connoisseurs must possess the prowess to amass and
                              oversee voluminous and multifarious data
                              collections from disparate origins, such as
                              databases, APIs, and an array of structured and
                              unstructured sources.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Purifying and readying information: Data
                              compilations frequently harbor inaccuracies,
                              incongruities, or deficient particulars,
                              necessitating data connoisseurs to cleanse,
                              preprocess, and transmute the information into an
                              apposite configuration for examination.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Investigating and illustrating information: Data
                              connoisseurs employ a cornucopia of statistical
                              and machine learning stratagems to delve into and
                              unveil patterns, connections, and tendencies
                              within the information. They also capitalize on
                              data visualization instruments to convey their
                              discoveries in a lucid and succinct fashion.
                            </li>
                            <br />
                            <img
                              src="assets/images/mac/what-does-data-scientist-responsibility.jpg"
                              style={{ width: "90%" }}
                              alt=""
                            />
                            <br />
                            <br />
                            <li style={{ fontsize: 14 }}>
                              Constructing prognostic models: Data connoisseurs
                              harness statistical modeling techniques to
                              establish prognostic models that can predict
                              forthcoming trajectories, conduct, or occurrences.
                              These models serve to inform decision-making,
                              pinpoint opportunities, and enhance procedures.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Disseminating enlightenment: Data connoisseurs
                              must exhibit the capacity to convey their findings
                              and acumen to an extensive array of stakeholders,
                              such as corporate leaders, technical squads, and
                              other interested parties. This necessitates
                              exceptional communication and presentation
                              aptitude, in conjunction with the ability to
                              transmute technical notions into layman's terms.
                            </li>
                          </ol>
                          <p style={{ fontsize: 14 }}>
                            In summary, a data connoisseur occupies an
                            indispensable position in metamorphosing information
                            into practicable revelations that can propel
                            corporate triumph and ingenuity.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading01">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse01"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How are Data
                            Scientists different from Business Analysts or Data
                            Analysts ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse01"
                        className="collapse"
                        aria-labelledby="heading01"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Although the responsibilities of data scientists,
                            business analysts, and data analysts are very
                            similar, there are some significant variances
                            between these roles.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Within a single department or function, business
                            analysts often concentrate on leveraging data to
                            solve particular business problems. They collaborate
                            closely with stakeholders to find areas for
                            improvement, create specifications, and put into
                            place solutions that address company demands.
                            Business analysts frequently have a deep awareness
                            of project management approaches, market trends, and
                            business procedures.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            On the other hand, data analysts concentrate on
                            gathering, sanitising, and analysing data to
                            generate insights or provide answers to certain
                            problems. They investigate links and trends in the
                            data using statistical and analytical techniques,
                            and then they produce reports or dashboards to
                            present their results. Data management, data
                            governance, and quality assurance responsibilities
                            are frequently performed by data analysts.
                          </p>
                          <br />
                          <img
                            src="assets/images/mac/Data-SCIENTIST-VS-DATA-ANALYST.jpg"
                            style={{ width: "90%" }}
                            alt=""
                          />
                          <br />
                          <br />
                          <p style={{ fontsize: 14 }}>
                            In order to produce insights that can drive business
                            strategy and innovation, data scientists have a
                            broader emphasis, fusing parts of both business
                            analysis and data analysis. To find patterns,
                            trends, and opportunities in huge and complicated
                            data sets, data scientists employ a variety of
                            analytical tools, machine learning algorithms, and
                            statistical modelling techniques. They are
                            proficient in both descriptive and predictive
                            analytics, which enables them to not only comprehend
                            the past but also predict future patterns and
                            behaviours.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Data scientists can work with massive, unstructured
                            data sets and develop scalable solutions that may be
                            leveraged to add value to businesses since they have
                            strong programming and data management skills. To
                            pinpoint business issues, plan trials, and create
                            solutions that can be incorporated into current
                            workflows, they collaborate closely with
                            stakeholders.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            In Shorts, data scientists combine components of
                            both disciplines to give strategic insights and add
                            value for the organisation, whereas business
                            analysts concentrate on addressing particular
                            business problems and data analysts concentrate on
                            analysing data to generate insights.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Data Science
                            <b style={{ fontSize: 25, color:"#9769ef" }}>Course Fees</b> in Bangalore ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>Data Science Course Fee is 72,000/-</p>
                          <p style={{ fontsize: 14 }}>
                            There is Discount in Data Science Classes of 15%
                            Discount for First 15 people who join the classes.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading03">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse03"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Who Should do
                            Data Science Course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse03"
                        className="collapse"
                        aria-labelledby="heading03"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Data science curricula cater to individuals
                            captivated by data manipulation, keen on honing
                            their prowess in data examination, statistics, and
                            programming. Here are specific demographics who
                            stand to gain from a data science program:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Aspiring data scientists: Individuals aspiring for
                              a data science vocation can reap benefits from a
                              data science curriculum. It provides a robust
                              foundation in data scrutiny, statistical modeling,
                              machine learning, and programming—crucial skills
                              for a data connoisseur.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Business analysts and data analysts: Professionals
                              in business analyst or data analyst roles can also
                              profit from a data science program. The course
                              bolsters their data dissection and visualization
                              aptitude and imparts knowledge of sophisticated
                              statistical and machine learning methodologies,
                              augmenting job performance.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              IT professionals: IT specialists handling data and
                              desiring to acquire novel data analysis and
                              programming competencies can benefit from a data
                              science program. The course imparts understanding
                              of data administration, data warehousing, and big
                              data technologies—significant skills in today's
                              data-centric landscape.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Researchers and academics: Researchers and
                              academicians across social sciences, natural
                              sciences, and engineering disciplines can likewise
                              profit from a data science program. The course
                              equips them with the skills and tools necessary
                              for dissecting and construing voluminous and
                              intricate data compilations, fostering more
                              informed conclusions and hypotheses.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Entrepreneurs: Entrepreneurs seeking to establish
                              a data-driven enterprise can benefit from a data
                              science program. The course facilitates
                              comprehension of data analytics, machine learning,
                              and other technologies instrumental in devising
                              innovative solutions and products.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading04">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse04"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>When to do a
                            Data Science Course
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse04"
                        className="collapse"
                        aria-labelledby="heading04"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            When to take a data science course depends on the
                            goals, career aspirations, and skill level of the
                            individual. When determining whether to enrol in a
                            data science course, keep the following things in
                            mind:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Prerequisites: Anyone can begin a data science
                              course at any time who has a basic understanding
                              of statistics, mathematics, and programming. But
                              before enrolling in a data science course, folks
                              without any prior understanding in these fields
                              might need to complete basic courses.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Career aspirations: Anyone interested in a career
                              in data science should think about enrolling in a
                              data science course as soon as possible. They will
                              acquire the abilities and information required to
                              compete on the job market as a result. However, if
                              someone is already employed in a related sector,
                              such as business analysis or data analysis, they
                              might want to hold off on enrolling in a data
                              science school until they have some experience.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Accessibility: Since many data science course are
                              offered online, students can enrol at any time.
                              Some courses, however, may not be ideal for
                              everyone since they have set timetables or call
                              for attendance at certain times.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Learning preferences: While some people like to
                              take structured courses with a teacher or mentor,
                              others prefer to learn through independent study.
                              When considering whether or not to enrol in a data
                              science course, individuals should take their
                              chosen learning style into account.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Budget: Because data science course can be
                              pricey, people should think about their budget
                              before enrolling in one. Some programs include
                              scholarships or financial aid, which might lower
                              the cost.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading05">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse05"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Duration of
                            Data Science Course
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse05"
                        className="collapse"
                        aria-labelledby="heading05"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Yes, there are plenty of job opportunities available
                            in the field of Data Science and Analytics across
                            various industries globally. As businesses have
                            realized the significance of using historical data
                            for informed decision-making and improving their
                            operations, digitalization has enabled the
                            generation and analysis of vast amounts of data.
                            This has created numerous job openings in the data
                            science and analytics space. The demand for skilled
                            Data Scientists far exceeds the supply, resulting in
                            high salaries and being regarded as one of the
                            best-paying industries. The Data Scientist career
                            path is promising and rewarding as the amount of
                            online data generated is continually increasing in
                            the future.
                          </p>
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => setTg(!toggle)}
                      className="btn btn-primary mb-3 viewmorebtn"
                    >
                      {toggle ? "View Less" : "View More"}
                    </button>

                    {toggle && (
                      <div className="morefaq">
                        <div className="card">
                          <div className="card-header" id="heading06">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse06"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Does
                                Logicmojo offer job assistance after completing
                                data science course?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse06"
                            className="collapse"
                            aria-labelledby="heading06"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                At Logicmojo, we offer placement assistance to
                                all learners who have successfully completed our
                                course in data science. We have
                                collaborated with over 80 top MNCs worldwide,
                                ensuring that our learners get the best possible
                                opportunities to work in reputed organizations
                                such as TCS, Sony, Ericsson, Cisco, Cognizant,
                                Mu Sigma, Standard Chartered, and many more. Our
                                team also provides support with job interview
                                preparation and resume building.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading07">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse07"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Is doing a
                                Data Science course worth it?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse07"
                            className="collapse"
                            aria-labelledby="heading07"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Certainly! Data Science is a highly rewarding
                                career path due to the high demand for experts
                                in this field, lucrative salaries, and the
                                significant value that it adds to businesses
                                across diverse industries.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading08">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse08"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Is coding
                                required to learn Data Science
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse08"
                            className="collapse"
                            aria-labelledby="heading08"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Occasionally. Although advanced coding skills
                                are not mandatory, learners should feel at ease
                                with data analytics, management, and
                                visualization.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Basic knowledge of programming languages like
                                C/C++, Python, R, Java, or SQL can enhance the
                                learning process. Acquiring expertise in any of
                                these programming languages can aid in
                                organizing unstructured datasets.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading09">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse09"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What skills
                                will help during the Data Science course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse09"
                            className="collapse"
                            aria-labelledby="heading09"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                The following abilities can help you learn more
                                effectively.
                              </p>
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                  Mathematical concepts: Knowledge of matrices,
                                  gradients, linear algebra, calculus, and other
                                  related topics can be useful in a variety of
                                  professions.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Programming Knowledge: Knowing how to build
                                  effective code and automate activities using
                                  languages like Python, Java, SQL, C, and C++.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Data processing: You can analyse and draw
                                  conclusions from sizable datasets with the
                                  help of knowledge of data mining, data
                                  processing, and data modelling approaches.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Advanced Statistical Analysis: You can carry
                                  out complex statistical analyses if you have
                                  knowledge of analytical tools like Hadoop,
                                  SAS, R, etc.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Data visualisation abilities can assist you in
                                  representing complex data in a clear and
                                  intelligible way. Examples of such tools
                                  include Matplotlib, Tableau, and others.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading11">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse11"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Why online
                                Data Science Course better than Offline
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse11"
                            className="collapse"
                            aria-labelledby="heading11"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Digital Data Science Education: A Rising Trend
                                with Compelling Advantages
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Over recent years, the popularity of online data
                                science courses has grown due to their ease of
                                access, adaptability, and affordability. Here
                                are several reasons why online data science
                                courses may surpass their traditional offline
                                counterparts:
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Convenience: Online data science course
                                  enable learners to study from any location and
                                  at any time. This flexibility allows
                                  individuals to progress at their own speed and
                                  accommodate the course within their
                                  professional or personal schedules. This
                                  adaptability is especially beneficial for
                                  those unable to attend in-person classes due
                                  to geographical or timing constraints.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Affordability: Online data science course
                                  frequently cost less than their offline
                                  equivalents. The absence of physical
                                  classrooms and the elimination of travel,
                                  accommodation, and other expenses contribute
                                  to the reduced fees.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Resource Availability: Online data science
                                  courses often grant access to an extensive
                                  array of resources, including digital
                                  libraries, video lectures, and discussion
                                  forums. This enables learners to gain
                                  knowledge from experts and stay current with
                                  the latest research and industry developments.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Engaging Learning: Online data science course
                                  commonly employ interactive learning tools,
                                  such as quizzes, simulations, and virtual
                                  laboratories, to facilitate the understanding
                                  and application of concepts. These resources
                                  can be especially effective in helping
                                  learners grasp intricate data science ideas
                                  and methodologies.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Practical Applications: Online data science
                                  courses frequently incorporate real-world case
                                  studies and projects, allowing learners to
                                  apply their newly-acquired knowledge to
                                  tangible problems. This approach can help
                                  individuals hone practical skills and assemble
                                  a portfolio that showcases their abilities to
                                  prospective employers.
                                </li>
                              </ol>
                              <p style={{ fontsize: 14 }}>
                                In summary, online data science course can
                                offer numerous advantages over traditional
                                offline courses, including convenience,
                                affordability, resource accessibility, engaging
                                learning experiences, and real-world
                                applications. However, it is crucial to
                                thoroughly investigate and assess online courses
                                to ensure their credibility, quality, and the
                                provision of essential skills and knowledge for
                                a successful data science career.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading12">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse12"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Data Science
                                Course Admission Process
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse12"
                            className="collapse"
                            aria-labelledby="heading12"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                The admission procedure for a data science
                                course can vary based on factors such as the
                                course duration, the number of classes and
                                subjects chosen, and the course level
                                (undergraduate or postgraduate degree).
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Skills Required for Data Science Course:
                                  <br />
                                  Prior knowledge of programming languages is a
                                  primary prerequisite for learning data
                                  science, especially Python, Perl, C/C++, SQL,
                                  and Java. Python is the most commonly used
                                  language for programming and developing apps.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Eligibility:
                                  <br />
                                  There is no age bar for pursuing a data
                                  science course, and many professional courses
                                  in the field are available on various online
                                  academic sites. However, to be eligible for a
                                  data science course, you need to have a
                                  background in science or mathematics and
                                  computer applications in senior secondary
                                  school. Economics or commerce and computer
                                  applications are also accepted for eligibility
                                  to pursue a data science course.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Data Science Course Admission 2022:
                                  <br />
                                  Data science is offered at the undergraduate
                                  and postgraduate levels, as well as a
                                  part-time or diploma course, so the admission
                                  procedure can vary from college to college.
                                  Universities typically determine the dates for
                                  examinations and interviews, and some may base
                                  admissions on high school performances. Some
                                  diploma and certification courses may not
                                  require entrance examination ranks, but high
                                  marks in your 12th board examination are
                                  typically required.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Data Science Course Entrance Exams:
                                  <br />
                                  Data science course can be pursued as an
                                  undergraduate course, a postgraduate course,
                                  or a PG diploma course for working
                                  professionals, and all of these options are
                                  available online.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading13">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse13"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Data Science
                                Course without Entrance
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse13"
                            className="collapse"
                            aria-labelledby="heading13"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Admission requirements for data science course
                                vary among universities and colleges, as the
                                field is interdisciplinary. For instance, IIT
                                Madras does not mandate that students take an
                                entrance exam for their data science course.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading14">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse14"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Data
                                Science Course Syllabus
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse14"
                            className="collapse"
                            aria-labelledby="heading14"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                A cornucopia of specializations exists within
                                data science, enabling students to pursue areas
                                that align with their aspirations and
                                professional objectives. Several sought-after
                                specializations include:
                              </p>
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                  Machine Learning: A concentration in machine
                                  learning empowers Data Scientists to
                                  contribute to the development of innovative
                                  algorithms, facilitating the autonomous
                                  operation of models and supporting the broad
                                  implementation of theoretical frameworks
                                  devised through data science.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Data Mining: Data excavation delves into the
                                  dissection of myriad data collections to
                                  extract valuable insights. Data Scientists
                                  specializing in this domain master the art of
                                  integrating predictive models and statistical
                                  methodologies to discern patterns germane to
                                  specific datasets.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Quality Analysis: The application of data
                                  science in quality evaluation yields positive
                                  repercussions for enterprises and sectors
                                  reliant on voluminous data. Data Scientists
                                  adept in quality evaluation can architect
                                  models contingent on particular statistical
                                  information, deriving analytical intel to
                                  enhance business quality.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Business Intelligence: Enterprise acumen
                                  entails the formulation of an organization's
                                  future stratagems by scrutinizing critical
                                  factors such as revenue, operational tempo,
                                  lead conversion and generation, among others.
                                  Data Scientists can devise algorithms that
                                  tackle hypothetical queries and produce
                                  analytical dossiers to inform decision-making
                                  processes.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Digital Analytics: In digital analysis, Data
                                  Scientists grapple with unstructured data,
                                  encompassing visuals and multimedia,
                                  originating from social media channels. They
                                  contribute to the development of analytical
                                  instruments that transmute raw data into
                                  comprehensible analytical reports.
                                </li>
                              </ul>
                              <p style={{ fontsize: 14 }}>
                                These disciplines provide a thorough
                                comprehension of data science, endowing learners
                                with the requisite abilities and erudition to
                                thrive in this domain. They encompass the
                                fundamental notions, methodologies, and
                                apparatuses employed in data science, forming an
                                indispensable foundation for any ambitious data
                                scientist.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Below are the advanced topic of Data Science
                                Course :
                              </p>
                              <ul>
                                <li style={{ fontsize: 14 }}>Introduction to Data Science</li>
                                <li style={{ fontsize: 14 }}>Mathematical and Statistical Skills</li>
                                <li style={{ fontsize: 14 }}>Machine Learning</li>
                                <li style={{ fontsize: 14 }}>Coding</li>
                                <li style={{ fontsize: 14 }}>Algorithms for Machine Learning</li>
                                <li style={{ fontsize: 14 }}>
                                  Statistical Foundations for Data Science
                                </li>
                                <li style={{ fontsize: 14 }}>Data Structures and Algorithms</li>
                                <li style={{ fontsize: 14 }}>Data Structures and Algorithms</li>
                                <li style={{ fontsize: 14 }}>Optimization Techniques</li>
                                <li style={{ fontsize: 14 }}>Data Visualization</li>
                                <li style={{ fontsize: 14 }}>Matrix Computations</li>
                                <li style={{ fontsize: 14 }}>Scholarly Models</li>
                                <li style={{ fontsize: 14 }}>
                                  Experimentation, Evaluation, and Project
                                  Deployment Tools
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Predictive Analytics and Segmentation using
                                  Clustering
                                </li>
                                <li style={{ fontsize: 14 }}>Applied Mathematics and Informatics</li>
                                <li style={{ fontsize: 14 }}>Exploratory Data Analysis</li>
                                <li style={{ fontsize: 14 }}>
                                  Business Acumen and Artificial Intelligence
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading15">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse15"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>You May
                                Question If Data Science Certification Is Worth
                                It
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse15"
                            className="collapse"
                            aria-labelledby="heading15"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Yes, completing a Data Science or Analytics
                                course can lead to numerous job opportunities
                                across various industries worldwide. Businesses
                                have come to recognize the importance of
                                analyzing historical data to make informed
                                decisions and enhance their operations. With
                                digitalization becoming prevalent across all
                                business domains, generating data and enabling
                                its analysis has become easier, resulting in the
                                creation of many job openings in Data Science
                                and Analytics. Due to the huge demand and supply
                                gap for Data Scientists, salaries in this field
                                are quite high and considered among the best in
                                the industry. Moreover, the Data Scientist
                                career path is both lucrative and long-term, as
                                the amount of online data being generated is
                                constantly increasing and is expected to
                                continue doing so in the future.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading16">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse16"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Why
                                Logicmojo Is The Best Data Science Course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse16"
                            className="collapse"
                            aria-labelledby="heading16"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Logicmojo offers versatile Data Science
                                certification training through various channels,
                                including online, in-person, and self-paced
                                digital courses. Our teaching curriculum aims to
                                provide well-rounded knowledge and practical
                                experience in the field of Data Science.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The web-based learning program delivers a
                                captivating educational experience, fostering
                                interaction with experienced professionals and
                                peers in virtual classrooms. On the other hand,
                                in-person training offers an immersive learning
                                journey in a physical environment, guided by
                                skilled instructors. Additionally, the
                                self-paced digital certification course allows
                                for flexibility in learning at your desired pace
                                and convenience.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Our Data Science certification course covers a
                                wide range of topics, such as data analysis,
                                data visualization, machine learning,
                                statistical evaluation, and programming
                                languages like Python and R. The course's goal
                                is to equip you with the skills and
                                understanding needed to excel in the Data
                                Science field.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Explore our website for a comprehensive course
                                outline, detailing the course structure,
                                modules, learning objectives, and assessment
                                criteria. Furthermore, we provide additional
                                educational resources, including study
                                materials, practice exams, and expert advice, to
                                support your success both in the course and your
                                career.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Our Data Science certification course
                                is thoughtfully designed to endow you with the
                                knowledge, insight, and practical experience
                                necessary for thriving in the Data Science
                                landscape, regardless of your beginner or
                                advanced status.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading17">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse17"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Is Logicmojo
                                Data Science course only for people with a
                                background in computer science or mathematics
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse17"
                            className="collapse"
                            aria-labelledby="heading17"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                  The Logicmojo Data Science course is open to
                                  everyone, regardless of background in maths or
                                  computer science. Regardless of their
                                  educational background or past experience in
                                  the subject, our Data Science course is made
                                  to accommodate a wide spectrum of students.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Our course is designed so that students may
                                  gradually increase their understanding of Data
                                  Science concepts and methods by starting with
                                  the basics and working their way up to more
                                  complex topics. To ensure that students have
                                  access to all the support they need to succeed
                                  in the course, we offer thorough learning
                                  tools, including study materials, practise
                                  exams, and professional guidance.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Although it might be advantageous in some
                                  circumstances, our Data Science course does
                                  not require prior knowledge of computer
                                  science or mathematics. We think that anyone
                                  with a passion for data science and an open
                                  mind may profit from our course and pursue a
                                  rewarding career in it.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  In fact, since this can contribute a diversity
                                  of viewpoints and ideas to the learning
                                  environment, we actively encourage students
                                  from a variety of educational and professional
                                  backgrounds to enrol in our course. Our
                                  objective is to provide accessibility to Data
                                  Science so that everyone can pursue careers in
                                  this fascinating and quickly expanding
                                  profession.
                                </li>
                                <br />
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading18">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse18"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>I am
                                freshers , can i do Data Science Course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse18"
                            className="collapse"
                            aria-labelledby="heading18"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                  You can absolutely enrol in a Data Science
                                  course as a freshmen. Data science is a
                                  discipline that uses statistical and
                                  computational methods to glean knowledge and
                                  insights from data. Increasing demand for
                                  qualified data scientists across numerous
                                  businesses has made it a popular career
                                  choice.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  In order to obtain insights and make wise
                                  judgements, data scientists work in a rapidly
                                  expanding subject called data science. Your
                                  ability to work with data, including data
                                  analysis, data visualisation, statistical
                                  analysis, and machine learning, will be
                                  enhanced by taking a data science course.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  While some prior programming, mathematical, or
                                  statistical knowledge may be advantageous, it
                                  is not necessarily necessary. Numerous Data
                                  Science courses are created to be inclusive of
                                  students with all educational backgrounds and
                                  skill levels, and they provide in-depth
                                  learning tools to make sure that students get
                                  the assistance they need to be successful in
                                  the course.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Additionally, enrolling in a Data Science
                                  course as a new student can be beneficial
                                  since it gives you a strong foundation in the
                                  subject and prepares you to compete for
                                  entry-level positions in the sector. Pursuing
                                  a Data Science course can be a wonderful
                                  approach to launch a lucrative career in this
                                  interesting sector given the growing demand
                                  for Data Scientists across numerous
                                  businesses.
                                </li>
                                <br />
                                <li style={{ fontsize: 14 }}>
                                  Pursuing a Data Science course as a fresher
                                  can be a terrific way to jump-start your
                                  career and open up a world of options if you
                                  have an interest in data science and a
                                  willingness to study.
                                </li>
                                <br />
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading19">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse19"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What is the
                                salary of a Data Scientist after completing a
                                Data Science Course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse19"
                            className="collapse"
                            aria-labelledby="heading19"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Salary Ranges for Data Scientists
                                <ul>
                                  <li style={{ fontsize: 14 }}>
                                    <b>Entry-Level Data Scientists</b>
                                  </li>
                                  <p style={{ fontsize: 14 }}>
                                    Entry-level data scientists, typically with
                                    less than three years of experience, can
                                    expect to earn an average salary of around
                                    $80,000 to $100,000 per year.
                                  </p>

                                  <li style={{ fontsize: 14 }}>
                                    <b>Mid-Level Data Scientists</b>
                                  </li>
                                  <p style={{ fontsize: 14 }}>
                                    Data scientists with 3 to 7 years of
                                    experience can expect to earn an average
                                    salary of around $100,000 to $130,000 per
                                    year.
                                  </p>

                                  <li style={{ fontsize: 14 }}>
                                    <b>Senior-Level Data Scientists</b>
                                  </li>
                                  <p style={{ fontsize: 14 }}>
                                    Senior data scientists, with over 7 years of
                                    experience or in leadership roles, can earn
                                    an average salary of around $130,000 to
                                    $180,000 per year, with some even surpassing
                                    the $200,000 mark.
                                  </p>
                                </ul>
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading20">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse20"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Do I Need To
                                Have Strong Programming Skills To Be A Data
                                Scientist
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse20"
                            className="collapse"
                            aria-labelledby="heading20"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Data science comprises myriad processes for data
                                examination and the extraction of insights from
                                data. Programming is an indispensable facet of
                                data science, though the degree of programming
                                aptitude required may hinge on the particular
                                job role and sector. In general, possessing a
                                sturdy foundation in programming is crucial to
                                excel in data science, but the scope of
                                proficiency necessitated may oscillate according
                                to project stipulations.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Here are several rationales elucidating the
                                import of potent programming skills for data
                                scientists:
                              </p>
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                  Data handling : Data scientists grapple with
                                  copious datasets demanding adroit
                                  manipulation, cleansing, and processing.
                                  Mastery of programming languages such as
                                  Python or R is imperative for efficacious data
                                  administration, purification, and
                                  transmutation into an analyzable format.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Data Analysis : Upon data preparation, data
                                  scientists employ statistical analysis,
                                  machine learning algorithms, and additional
                                  data modeling techniques to unveil significant
                                  insights. These methodologies are executed
                                  using programming languages, and a thorough
                                  comprehension of programming principles is
                                  requisite for the efficacious development and
                                  application of these techniques.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Automation: Data scientists frequently
                                  undertake the automation of data processing
                                  tasks to conserve resources and enhance
                                  efficiency. Programming acumen is vital for
                                  devising scripts that automate data processing
                                  tasks, ensuring uniform outcomes.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Communication: Lastly, programming expertise
                                  is required for effectively conveying results.
                                  Data scientists must generate visualizations
                                  and reports lucidly conveying insights to
                                  stakeholders, necessitating mastery in
                                  programming languages and data visualization
                                  instruments.
                                </li>
                              </ul>
                              <p style={{ fontsize: 14 }}>
                                Nonetheless, it is crucial to acknowledge that
                                the specific programming proficiencies demanded
                                for a data scientist may vary contingent on the
                                industry and job role. For instance, a data
                                scientist in the healthcare domain may
                                necessitate SQL and SAS proficiency, while a
                                data scientist in the finance realm may require
                                Python and R expertise.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Possessing potent programming skills is
                                indispensable for thriving in data science, but
                                the level of proficiency required may diverge
                                based on the particular job role and sector.
                                Irrespective of the industry or job role,
                                programming is an essential instrument for
                                managing data, extracting insights, automating
                                processes, and communicating results effectively
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading21">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse21"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>How to do a
                                Data Science Course in India
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse21"
                            className="collapse"
                            aria-labelledby="heading21"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Comprehensive stages for embarking on a data
                                science curriculum in India:
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Grasp data science's purview: Prior to
                                  initiation, it is paramount to comprehend the
                                  essence of data science and the array of
                                  specializations at hand. Data science is an
                                  interdisciplinary domain encompassing
                                  statistics, mathematics, and computer science.
                                  Depending on high school subjects, pupils may
                                  delve into niches such as machine learning,
                                  artificial intelligence, and voluminous data.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Scour dependable online data science course:
                                  An abundance of online platforms proffer data
                                  science curricula in India. Scholars can
                                  peruse these sites, opting for courses
                                  aligning with their budget, syllabus, and
                                  duration preferences. Selecting a trustworthy
                                  platform furnishing quality education is
                                  vital, and courses should be facilitated by
                                  seasoned data scientists or industry
                                  connoisseurs.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Gear up for entrance examinations: Certain
                                  universities and colleges might necessitate
                                  entrance exams for data science course
                                  admissions. Pupils should investigate the
                                  admission prerequisites of their targeted
                                  institutions and ready themselves for the
                                  entrance assessments accordingly. For online
                                  curricula, entrance exams may be optional.
                                  Nevertheless, possessing a foundational
                                  understanding of concepts to excel in the
                                  course is prudent.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Excel in interview rounds: Upon clearing
                                  entrance exams (if applicable), students might
                                  be summoned for interviews with colleges or
                                  universities. Interviewers may pose inquiries
                                  pertaining to data science and the course
                                  outline. Adequate preparation for the
                                  interview, researching prevalent data science
                                  inquiries, and maintaining authenticity in
                                  responses are crucial.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Register for the course and attend lectures:
                                  After triumphing in the entrance examination
                                  and interview, students can enroll in their
                                  preferred data science course. It is
                                  imperative to attend all lectures, take notes,
                                  and thoroughly comprehend concepts. Sustaining
                                  motivation and commitment to the course
                                  ensures optimal outcomes.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Hone coding and data analysis skills: Data
                                  science demands proficiency in coding and data
                                  analysis, necessitating regular practice.
                                  Pupils can engage in coding contests and
                                  refine data analysis skills using authentic
                                  datasets. Additionally, involvement in online
                                  forums and communities can provide invaluable
                                  insights from experienced data scientists.
                                </li>
                              </ol>
                              <p style={{ fontsize: 14 }}>
                                Logicmojo data science curriculum is the
                                preeminent course for data science in India,
                                encompassing all the aforementioned stages
                                within its Live Classes.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div id="tab026" className="tab-pane">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading00">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse00"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Study Data
                            Science Courses in India
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse00"
                        className="collapse"
                        aria-labelledby="heading00"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            There are many resources available to help you
                            prepare for a career in data science. Logicmojo
                            clsses is the best choice:
                          </p>
                          <p style={{ fontsize: 14 }}>
                            <b>Logicmojo :</b>
                          </p>
                          <p style={{ fontsize: 14 }}>
                            This live course on data science is one of the most
                            enrolled and highly rated course collections on this
                            list. Logicmojo did an incredible job with the
                            balance of breadth and depth in the curriculum.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            This Data Science specialization is an ideal mix of
                            theory and application using the Python programming
                            language. As far as prerequisites go, you should
                            have some programming experience and you have a good
                            understanding of Algebra. Previous knowledge of
                            Linear Algebra and/or Calculus isn’t necessary, but
                            it is helpful.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            They cover all aspects of data science, starting
                            with the basics of programming (binary, loops,
                            number systems, etc.) to intermediate programming
                            topics (arrays, OOPs, sorting, recursion, etc.) to
                            ML Engineering (NLP, Reinforcement Learning,
                            TensorFlow, Keras, etc.) and advanced programming
                            topics (Deep learning, DB and System design,
                            Predictive modeling, Hashing, Greedy, etc.).
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Logicmojo provides 250+ hours of live online
                              interactive classroom
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Recorded videos of the sessions are promptly made
                              available so that you can study at your own pace,
                              outside the confines of a classroom.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Logicmojo has dedicated career support, 1:1
                              mentorship programs with Machine Learning
                              Engineers and Data Scientists, and a strong
                              student community on Slack.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Regular assignments, tests and 15+ real time
                              projects help you enhance your skills.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Life-time access contents that are all class
                              recordings are provided in the form of recorded
                              lectures after the end of class.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Helps you prepare for interviews by conducting
                              mock interviews.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Provide you with ongoing support after you
                              complete the course, building your confidence day
                              by day.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading01">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse01"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Study Data
                            Science Courses in Abroad
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse01"
                        className="collapse"
                        aria-labelledby="heading01"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>Data Science Course in the USA</p>
                          <p style={{ fontsize: 14 }}>
                            Best universities in the USA for pursuing an MS in
                            Data Science
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>Stanford University</li>
                            <li style={{ fontsize: 14 }}>Harvard University</li>
                            <li style={{ fontsize: 14 }}>Yale University</li>
                            <li style={{ fontsize: 14 }}>University of Pennsylvania</li>
                            <li style={{ fontsize: 14 }}>Columbia University</li>
                            <li style={{ fontsize: 14 }}>New York University</li>
                            <li style={{ fontsize: 14 }}>Duke University</li>
                          </ul>

                          <p style={{ fontsize: 14 }}>Data Science in the UK</p>
                          <p style={{ fontsize: 14 }}>
                            Best universities in the UK for pursuing an MS in
                            Data Science
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>King’s College London</li>
                            <li style={{ fontsize: 14 }}>Imperial College London</li>
                            <li style={{ fontsize: 14 }}>University of Edinburgh</li>
                            <li style={{ fontsize: 14 }}>
                              The London School of Economics and Political
                              Science
                            </li>
                            <li style={{ fontsize: 14 }}>University of Oxford</li>
                            <li style={{ fontsize: 14 }}>University of Bath</li>
                            <li style={{ fontsize: 14 }}>University of Manchester</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Growing demand
                            for Data Science course in India is gaining
                            momentum
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Data Science has emerged as a highly lucrative
                            career option, witnessing a significant surge in
                            demand for skilled professionals in India in recent
                            years. The outbreak of COVID-19 saw the successful
                            implementation of Data Science applications in the
                            healthcare sector, where the collection and analysis
                            of patient-related data helped authorities to make
                            informed decisions.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Data has become a global currency, and the field of
                            Data Science has become alluring to students and
                            companies alike. Businesses have realized the
                            significance of Data Science in driving success,
                            where properly analyzed data can reveal insights
                            into customer preferences and trends and aid in
                            predicting future trends using predictive models. In
                            this entire process, Data Science plays a vital
                            role.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            The job of a Data Scientist entails collecting,
                            analyzing, and interpreting data sets separated from
                            a vast data pool. This process can be simplified
                            with the use of specialized tools and machine
                            learning algorithms. Such algorithms can be
                            reconfigured and customized to cater to different
                            data sets, given the unpredictability of the data
                            encountered and the trends to be predicted. This
                            uncertainty has made Data Science a highly
                            attractive career option.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading03">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse03"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Data Scientist
                            Average Salary in India
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse03"
                        className="collapse"
                        aria-labelledby="heading03"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            A Data Scientist's typical income in India varies
                            depending on criteria such as job experience, skill
                            level, and sector. The average yearly compensation
                            for a Data Scientist in India is INR 10.8 lakhs,
                            according to a poll done by Analytics India
                            Magazine. However, wage ranges can vary greatly
                            depending on a variety of circumstances.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            For example, entry-level Data Scientists with less
                            than one year of experience can expect to earn INR
                            6.7 lakhs per year on average. Mid-career Data
                            Scientists with five to nine years of experience, on
                            the other hand, can make an annual income of INR
                            18.3 lakhs.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Aside from work experience, the industry in which a
                            Data Scientist works can also have a big impact on
                            their compensation. According to the report, the
                            highest-paying industries in India for Data
                            Scientists include IT services and products, BFSI
                            (Banking, Financial Services, and Insurance), and
                            e-commerce. Data Scientists working in these
                            businesses can expect to earn INR 13.1 lakhs, INR
                            12.7 lakhs, and INR 11.9 lakhs on average.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading04">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse04"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Data Scientist
                            Salary in Abroad
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse04"
                        className="collapse"
                        aria-labelledby="heading04"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Foreign data scientists may earn much more or less
                            money depending on their location, industry, job
                            experience, and skill level. The average yearly
                            income for a data scientist in the United States is
                            $113,309, which is much more than the equivalent
                            figure in India, according to a Glassdoor poll.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            The average yearly wage for a data scientist in the
                            United Kingdom is £46,665, or roughly $64,600. In
                            contrast, the average yearly wage for a data
                            scientist in Australia is AUD 113,309, or about
                            $84,300.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            It is significant to note that depending on criteria
                            like experience and sector, the pay for a data
                            scientist can vary significantly in other nations.
                            For instance, a Glassdoor poll revealed that Data
                            Scientists in the technology and financial sectors
                            typically make more money than their counterparts in
                            other sectors.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Additionally, the Data Scientist's income might be
                            considerably impacted by the location. For instance,
                            in the US, data scientists who work in IT hotspots
                            like San Francisco and New York typically earn a lot
                            more money than those who work in other cities.
                            Similar to this, in the UK, Data Scientists in
                            London typically make more money than those in other
                            cities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() => setTg(!toggle)}
                      className="btn btn-primary mb-3 viewmorebtn"
                    >
                      {toggle ? "View Less" : "View More"}
                    </button>

                    {toggle && (
                      <div className="morefaq">
                        <div className="card">
                          <div className="card-header" id="heading05">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse05"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                some good Data Science course for beginners
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse05"
                            className="collapse"
                            aria-labelledby="heading05"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                At the core of Data Science lies the ability to
                                derive insights from vast amounts of raw and
                                unstructured data that organizations encounter
                                on a daily basis, often in the form of
                                zettabytes and yottabytes. This blog is designed
                                to offer comprehensive information to assist you
                                in comprehending the concepts behind Data
                                Science, as well as determining whether this
                                field is a good fit for your professional
                                profile.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                There are few courses best for learning data
                                science for beginner level.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Few of the best courses includes Logicmojo,
                                Udemy, Upgrad, Coursera etc.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Although I preferred courses similar to
                                <b>Logicmojo</b> which provides live interactive
                                sessions with doubt clearing classes. They cover
                                all aspects of data science, starting with
                                basics of programming (binary, loops, number
                                systems, etc.) to intermediate programming
                                topics (arrays, OOPs, sorting, recursion, etc.)
                                to ML Engineering (NLP, Reinforcement Learning,
                                TensorFlow, Keras, etc.) and advanced
                                programming topics (Deep learning, DB and System
                                design, Predictive modeling, Hashing, Greedy,
                                etc.).
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Has dedicated career support, 1:1 mentorship
                                  programs with Machine Learning Engineers and
                                  Data Scientists, and a strong student
                                  community on Slack.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Regular assignments, tests and 15+ real time
                                  projects help you enhance your skills.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Life-time access contents that are all class
                                  recordings are provided in the form of
                                  recorded lectures after the end of class.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Helps you prepare for interviews by conducting
                                  mock interviews.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Provide you with ongoing support after you
                                  complete the course, building your confidence
                                  day by day.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  The most efficient way to build your network
                                  is by having a mentor. A mentor can provide
                                  support in building your career. Online
                                  courses like of Logicmojo will have access to
                                  the professional network of mentor. It is a
                                  great way to get to know experienced data
                                  science professionals in the industry. They
                                  help you in job referrals as well.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading06">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse06"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Can I get a
                                job in Data Science without a degree after
                                completing a course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse06"
                            className="collapse"
                            aria-labelledby="heading06"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Yes, it is possible to get a job in Data Science
                                without a degree, provided that you have
                                completed a Logicmojo Data Science course and
                                have acquired the necessary skills and
                                knowledge. While having a degree in a related
                                field can be helpful, it is not always a
                                requirement for entering the field of Data
                                Science.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The key to getting a job in Data Science without
                                a degree is to have a strong understanding of
                                the concepts and skills required in the field,
                                and to be able to demonstrate your proficiency
                                to potential employers. This can be achieved by
                                completing Logicmojo online courses, attending
                                bootcamps or training programs, or building a
                                portfolio of Data Science projects.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                In addition, it is important to acquire hands-on
                                experience working with data from Logicmojo
                                projects live experience, which can be achieved
                                through working on personal projects.
                                Demonstrating your ability to work with
                                real-world data sets and apply analytical
                                techniques can be a significant factor in
                                landing a job in Data Science.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                It is also important to develop a strong network
                                of contacts in the industry, as this can provide
                                valuable connections and opportunities for job
                                openings. Networking can be achieved through
                                attending industry events, participating in
                                online forums and groups, and reaching out to
                                professionals in the field for advice and
                                guidance.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading07">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse07"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Python For
                                Data Science Course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse07"
                            className="collapse"
                            aria-labelledby="heading07"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                If you are interested in learning Python for
                                data science, there are various online courses
                                and resources available.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Some popular online courses for learning Python
                                for data science include:
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Logicmojo : Online Course for learning Data
                                  Science Course. In the live interactive
                                  classes, you will end to end complete data
                                  science in Python Language.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  DataCamp : offers a variety of courses on
                                  Python for data science, including data
                                  manipulation, visualization, and machine
                                  learning.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Coursera - offers courses on Python for data
                                  science from universities such as the
                                  University of Michigan and IBM.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  edX - offers courses on Python for data
                                  science from institutions like Harvard
                                  University and Microsoft.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading08">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse08"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                difference between a Data Science course and a
                                Machine Learning course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse08"
                            className="collapse"
                            aria-labelledby="heading08"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                In an era dominated by information, data science
                                and machine learning have risen as indispensable
                                competencies. Although both disciplines revolve
                                around data, gleaning insights, and resolving
                                quandaries, pivotal dissimilarities exist. This
                                composition delves into the disparities between
                                data science and machine learning curricula
                                while highlighting their singular aspects.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                <b>Data Science Course</b>
                              </p>
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                  Data science delves into data examination,
                                  encompassing data acquisition, processing,
                                  scrutinization, and decipherment. A data
                                  science syllabus typically addresses subjects
                                  like statistical evaluation, data
                                  representation, machine learning, data
                                  excavation, and large-scale data technologies.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Data science programs aim to endow students
                                  with the prowess to manage complex datasets
                                  and unveil insights. Covered subjects range
                                  from amassing and refining data to employing
                                  statistical methods for data examination and
                                  utilizing machine learning algorithms to
                                  create prognostic models. Moreover, pupils
                                  learn to convey their discoveries engagingly
                                  and perspicuously through data visualization
                                  instruments.
                                </li>
                              </ul>
                              <ul>
                                <p style={{ fontsize: 14 }}>
                                  <b>Machine Learning Course</b>
                                </p>
                                <p style={{ fontsize: 14 }}>
                                  A subdiscipline of artificial intelligence,
                                  machine learning focuses on algorithms
                                  discerning patterns within data. A standard
                                  machine learning syllabus delves into
                                  supervised learning, unsupervised learning,
                                  reinforcement learning, and profound learning.
                                </p>
                                <p style={{ fontsize: 14 }}>
                                  The curriculum's principal objective is to
                                  enable students to cultivate and apply machine
                                  learning algorithms. Pupils learn to pinpoint
                                  the apt algorithm for particular issues, train
                                  and evaluate machine learning models, and
                                  optimize them for heightened efficacy.
                                  Additionally, they receive instruction on
                                  assessing model performance and interpreting
                                  the outcomes.
                                </p>
                              </ul>
                              <p style={{ fontsize: 14 }}>Key Difference</p>
                              <p style={{ fontsize: 14 }}>
                                Despite their shared attributes, data science
                                and machine learning differ primarily in their
                                scope and concentration. Data science
                                constitutes a more expansive field, integrating
                                various techniques for data manipulation.
                                Machine learning, on the other hand, specializes
                                in employing algorithms to detect patterns
                                within data.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                A significant divergence between data science
                                and machine learning curricula lies in
                                prerequisite mathematical and statistical
                                knowledge. A data science curriculum
                                necessitates a robust foundation in mathematics
                                and statistics, encompassing calculus, linear
                                algebra, and probability theory. A machine
                                learning curriculum also demands a vigorous
                                mathematical and statistical grounding but
                                accentuates applied mathematics over theoretical
                                concepts.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading09">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse09"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                difference between a Data Science course and a
                                Business Analytics course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse09"
                            className="collapse"
                            aria-labelledby="heading09"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                The disciplines of Data Science and Business
                                Analytics are related but distinct. While both
                                involve data, their objectives, methodologies,
                                and implementations are distinct.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Data Science is the application of statistical
                                and computational techniques to large and
                                complex data sets in order to derive insights.
                                Machine learning, deep learning, and artificial
                                intelligence are utilised to analyse data and
                                develop predictive models. The tasks of data
                                scientists include image recognition, natural
                                language processing, fraud detection, and
                                consumer segmentation. Typically, they possess a
                                solid foundation in computer science,
                                mathematics, and statistics.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Business Analytics, on the other hand, entails
                                the use of data to inform business decisions.
                                Utilising statistical and computational
                                techniques to analyse data and derive insights
                                that can aid businesses in making better
                                decisions is involved. Business analysts work on
                                numerous issues, including customer behaviour
                                analysis, market segmentation, and supply chain
                                optimisation. Typically, they have a solid
                                foundation in business and economics.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                While both Data Science and Business Analytics
                                utilise data and statistical techniques, their
                                objectives, methodologies, and applications are
                                distinct. Data Science is concerned with
                                developing predictive models and discovering
                                insights from large and complex data sets,
                                whereas Business Analytics is concerned with
                                utilising data to inform business decisions.
                                Data Science is more focused on research and
                                development, whereas Business Analytics is more
                                focused on practical business applications.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                A typical Data Science course would encompass
                                statistical modelling, machine learning, data
                                visualisation, and deep learning, among other
                                topics. In contrast, a typical course in
                                Business Analytics would encompass topics such
                                as business statistics, data analysis, and
                                decision making.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                While both Data Science and Business Analytics
                                involve data and statistical techniques, their
                                objectives, methodologies, and applications are
                                distinct. Data Science is concerned with
                                developing predictive models and deriving
                                insights from data, whereas Business Analytics
                                is concerned with utilising data to inform
                                business decisions. When deciding between a Data
                                Science course and a Business Analytics course,
                                it is crucial to consider your interests, career
                                objectives, and the specific skills and
                                knowledge that each course will provide.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading10">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse10"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> How will a
                                Data Science course help me in my current job
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse10"
                            className="collapse"
                            aria-labelledby="heading10"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Data Science, an ever-expanding domain, has
                                surged in significance as enterprises and
                                organizations grapple with copious amounts of
                                data. Logicmojo Data Science course equips you
                                with the acumen and proficiency required to
                                harness this data, deriving insights that foster
                                enhanced decision-making in your present
                                occupation.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                A primary advantage of undertaking Logicmojo
                                Data Science course lies in mastering the art of
                                handling voluminous and intricate datasets. This
                                expertise proves invaluable across industries,
                                as businesses accumulate escalating quantities
                                of data on clientele, merchandise, and
                                operations. By deciphering this data, you can
                                unveil patterns and tendencies otherwise
                                imperceptible. For instance, discerning customer
                                segments predisposed to purchasing a specific
                                item or pinpointing manufacturing process
                                inefficiencies ripe for amelioration becomes
                                feasible.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Additionally, this Data Science course imparts
                                knowledge on formulating predictive models. Such
                                algorithms facilitate data-driven
                                prognostications. Employing a predictive model,
                                one could forecast sales for an item or detect
                                fraudulent transactions. Acquiring the ability
                                to create these models ensures precise
                                predictions and more informed, data-centric
                                decisions.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The Logicmojo Data Science course also educates
                                learners on efficacious data visualization and
                                communication. Data visualization entails
                                crafting graphic representations, such as charts
                                and graphs, rendering data more comprehensible
                                and patterns discernible. Articulating data
                                effectively proves essential as it enables
                                sharing insights with others, bolstering the
                                case for specific actions.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Hence, the Logicmojo Data Science course
                                bolsters your current career by furnishing the
                                aptitudes and erudition necessary to manipulate
                                vast, complex datasets, devise predictive
                                models, and adeptly visualize and communicate
                                data. By leveraging these proficiencies, you can
                                extract valuable insights from data, engendering
                                judicious decisions and driving superior
                                business outcomes.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading11">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse11"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What are
                                the best books to read before enrolling in a
                                Data Science course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse11"
                            className="collapse"
                            aria-labelledby="heading11"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Data Science is a rapidly growing field that
                                combines statistics, programming, and domain
                                expertise to extract insights from data. If
                                you're interested in pursuing a career in Data
                                Science, there are several books that can help
                                you build a strong foundation in the field.
                              </p>
                              <ul>
                                <li style={{ fontsize: 14 }}>
                                  Logicmojo is a well-known online platform that
                                  provides Data Science course to students all
                                  around the world. Pursuing a course on this
                                  platform might be a terrific way to learn new
                                  skills and knowledge, but tuition costs can be
                                  an issue for some students. Fortunately, there
                                  are various scholarships available to assist
                                  with tuition costs.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  The Logicmojo Data Science Scholarship is one
                                  of the scholarships available for Logicmojo
                                  Data Science course. This grant is given to
                                  students who have shown academic achievement
                                  as well as a significant interest in Data
                                  Science. The scholarship covers the cost of
                                  tuition and may also include other benefits
                                  such as mentorship and networking
                                  opportunities.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  The Women in Data Science Scholarship, offered
                                  by the Women in Data Science organisation, is
                                  another scholarship available for Logicmojo
                                  Data Science course. This scholarship is
                                  given to women who want to work in Data
                                  Science or a similar profession, and it can be
                                  used to pay for Logicmojo Data Science
                                  courses.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Furthermore, many universities and
                                  institutions have scholarships that can be
                                  used to pay for Logicmojo Data Science
                                  courses. The University of Texas at Austin,
                                  for example, supports the Data Science
                                  Scholarship for Underrepresented Students,
                                  which provides financial assistance to
                                  students from underrepresented groups seeking
                                  a degree in Data Science. This scholarship can
                                  be used to pay for Logicmojo Data Science
                                  courses as well as other educational costs.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  There are also a number of non-profit
                                  organisations that provide scholarships for
                                  Data Science course, which can be used to
                                  offset the cost of Logicmojo courses. For
                                  example, the Data Incubator provides a Data
                                  Science Fellowship that includes financial
                                  assistance as well as training and mentoring
                                  for students interested in a future in data
                                  science. This scholarship can be used to pay
                                  for Logicmojo Data Science classes.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading12">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse12"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>Are there
                                any scholarships available for Data Science
                                courses
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse12"
                            className="collapse"
                            aria-labelledby="heading12"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Students from all over the world can take Data
                                Science courses from Logicmojo, a well-known
                                online educational resource. A course on this
                                platform can be a terrific way to learn new
                                things, but some students might be worried about
                                the tuition costs. Fortunately, there are a
                                number of scholarships offered to assist with
                                tuition costs.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The Data Science Scholarship that Logicmojo
                                itself offers is one of the awards offered for
                                its Data Science course. Students with a
                                significant interest in data science and a
                                record of academic performance will be given
                                this scholarship. In addition to offering
                                financial aid to cover tuition, the scholarship
                                may also offer other forms of assistance
                                including networking and coaching.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The Women in Data Science award is an additional
                                award available for Logicmojo Data Science
                                courses. It is provided by the Women in Data
                                Science organisation. This scholarship can be
                                used to pay for Logicmojo Data Science course
                                and is given to women who are pursuing careers
                                in data science or fields that are closely
                                related to it.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The cost of the Logicmojo Data Science course
                                may also be covered by scholarships that are
                                available from numerous institutions and
                                colleges. The Data Science Scholarship for
                                Underrepresented Students, for instance, is a
                                financial aid programme offered by the
                                University of Texas at Austin for students from
                                underrepresented groups who wish to pursue a
                                degree in data science. The cost of the
                                Logicmojo Data Science course as well as
                                additional educational fees may be covered by
                                this award.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Several charitable organisations also provide
                                scholarships for Data Science course, which can
                                be used to pay for the cost of Logicmojo
                                courses. For instance, the Data Incubator
                                supports students interested in a future in data
                                science with a Data Science Fellowship that
                                includes financial assistance as well as
                                training and mentoring. The cost of the
                                Logicmojo Data Science course may be covered by
                                this scholarship.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading13">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse13"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What are the
                                best Data Science course for advanced learners
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse13"
                            className="collapse"
                            aria-labelledby="heading13"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Logicmojo Data Science course stands out as a
                                comprehensive and engaging program that covers a
                                wide range of topics in the field.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Other notable courses for advanced learners
                                include the Harvard University Data Science
                                Professional Certificate program, which is
                                designed to provide learners with hands-on
                                experience in data analysis, machine learning,
                                and data visualization. Another top-tier option
                                is the Applied Data Science with Python
                                specialization offered by the University of
                                Michigan on Coursera, which focuses on building
                                practical data science skills using Python
                                programming language.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                For learners seeking a more rigorous and
                                academic program, the Master of Data Science
                                program offered by the University of British
                                Columbia provides an in-depth and
                                research-focused curriculum that explores the
                                theoretical foundations of data science.
                                Additionally, the Data Science MicroMasters
                                program from MIT is another option for learners
                                looking to delve deeper into the mathematical
                                and computational aspects of the field.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Overall, there are many high-quality Data
                                Science courses available for advanced learners,
                                and the choice ultimately depends on the
                                learner's personal goals, preferences, and
                                needs. However, Logicmojo Data Science course is
                                certainly a great option to consider, given its
                                comprehensive curriculum, experienced
                                instructors, and practical approach to learning.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading14">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse14"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What are the
                                prerequisites for a Data Science course for MBA
                                students
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse14"
                            className="collapse"
                            aria-labelledby="heading14"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Data science has emerged as an increasingly
                                vital facet of contemporary commerce, so it's no
                                wonder that MBA students express keenness in
                                pursuing courses pertinent to this sphere. Prior
                                to delving into such a course, grasping the
                                prerequisites necessary to thrive in data
                                science is crucial.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                A primary prerequisite for a Logicmojo data
                                science course is a robust background in
                                mathematics and statistics. MBA students eager
                                to engage in data science must possess a firm
                                grasp of calculus, probability theory, and
                                linear algebra. These subjects furnish
                                indispensable tools for data scrutiny and
                                modeling, which lie at the heart of data
                                science.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Beyond mathematics and statistics, programming
                                prowess is also indispensable for a data science
                                course. MBA students ought to be acquainted with
                                at least one programming language, preferably
                                Python or R, frequently employed in data
                                science. Proficiency in programming languages
                                empowers students to manipulate data, construct
                                models, and conduct data analysis.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                A further vital prerequisite for data science is
                                a rudimentary comprehension of business and
                                economics. Data scientists must forge
                                connections between data and real-world business
                                quandaries, making data-driven determinations
                                that propel business growth. Consequently, MBA
                                students should possess a thorough understanding
                                of business operations, marketing, finance, and
                                economics.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Communication skills are equally essential for
                                data scientists. They must communicate
                                effectively with non-technical stakeholders,
                                presenting intricate data in a lucid and
                                succinct manner. MBA students aiming to pursue
                                data science should cultivate their
                                communication skills by enrolling in public
                                speaking courses or participating in group
                                dialogues.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Lastly, fervor and inquisitiveness are crucial
                                prerequisites for a data science course. Data
                                science is an expeditiously evolving domain,
                                demanding ongoing learning and self-enhancement.
                                MBA students who are passionate about data
                                science and curious about the world around them
                                are more inclined to prosper in the field.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Thus, MBA students who aspire to undertake data
                                science courses must possess a solid background
                                in mathematics and statistics, programming
                                expertise, a fundamental comprehension of
                                business and economics, communication skills,
                                and zeal for the discipline. These
                                prerequisites, coupled with a comprehensive data
                                science curriculum, can equip MBA students for
                                triumphant careers in data science.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading15">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse15"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What are the
                                prerequisites for a Data Science course for
                                Non-IT students
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse15"
                            className="collapse"
                            aria-labelledby="heading15"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Data science has evolved as an important field
                                of study that provides intriguing job options
                                for people who enjoy analytics and problem
                                solving. While the topic is frequently connected
                                with IT and technical expertise, Logicmojo
                                provides a Data Science course for individuals
                                with non-IT backgrounds. Certain prerequisites
                                must be satisfied in order to excel in this
                                course.
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  First and foremost, a solid mathematical
                                  foundation is essential. Non-IT students
                                  interested in data science should be
                                  well-versed in calculus, linear algebra, and
                                  probability theory. These mathematical
                                  principles serve as the foundation for data
                                  modelling and analysis, which are essential
                                  components of data science.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  In addition to math, programming skills are
                                  required. The ability to code in a programming
                                  language such as Python is required for data
                                  manipulation and analysis. Understanding
                                  database principles like SQL is also necessary
                                  when working with massive datasets.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Non-IT students interested in data science
                                  must also have an eye for detail and a strong
                                  desire to solve problems. Individuals who are
                                  comfortable working with complicated and
                                  unstructured data and who can recognise trends
                                  and patterns are needed in data science. They
                                  should also have a keen mind and be prepared
                                  to try new techniques to issue resolution.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Communication abilities are also essential.
                                  Working with cross-functional teams and
                                  presenting complex information to stakeholders
                                  who may not have a technical background are
                                  all part of data science. Non-IT students
                                  interested in data science must be able to
                                  communicate difficult concepts clearly and
                                  concisely, both vocally and in writing.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Finally, domain knowledge in the area of
                                  interest is required. Data science projects
                                  are frequently focused on resolving business
                                  issues. As a result, non-IT students
                                  interested in data science should have a basic
                                  understanding of the sector and the challenges
                                  they hope to tackle.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading16">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse16"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What is the
                                future scope of Logicmojo Data Science course
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse16"
                            className="collapse"
                            aria-labelledby="heading16"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                The explosion of data in today's digital age is
                                driving up demand for data science
                                professionals. Companies acquire massive volumes
                                of data from many sources, and they need data
                                scientists to analyse and understand this data
                                in order to make business choices. As a result,
                                Logicmojo data science course are designed to
                                provide students with the skills and knowledge
                                needed to overcome complicated data-related
                                challenges.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The rapid evolution of technology is another
                                aspect that will influence the future scope of
                                Logicmojo data science course. Big Data and the
                                Internet of Things (IoT) have created a demand
                                for data scientists that can work with huge and
                                complicated information. Furthermore, the
                                availability of cloud computing and machine
                                learning techniques has simplified data
                                scientists' ability to analyse data and draw
                                insights rapidly and reliably.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Furthermore, the future reach of Logicmojo data
                                science courses extends outside traditional
                                sectors. The emergence of new businesses such as
                                e-commerce, social networking, and healthcare
                                has produced new data-related difficulties that
                                necessitate data scientists' competence. As a
                                result, data science course are changing to
                                reflect new and emerging trends, technologies,
                                and applications.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The possibility of multidisciplinary
                                collaboration is another interesting aspect of
                                the future scope of data science course. Data
                                science necessitates competence in a variety of
                                fields, including statistics, computer science,
                                and domain knowledge. As a result, data science
                                courses can be tailored to foster cooperation
                                and interdisciplinary learning, allowing
                                students to gain a broader perspective and a
                                more holistic approach to data-related
                                difficulties.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                The future of data science course seems bright
                                and promising. As data and technology continue
                                to flourish, the demand for data scientists is
                                projected to rise, opening up new and intriguing
                                job options. Individuals with a passion for data
                                analysis and problem solving can consider taking
                                data science course to gain the skills and
                                knowledge needed to excel in this area.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading16">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse16"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>How does one
                                choose the right data science course for their
                                career goals
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse16"
                            className="collapse"
                            aria-labelledby="heading16"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                People who love statistics and problem-solving
                                will find intriguing job prospects in the
                                emerging profession of data science. However,
                                selecting the best degree might be challenging
                                given the abundance of data science programs
                                accessible. This is particularly true if you are
                                studying data science to advance your
                                profession. In this light, Logicmojo's Data
                                Science course is a wonderful option for
                                students looking to get the abilities and
                                information required to succeed in this
                                industry. Here are some things to think about
                                while selecting the best data science education
                                for your professional aspirations.
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  Curriculum: The most crucial aspect to take
                                  into account is the curriculum for the
                                  Logicmojo data science course. The subjects
                                  that should be covered in a solid data science
                                  course include statistics, machine learning,
                                  data visualisation, and big data technology.
                                  All of these topics are covered in Logicmojo's
                                  Data Science course, which aims to provide
                                  students a thorough understanding of the
                                  subject.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Accreditation: When selecting a data science
                                  course, accreditation is crucial. By being
                                  accredited, a course is guaranteed to meet the
                                  necessary criteria and have its credential
                                  accepted by companies. The Indian Institute of
                                  Technology, Kanpur has accredited Logicmojo's
                                  Data Science course, assuring that the degree
                                  earned is respected by employers.
                                </li>

                                <li style={{ fontsize: 14 }}>
                                  Faculty: The instructors for the data science
                                  course should have relevant experience and
                                  expertise. They ought to have knowledge of
                                  data science and practical experience with
                                  handling data issues. The instructors for the
                                  Data Science course at Logicmojo are skilled
                                  professionals.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Industry contacts: The data science course
                                  must to have connections to the industry and
                                  give students the chance to network with
                                  experts in the field. After completing the
                                  course, this may assist students land
                                  internships and employment prospects. The Data
                                  Science course at Logicmojo offers connections
                                  to the industry and gives students the chance
                                  to network with experts in the field.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Delivery method: How the data science course
                                  is delivered is equally crucial. Other courses
                                  are taught in-person, while some are given
                                  online. The Data Science course at Logicmojo
                                  is taught using a hybrid methodology that
                                  blends online and in-person instruction. For
                                  those students who are unable to attend
                                  classes in person, this offers flexibility.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div id="tab027" className="tab-pane">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading05">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse05"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            level of difficulty in a data science course
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse05"
                        className="collapse"
                        aria-labelledby="heading05"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The intricacy of a data science curriculum can
                            oscillate based on multiple elements, encompassing
                            the syllabus's architecture, the pupil's
                            foundational erudition, and their adeptness in
                            mathematics and coding. Ordinarily, data science
                            curricula necessitate a robust comprehension of
                            mathematical notions such as linear algebra,
                            calculus, probability, and statistics. Pupils are
                            also anticipated to be adroit in programming
                            dialects like Python or R and possess a rudimentary
                            cognizance of data structures and algorithms.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Beyond these technical proficiencies, data science
                            curricula may also call for critical cogitation,
                            problem-resolution, and analytical acumen. Pupils
                            might need to tackle authentic data conundrums and
                            be capable of scrutinizing and construing data to
                            distill insights and make enlightened choices.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            The intricacy of a data science curriculum may also
                            be contingent upon the tier of the course in
                            question. Some data science curricula cater to
                            novices and encapsulate rudimentary notions, while
                            others are more sophisticated and probe into
                            intricate subjects such as deep learning and natural
                            language processing.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Nevertheless, with apt tutelage, resources, and
                            tenacity, pupils can surmount the trials of a data
                            science curriculum and thrive in the domain. It is
                            paramount to select a curriculum that aligns with
                            your competencies and to persistently hone and
                            augment your skills through undertakings, digital
                            assets, and synergies with colleagues in the
                            discipline.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            In summation, the intricacy of a data science
                            curriculum can oscillate based on the syllabus's
                            architecture, the pupil's foundational erudition,
                            and their adeptness in mathematics and coding.
                            However, by employing the correct stratagem and
                            resources, pupils can surmount these hurdles and
                            cultivate the requisite expertise to flourish in the
                            realm of data science.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading06">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse06"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I work at
                            my own pace in a data science course
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse06"
                        className="collapse"
                        aria-labelledby="heading06"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            When you join a data science class at Logicmojo,
                            many students wonder if they can learn at their
                            speed. Everyone has different ways of learning and
                            schedules, so it's important to feel in control of
                            how you learn.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Thankfully, Logicmojo knows that flexibility is
                            important and designs their data science classes
                            with that in mind. Whether you are a full-time
                            student, have a job, or are just busy, you can
                            adjust your learning to fit your life.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            It's important to remember that learning at your
                            speed doesn't mean you're alone with the course
                            materials and other students. In fact, Logicmojo
                            wants students to work together and offers tools to
                            connect with classmates and teachers.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            So, if you like to finish the work fast or take your
                            time, you can be sure that you'll have the help and
                            resources you need to do well in your Logicmojo data
                            science class.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading08">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse08"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How do I build
                            a portfolio of data science projects
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse08"
                        className="collapse"
                        aria-labelledby="heading08"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            To create a portfolio that highlights your data
                            science abilities, follow these easy steps:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Select various projects that demonstrate different
                              aspects of data science, such as data
                              visualization, machine learning, data cleaning,
                              and data analysis. This allows you to showcase
                              your diverse skill set.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Choose projects that align with your career
                              objectives. If you're interested in a specific
                              industry or job type, focus on projects within
                              those areas. This helps show your expertise in
                              what you're passionate about and lets employers
                              know you have clear career goals.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              When putting together your portfolio, include
                              clear descriptions for each project and any data
                              sets or code you used. This allows employers to
                              grasp your methods and understand the types of
                              projects you can handle.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Share your portfolio with others in the data
                              science community. You can post it on social media
                              or discuss it at data science events or meetups.
                              Sharing your work can provide valuable feedback
                              and help you connect with other professionals.
                            </li>
                          </ol>
                          <p style={{ fontsize: 14 }}>
                            Creating a strong data science portfolio requires
                            planning and attention to detail. By choosing a
                            variety of projects, writing clear descriptions and
                            sharing your code, and presenting your work to
                            others, you can build a portfolio that highlights
                            your skills and expertise as a data scientist.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading09">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse09"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            companies hire data scientists
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse09"
                        className="collapse"
                        aria-labelledby="heading09"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Many companies need data scientists because they
                            help make decisions based on data. Here are examples
                            of companies that often hire data scientists:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Tech companies: Big companies like Google,
                              Facebook, and Amazon use data to make choices and
                              want skilled data scientists to join them.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Financial companies: Banks, investment firms, and
                              other money-related businesses use data science
                              for managing risk, finding fraud, and deciding on
                              investments. Data scientists with finance
                              experience are very valuable here.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Healthcare companies: These businesses use data
                              science to study patient data, create new
                              treatments, and make patients healthier. Data
                              scientists with healthcare analysis experience are
                              needed a lot.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Retail companies: Retail businesses use data
                              science to learn about customer habits, set
                              prices, and guess what people will buy. Data
                              scientists with retail analysis experience can
                              help companies beat their competition.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Consulting companies: Some consulting businesses
                              focus on data analysis and hire data scientists to
                              help clients make data-based decisions. They work
                              in many industries, so data scientists with
                              different experiences are very important.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Government agencies: Governments use data science
                              to make public services better, watch public
                              health, and follow crime. Data scientists with
                              government analysis experience can make a big
                              difference in this area.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Manufacturing companies: These businesses use data
                              science to make production better, waste less, and
                              control quality. Data scientists with
                              manufacturing analysis experience are wanted a lot
                              in this industry.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading10">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse10"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are some
                            common data science tools and platforms
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse10"
                        className="collapse"
                        aria-labelledby="heading10"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Data science employs a multitude of instruments and
                            platforms for gathering, processing, scrutinizing,
                            and illustrating data. The following list presents
                            several prevalent tools and platforms frequently
                            encountered in data science curriculums:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Python: This widely embraced programming language
                              is favored in data science for its uncomplicated
                              nature, adaptability, and extensive assortment of
                              libraries and packages. Python plays a crucial
                              role in data preprocessing, purification,
                              modeling, and depiction.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              SQL: Standing for Structured Query Language, SQL
                              is employed for administering and querying
                              relational databases. Data scientists frequently
                              use SQL to extract and manipulate information
                              within databases.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Excel: A pervasive spreadsheet application, Excel
                              is utilized for data cleansing, examination, and
                              illustration. It proves particularly advantageous
                              for compact datasets and straightforward data
                              analysis undertakings.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Tableau: As a renowned data illustration
                              instrument, Tableau empowers users to craft
                              interactive panels and visualizations. It is
                              commonly employed for inquisitive data analysis
                              and conveying data insights to interested parties.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Hadoop: This framework facilitates the distributed
                              storage and processing of substantial data. Hadoop
                              is a customary choice in data science for
                              examining and processing sizable datasets.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Spark: Apache Spark, an open-source data
                              processing engine, serves large-scale data
                              processing and analysis requirements. It is
                              particularly beneficial for distributed computing
                              and machine learning tasks.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Jupyter Notebook: This open-source web application
                              permits users to generate and share documents
                              containing live code, equations, visualizations,
                              and narrative text. It is routinely used for data
                              exploration, prototyping, and collaborative data
                              science endeavors.
                            </li>
                          </ol>
                          <p style={{ fontsize: 14 }}>
                            In summary, numerous tools and platforms cater to
                            data science needs. The specific instruments
                            utilized in a data science course might rely on the
                            curriculum, the instructor's predilections, and the
                            students' requirements. Nonetheless, Python, R, SQL,
                            Excel, Tableau, Hadoop, Spark, and Jupyter Notebook
                            constitute some of the most prevalently adopted
                            tools and platforms within data science pedagogy.
                          </p>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() => setTg(!toggle)}
                      className="btn btn-primary mb-3 viewmorebtn"
                    >
                      {toggle ? "View Less" : "View More"}
                    </button>

                    {toggle && (
                      <div className="morefaq">
                        <div className="card">
                          <div className="card-header" id="heading11">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse11"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What is the
                                format of the course (online, in-person, hybrid,
                                etc.)
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse11"
                            className="collapse"
                            aria-labelledby="heading11"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                The format of Logicmojo live classes is
                                completely online, meaning that students access
                                course materials and attend live lectures and
                                discussions through an online platform. The
                                classes are conducted in a synchronous format,
                                with set class times and real-time interaction
                                between students and instructors. This online
                                format provides flexibility for students to
                                attend classes from anywhere with an internet
                                connection and allows for a more collaborative
                                learning experience through virtual breakout
                                sessions and group projects. Additionally,
                                students have access to recorded lectures and
                                materials for self-paced review and study.
                                Overall, the online format of Logicmojo live
                                classes offers a convenient and accessible
                                option for students to learn data structures and
                                algorithms.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading110">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse110"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What kind
                                of support is available during the course, such
                                as access to instructors or mentors
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse110"
                            className="collapse"
                            aria-labelledby="heading110"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                At Logicmojo, we recognize that grasping data
                                science can be arduous and multifaceted. Hence,
                                we furnish our students with abundant assistance
                                to facilitate their progress. Our data science
                                curriculum showcases adept educators and
                                advisors, fervent about guiding learners towards
                                their objectives.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Throughout the program, students can engage with
                                instructors and mentors via diverse channels,
                                including online discussion boards, electronic
                                correspondence, and real-time video
                                conversations. This enables learners to obtain
                                tailored feedback on their efforts and inquire
                                about the course materials.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Besides the backing from our instructors and
                                mentors, we also present an array of resources
                                to bolster students' performance and maintain
                                their focus. These provisions include
                                comprehensive study materials, practice drills,
                                and tasks aimed at strengthening crucial notions
                                and abilities.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                At Logicmojo, we firmly believe that delivering
                                robust support and invaluable resources is
                                imperative for empowering our students to
                                realize their data science ambitions. Whether
                                you are a neophyte or adept in data-centric
                                endeavors, we stand by you to foster your
                                triumph
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading12">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse12"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What kind
                                of projects will be included in the course and
                                what level of proficiency will be achieved by
                                completing them
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse12"
                            className="collapse"
                            aria-labelledby="heading12"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Students will gain practical experience working
                                on actual data science projects as part of the
                                Logicmojo data science course. Students will
                                work on a variety of projects during the
                                semester that are intended to advance their
                                expertise in various aspects of data science.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Data preparation and cleansing, exploratory data
                                analysis, machine learning, and data
                                visualisation are just a few of the subjects
                                covered by the projects for this course. Each
                                assignment is thoughtfully created to aid
                                students in developing these abilities and
                                applying what they have learned in real-world
                                situations.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Students will become highly proficient in data
                                science by completing the assignments in the
                                course. They will have the chance to deal with
                                actual data sets and use a range of data science
                                methodologies to resolve challenging issues.
                                Additionally, they will get practise using
                                well-known data science tools and technologies
                                like Python, R, and SQL.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Students will have a solid foundation in data
                                science by the end of the course and be able to
                                apply their knowledge to a range of data-driven
                                projects. They will be able to successfully
                                analyse data, create predictive models, and
                                convey their findings. The Logicmojo data
                                science course is made to support you in
                                achieving your data science objectives, whether
                                you are a beginner or an experienced data
                                professional.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading13">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse13"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> Are the
                                Data Science classes conducted online or
                                in-person? ?
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse13"
                            className="collapse"
                            aria-labelledby="heading13"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                With a typical student-to-instructor ratio of
                                30:1, each student in a Logicmojo data science
                                course can anticipate receiving individualised
                                attention and feedback from our knowledgeable
                                educators. This enables our teachers to offer
                                each student specialised attention and to assist
                                them in overcoming any difficulties they might
                                face throughout the course.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                A low student-to-instructor ratio, in our
                                opinion, is particularly crucial in a data
                                science course since it enables students to get
                                feedback on their work and ask questions about
                                challenging subjects. Our students benefit from
                                this individualised attention as they establish
                                a solid foundation in data science and acquire
                                the skills necessary to be successful in their
                                future employment.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                We at Logicmojo are dedicated to giving our
                                students the best possible education in data
                                science. One of the numerous ways we support our
                                students and assist them in achieving their data
                                science goals is through our low
                                student-to-instructor ratio.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading14">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse14"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i> What kind
                                of software or tools are required for the
                                course, and are they included in the course fee
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse14"
                            className="collapse"
                            aria-labelledby="heading14"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                Tools and software for the data science course
                                and their relation to the course fee:
                              </p>
                              <ol>
                                <li style={{ fontsize: 14 }}>
                                  The course necessitates that students have
                                  access to programming tools like Python, R,
                                  and SQL, as well as visualization tools such
                                  as Tableau and Power BI.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Students need to get their own access to these
                                  tools, but teachers offer guidance and
                                  assistance to help learners set up the
                                  required software.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  The course fee doesn't cover the expenses of
                                  these software and tools. However, many tools
                                  are available for free or at a low cost, and
                                  teachers help students find the best choices
                                  for their needs and budget.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  Ensuring access to these tools is crucial for
                                  students to develop the abilities they need
                                  for success in data science.
                                </li>
                                <li style={{ fontsize: 14 }}>
                                  The course fee includes access to course
                                  materials, teaching, and support but does not
                                  cover the cost of necessary software and
                                  tools.
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header" id="heading15">
                            <h3 className="mb-0">
                              <button
                                type="button"
                                className="btn btn-link collapsed"
                                data-toggle="collapse"
                                data-target="#collapse15"
                                aria-expanded="false"
                              >
                                <i className="fa fa-angle-down"></i>What is the
                                refund policy in case I am unable to complete
                                the course or am unsatisfied with the
                                instruction
                              </button>
                            </h3>
                          </div>

                          <div
                            id="collapse15"
                            className="collapse"
                            aria-labelledby="heading15"
                            data-parent="#accordionExample2"
                          >
                            <div className="card-body">
                              <p style={{ fontsize: 14 }}>
                                If for any reason you find yourself unable to
                                complete the Logicmojo data science course or
                                are unsatisfied with the course content, we
                                offer a 14-day refund policy. This gives you two
                                full weeks to explore the course materials, get
                                a feel for the curriculum, and determine if it's
                                the right fit for your needs and goals.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                Our refund policy is designed to give you peace
                                of mind and ensure that you are satisfied with
                                your investment in the course. If for any reason
                                you decide that the course is not a good fit for
                                you, simply reach out to our support team within
                                14 days of your enrollment, and we will issue a
                                refund.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                It's important to note that we do have certain
                                terms and conditions in place to protect the
                                integrity of our refund policy. Specifically, we
                                do not issue refunds for students who have
                                completed more than 25% of the course content or
                                who have violated our code of conduct or terms
                                of service.
                              </p>
                              <p style={{ fontsize: 14 }}>
                                At Logicmojo, we strive to provide the highest
                                quality educational experience possible, and we
                                are committed to ensuring that our students are
                                satisfied with their investment in the course.
                                If you have any questions or concerns about our
                                refund policy, please don't hesitate to reach
                                out to our support team for assistance.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div id="tab028" className="tab-pane">
                <div className="faqnew">
                  <div className="accordion" id="accordionExample2">
                    <div className="card">
                      <div className="card-header" id="heading00">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse00"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is the course
                            self-paced, or are there specific deadlines or
                            timelines for completing assignments and projects
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse00"
                        className="collapse"
                        aria-labelledby="heading00"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              You may learn whenever and wherever you choose
                              thanks to the accessibility of the Logicmojo
                              course materials.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Throughout order to make sure you are making
                              steady progress and staying on track, there are
                              precise deadlines for finishing tasks and projects
                              throughout the course.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              These deadlines are intended to help you reach
                              your learning objectives while maintaining your
                              motivation and engagement in the learning process.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              The course material is broken up into modules, and
                              each module contains a set of tasks and projects
                              that must be finished within a certain amount of
                              time.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              At the start of the course, the due dates for
                              these tasks and projects are made known to you so
                              that you can schedule your study accordingly.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              In addition, there are frequent check-ins and
                              evaluations to monitor your development and make
                              sure you are fulfilling the course's learning
                              goals.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              All things considered, the Logicmojo data science
                              course provides the adaptability of self-paced
                              learning with the structure of specified goals and
                              timetables to keep you on track and motivated.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading01">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse01"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            feedback and evaluation will be provided throughout
                            the logicmojo data science course to track progress
                            and ensure understanding of the material
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse01"
                        className="collapse"
                        aria-labelledby="heading01"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            In the Logicmojo data science class, students get
                            detailed feedback and reviews during the whole
                            course. Feedback is important for learning, and
                            teachers give regular comments on tasks and projects
                            to help students know where to get better. Also,
                            teachers and mentors are ready to answer questions
                            and give help when needed.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            To see how students are doing and make sure they
                            understand, the Logicmojo data science class has
                            regular tests and reviews. These tests check how
                            well students know the material and if they can use
                            what they learned in real life. The tests can be
                            quizzes, exams, or projects.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Also, students get updates on how they are doing
                            through personal progress reports that show what
                            they are good at and what they need to work on.
                            Teachers will help students make a plan to get
                            better at things they need help with, so they have
                            the support and tools to do well
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading02">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse02"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How are
                            assessments and grades handled in the data science
                            course
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse02"
                        className="collapse"
                        aria-labelledby="heading02"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            In the Logicmojo data science course, assessments
                            and grades are an important aspect of evaluating
                            progress and understanding of the material.
                            Throughout the course, students will be evaluated
                            through a variety of assignments, quizzes, projects,
                            and exams to ensure that they are absorbing the
                            concepts and techniques being taught.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Assessments are designed to be challenging and
                            thought-provoking, allowing students to apply their
                            newfound knowledge in real-world scenarios. These
                            assessments are designed to test the student's
                            understanding of the material and provide
                            opportunities to identify and address any areas of
                            weakness.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Grades are assigned based on a variety of factors,
                            including performance on assessments, participation
                            in class discussions, and completion of assignments.
                            At the end of the course, students will receive a
                            final grade based on their overall performance
                            throughout the course.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            It is important to note that the emphasis in the
                            Logicmojo data science course is on learning and
                            understanding the material, rather than just
                            receiving a high grade. Instructors provide
                            constructive feedback on assignments and assessments
                            to help students improve their skills and ensure
                            their success in the field of data science.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading03">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse03"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support is available for technical issues or
                            difficulties with the course material
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse03"
                        className="collapse"
                        aria-labelledby="heading03"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Primarily, you'll gain entry to a devoted assembly
                            of technical support connoisseurs who stand ready to
                            address inquiries about the course content, rectify
                            technical snags, and offer counsel on employing
                            indispensable software or apparatuses.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Moreover, you'll tap into a fraternity of
                            like-minded learners who contribute guidance,
                            backing, and discernment stemming from their
                            personal encounters within the course. This proves
                            particularly beneficial when grappling with a
                            singular notion or task and craving supplementary
                            viewpoints.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Lastly, Logicmojo furnishes an all-encompassing
                            repository of knowledge and digital assets
                            encompassing an extensive spectrum of subjects
                            pertinent to the course curriculum, encompassing
                            didactic materials, diagnostic manuals, and other
                            invaluable resources. Regardless of your quest for
                            data analysis strategies, assistance with a
                            programming dialect, or direction on adhering to
                            best practices when handling voluminous data, a
                            wealth of resources awaits to bolster your success
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading04">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse04"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How up-to-date
                            is the course material, and is it regularly updated
                            to reflect changes in the field of data science
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse04"
                        className="collapse"
                        aria-labelledby="heading04"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            As an institution, we take immense pride in
                            providing our pupils with the most modern
                            information, equipment, and methodologies to aid in
                            their data science careers. Our course syllabus is
                            comprehensive and covers a wide range of topics,
                            from fundamental concepts to the most advanced and
                            cutting-edge technologies. Its purpose is to equip
                            our students with a thorough understanding of the
                            field.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Apart from updating our course content frequently,
                            we place considerable importance on our students'
                            feedback. We urge our students to provide us with
                            constructive criticism and recommendations for our
                            course content. This valuable feedback assists us in
                            constantly improving our course material, ensuring
                            it remains current and applicable.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="btn-center-section" id="faq">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>






      {/*
      <section className="relatedcourses">
        <div className="container ">
          <h3 style={{ fontSize: 25 }}>Data Science Course Faculty</h3>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/ravi-singh.jpg" />
                </div>

                <h3 className="name">Ravi Singh</h3>
                <p className="title">Experinced Senior Faculty Data Science</p>
                <p className="description">
                  Ravi has been part of multiple companies, gaining a wide array
                  of knowledge in data science. His background involves handling
                  various data kinds, applying diverse analysis methods.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/diwakar.png" />
                </div>

                <h3 className="name">Diwakar Choudhary</h3>
                <p className="title">Senior Faculty Member Data Science</p>
                <p className="description">
                  Diwakar has collaborated with numerous organizations, amassing
                  an extensive scope of expertise in data science. His
                  experience encompasses managing an assortment of data types
                  and employing a range of analytical approaches.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Vishal.jpeg" />
                </div>
                <h3 className="name">Vishal Gupta</h3>
                <p className="title">Faculty Of Data Science</p>
                <p className="description">
                Vishal has partnered with countless companies, building up
                  an impressive depth of proficiency in the data science field.
                  His experiences involve dealing with numerous data categories
                  and applying a wide spectrum of analytical techniques.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
                                */}



      <section className="newsstrip">
        <div className="container">

          <div className="newsleftinfo mb-4">
            <h3>Logicmojo in <br />the News</h3>
          </div>

          <div className="reclogoinfo">
            <ul>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a href="https://www.business-standard.com/content/specials/edtech-firm-logicmojo-comes-up-with-a-platform-for-riveting-live-learning-122051600891_1.html"><img src="assets/images/newslogo01.jpg" border="0" alt="" /></a>
                </div>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a href="https://www.hindustantimes.com/brand-stories/logicmojo-an-edtech-firm-launches-a-platform-for-interactive-and-live-learning-101653369123410.html"><img src="assets/images/newslogo02.jpg" border="0" alt="" /></a>
                </div>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a href="https://yourstory.com/companies/logicmojo"><img src="assets/images/newslogo03.jpg" border="0" alt="" /></a>
                </div>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a href="https://theprint.in/ani-press-releases/logicmojo-data-science-course-transitioning-from-software-professionals-to-data-scientist/1928940/"><img src="assets/images/theprint.jpeg" border="0" alt="" /></a>
                </div>

              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.tribuneindia.com/news/impact-feature/logicmojo-data-science-course-review-573816"><img src="assets/images/theTribuneNews.jpg" border="0" alt="" /></a>
                </div>

              </li>

              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.aninews.in/news/business/business/logicmojo-data-science-course-transitioning-from-software-professionals-to-data-scientist20240118141852/"><img src="assets/images/ANINews.jpg" border="0" alt="" /></a>
                </div>

              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.dnaindia.com/india/report-logicmojo-data-science-course-to-become-data-scientist-in-2024-3072700"><img src="assets/images/DNANews.jpg" border="0" alt="" /></a>
                </div>

              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.msn.com/en-us/money/careers/logicmojo-data-science-course-best-place-to-learn-data-science-ai-in-india/ar-AA1mkOW9"><img src="assets/images/msnwhite.jpeg" border="0" alt="" /></a>
                </div>

              </li>

              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://www.digitaljournal.com/pr/news/cdn-newswire/logicmojo-data-science-course-review-1386609983.html"><img src="assets/images/digitaljournal.jpg" border="0" alt="" /></a>
                </div>

              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv">
                  <a target="default" href="https://ed.ted.com/best_of_web/2YXTGm38/digdeeper"><img src="assets/images/ted.jpeg" border="0" alt="" /></a>
                </div>

              </li>

            </ul>
          </div>

        </div>
      </section>

      <section className="newsstrip">
        <div className="container">

          <div className="newsleftinfo mb-4">
            <h3>Logicmojo <b style={{ fontSize: 28, color:"#9769ef" }}>Recognition</b> <br />& Affiliation</h3>
          </div>

          <div className="reclogoinfo">
            <ul>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv1">
                  <a target="_default" href="https://m.canvas.umich.edu/eportfolios/2819/Home/From_Novice_to_Expert_The_Journey_of_a_Full_Stack_Developer_with_Logicmojo"><img width="150" height="150" src="assets/images/university1.jpg" border="0" alt="" /></a>
                </div>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv1">
                  <a target="_default" href="https://pressbooks.umn.edu/blogger/chapter/cracking-the-code-how-logicmojo-equips-candidates-for-top-tech-interviews/"><img width="220" height="150" src="assets/images/university2.jpeg" border="0" alt="" /></a>
                </div>
              </li>

              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv1">
                  <a target="_default" href="https://canvas.ubc.ca/eportfolios/49408/Home/Logicmojo_Bridging_the_Gap_Integrating_RealWorld_Applications_into_AI_and_Data_Science_Courses"><img width="220" height="150" src="assets/images/british.jpg" border="0" alt="" /></a>
                </div>
              </li>
              <li style={{ fontsize: 14 }}>
                <div className="reclogdiv1">
                  <a target="_default" href="https://cpeonline.ucdavis.edu/eportfolios/533/Home/Unlocking_the_Digital_World_Logicmojos_Full_Stack_Developer_Course_for_Aspiring_Tech_Professionals"><img width="220" height="150" src="assets/images/ucdavis.jpg" border="0" alt="" /></a>
                </div>
              </li>


            </ul>
          </div>

        </div>
      </section>

      <section className="relatedcourses">
        <div className="container ">
          <h2>Data Science Blogs</h2>
          <OwlCarousel
            className="owl-theme with-nav"
            loop
            margin={20}
            nav
            navText={[
              " ",
              " ",
            ]}
            responsive={{
              0: {
                items: 1
              },
              600: {
                items: 1
              },
              1000: {
                items: 3
              }
            }}
          >



            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-interview-questions"
                >
                  <img src="assets/images/data-science-interview.jpeg" alt="" />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Data Science Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-introduction"
                >
                  <img
                    src="assets/images/mac/what-is-data-science-Intro.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Introduction : What is Data Science</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/machine-learning-interview-questions"
                >
                  <img
                    src="assets/images/mac/machine-learning-interview-question.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Machine Learning Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-scientist-salary"
                >
                  <img
                    src="assets/images/mac/Data-Scientist-Salary.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>What is Data Scientist Salary in India</h3>
                </div>
              </div>
            </div>

          </OwlCarousel>
        </div>
      </section>


      <section id="relatedcourses" className="relatedcourses">
        <div className="container ">
          <h2>Related Data Science Courses</h2>
          <OwlCarousel
            className="owl-theme with-nav"
            loop
            margin={20}
            nav
            navText={[
              " ",
              " ",
            ]}
            responsive={{
              0: {
                items: 1
              },
              600: {
                items: 1
              },
              1000: {
                items: 3
              }
            }}
          >



            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Advance-Data-Science-ML-Program">
                  <img
                    src="assets/images/resources/advance_data_Science_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Advance Data Science & AI Program
                  </h3>
                  <p style={{ fontsize: 14 }}>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>5096 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Advance-AI-ML-program">
                  <img
                    src="assets/images/resources/advance_ai_ml_program.jpg"
                    alt=""
                  />
                </Link>

                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>Advance AI & ML Program </h3>
                  <p style={{ fontsize: 14 }}>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>8976 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/master-data-Science-ai-program">
                  <img
                    src="assets/images/resources/data_science_master_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    AI Fundamental for Beginner
                  </h3>
                  <p style={{ fontsize: 14 }}>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>10022 Learners</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Data-Science-For-Freshers">
                  <img
                    src="assets/images/resources/Data-Science-Fundamental.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Data Science Course For Freshers
                  </h3>
                  <p style={{ fontsize: 14 }}>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>986 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Data-Science-Course-For-Managers">
                  <img
                    src="assets/images/resources/data-Science-for-Managers.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Data Science Course For Managers
                  </h3>
                  <p style={{ fontsize: 14 }}>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>1786 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Practical-Decision-Making-in-Data-Science">
                  <img
                    src="assets/images/resources/Data-Science-Freshers.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    AI Fundamental Course
                  </h3>
                  <p style={{ fontsize: 14 }}>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>1586 Learners</span>
                  </p>
                </div>
              </div>
            </div>

          </OwlCarousel>
        </div>
      </section>


      <section className="city-section">
        <div className="container ">
          <div className="row">
            <div className="col-lg-8 master-page-city-wrapper">
              <h2>
                <strong>
                  Find Data Science Course in Other Regions
                </strong>
              </h2>
              <div className="city-link-container">
                <Link
                  title="Data Science Course in Pune"
                  to="/Data-Science-Course-in-Pune"
                >
                  Pune
                </Link>
                <Link
                  title="Data Science Course in Bangalore"
                  to="/Data-Science-Course-in-bangalore"
                >
                  Bangalore
                </Link>
                <Link
                  title="Data Science Course in Ahmedabad"
                  to="/Data-Science-Course-Ahmedabad"
                >
                  Ahmedabad
                </Link>
                <Link
                  title="Data Science Course in Bhilai"
                  to="/Data-Science-Course-Bhilai"
                >
                  Bhilai
                </Link>
                <Link
                  title="Data Science Course in Bhopal"
                  to="/Data-Science-Course-Bhopal"
                >
                  Bhopal
                </Link>
                <Link
                  title="Data Science Course in Bhubaneshwar"
                  to="/Data-Science-Course-Bhubaneshwar"
                >
                  Bhubaneshwar
                </Link>
                <Link
                  title="Data Science Course in Boston"
                  to="/Data-Science-Course-Boston"
                >
                  Boston
                </Link>
                <Link
                  title="Data Science Course in Chandigarh"
                  to="/Data-Science-Course-Chandigarh"
                >
                  Chandigarh
                </Link>
                <Link
                  title="Data Science Course in Chennai"
                  to="/Data-Science-Course-Chennai"
                >
                  Chennai
                </Link>
                <Link
                  title="Data Science Course in Chicago"
                  to="/Data-Science-Course-Chicago"
                >
                  Chicago
                </Link>
                <Link
                  title="Data Science Course in Cochin"
                  to="/Data-Science-Course-Cochin"
                >
                  Cochin
                </Link>
                <Link
                  title="Data Science Course in Coimbatore"
                  to="/Data-Science-Course-Coimbatore"
                >
                  Coimbatore
                </Link>
                <Link
                  title="Data Science Course in Dallas"
                  to="/Data-Science-Course-Dallas"
                >
                  Dallas
                </Link>
                <Link
                  title="Data Science Course in Dehradun"
                  to="/Data-Science-Course-Dehradun"
                >
                  Dehradun
                </Link>
                <Link
                  title="Data Science Course in Delhi"
                  to="/Data-Science-Course-Delhi"
                >
                  Delhi
                </Link>
                <Link
                  title="Data Science Course in Dubai"
                  to="/Data-Science-Course-Dubai"
                >
                  Dubai
                </Link>
                <Link
                  title="Data Science Course in Durban"
                  to="/Data-Science-Course-Durban"
                >
                  Durban
                </Link>
                <Link
                  title="Data Science Course in Faridabad"
                  to="/Data-Science-Course-Faridabad"
                >
                  Faridabad
                </Link>
                <Link
                  title="Data Science Course in Ghaziabad"
                  to="/Data-Science-Course-Ghaziabad"
                >
                  Ghaziabad
                </Link>
                <Link
                  title="Data Science Course in Guntur"
                  to="/Data-Science-Course-Guntur"
                >
                  Guntur
                </Link>
                <Link
                  title="Data Science Course in Gurgaon"
                  to="/Data-Science-Course-Gurgaon"
                >
                  Gurgaon
                </Link>
                <Link
                  title="Data Science Course in Guwahati"
                  to="/Data-Science-Course-Guwahati"
                >
                  Guwahati
                </Link>
                <Link
                  title="Data Science Course in HongKong"
                  to="/Data-Science-Course-HongKong"
                >
                  HongKong
                </Link>
                <Link
                  title="Data Science Course in Hyderabad"
                  to="/Data-Science-Course-Hyderabad"
                >
                  Hyderabad
                </Link>
                <Link
                  title="Data Science Course in Jaipur"
                  to="/Data-Science-Course-Jaipur"
                >
                  Jaipur
                </Link>
                <Link
                  title="Data Science Course in Johannesburg"
                  to="/Data-Science-Course-Johannesburg"
                >
                  Johannesburg
                </Link>
                <Link
                  title="Data Science Course in Los Kanpur"
                  to="/Data-Science-Course-Kanpur"
                >
                  Kanpur
                </Link>
                <Link
                  title="Data Science Course in Khammam"
                  to="/Data-Science-Course-Khammam"
                >
                  Khammam
                </Link>
                <Link
                  title="Data Science Course in Kolkata"
                  to="/Data-Science-Course-Kolkata"
                >
                  Kolkata
                </Link>
                <Link
                  title="Data Science Course in LosAngeles"
                  to="/Data-Science-Course-LosAngeles"
                >
                  LosAngeles
                </Link>
                <Link
                  title="Data Science Course in Lucknow"
                  to="/Data-Science-Course-Lucknow"
                >
                  Lucknow
                </Link>
                <Link
                  title="Data Science Course in Madurai"
                  to="/Data-Science-Course-Madurai"
                >
                  Madurai
                </Link>
                <Link
                  title="Data Science Course in Miami"
                  to="/Data-Science-Course-Miami"
                >
                  Miami
                </Link>
                <Link
                  title="Data Science Course in Mumbai"
                  to="/Data-Science-Course-Mumbai"
                >
                  Mumbai
                </Link>
                <Link
                  title="Data Science Course in Mysore"
                  to="/Data-Science-Course-Mysore"
                >
                  Mysore
                </Link>
                <Link
                  title="Data Science Course in Nagpur"
                  to="/Data-Science-Course-Nagpur"
                >
                  Nagpur
                </Link>
                <Link
                  title="Data Science Course in Noida"
                  to="/Data-Science-Course-Noida"
                >
                  Noida
                </Link>
                <Link
                  title="Data Science Course in Patna"
                  to="/Data-Science-Course-Patna"
                >
                  Patna
                </Link>
                <Link
                  title="Data Science Course in Pondicherry"
                  to="/Data-Science-Course-Pondicherry"
                >
                  Pondicherry
                </Link>
                <Link
                  title="Data Science Course in Ranchi"
                  to="/Data-Science-Course-Ranchi"
                >
                  Ranchi
                </Link>
                <Link
                  title="Data Science Course in Seattle"
                  to="/Data-Science-Course-Seattle"
                >
                  Seattle
                </Link>
                <Link
                  title="Data Science Course in Shimoga"
                  to="/Data-Science-Course-Shimoga"
                >
                  Shimoga
                </Link>
                <Link
                  title="Data Science Course in Surat"
                  to="/Data-Science-Course-Surat"
                >
                  Surat
                </Link>
                <Link
                  title="Data Science Course in Thane"
                  to="/Data-Science-Course-Thane"
                >
                  Thane
                </Link>
                <Link
                  title="Data Science Course in Thiruvananthapuram"
                  to="/Data-Science-Course-Thiruvananthapuram"
                >
                  Thiruvananthapuram
                </Link>
                <Link
                  title="Data Science Course in Tiruchchirappalli"
                  to="/Data-Science-Course-Tiruchchirappalli"
                >
                  Tiruchchirappalli
                </Link>
                <Link
                  title="Data Science Course in Tirupati"
                  to="/Data-Science-Course-Tirupati"
                >
                  Tirupati
                </Link>
                <Link
                  title="Data Science Course in Toronto"
                  to="/Data-Science-Course-Toronto"
                >
                  Toronto
                </Link>
                <Link
                  title="Data Science Course in Trichur"
                  to="/Data-Science-Course-Trichur"
                >
                  Trichur
                </Link>
                <Link
                  title="Data Science Course in Vadodara"
                  to="/Data-Science-Course-Vadodara"
                >
                  Vadodara
                </Link>
                <Link
                  title="Data Science Course in Visakhapatnam"
                  to="/Data-Science-Course-Visakhapatnam"
                >
                  Visakhapatnam
                </Link>
                <Link
                  title="Data Science Course in Warangal"
                  to="/Data-Science-Course-Warangal"
                >
                  Warangal
                </Link>
                <Link
                  title="Data Science Course in Washington"
                  to="/Data-Science-Course-Washington"
                >
                  Washington
                </Link>
                <Link
                  title="Data Science Course in Mountain View"
                  to="/Data-Science-Course-MountainView"
                >
                  Mountain View
                </Link>
                <Link
                  title="Data Science Course in Ashburn"
                  to="/Data-Science-Course-Ashburn"
                >
                  Ashburn
                </Link>
                <Link
                  title="Data Science Course in Charlotte"
                  to="/Data-Science-Course-Charlotte"
                >
                  Charlotte
                </Link>
                <Link
                  title="Data Science Course in Austin"
                  to="/Data-Science-Course-Austin"
                >
                  Austin
                </Link>
                <Link
                  title="Data Science Course in San Diego"
                  to="/Data-Science-Course-SanDiego"
                >
                  San Diego
                </Link>
                <Link
                  title="Data Science Course in Irving"
                  to="/Data-Science-Course-Irving"
                >
                  Irving
                </Link>
                <Link
                  title="Data Science Course in Columbus"
                  to="/Data-Science-Course-Columbus"
                >
                  Columbus
                </Link>
                <Link
                  title="Data Science Course in Sunnyvale"
                  to="/Data-Science-Course-Sunnyvale"
                >
                  Sunnyvale
                </Link>
                <Link
                  title="Data Science Course in Fremont"
                  to="/Data-Science-Course-Fremont"
                >
                  Fremont
                </Link>
                <Link
                  title="Data Science Course in Denver"
                  to="/Data-Science-Course-Denver"
                >
                  Denver
                </Link>
                <Link
                  title="Data Science Course in Philadelphia"
                  to="/Data-Science-Course-Philadelphia"
                >
                  Philadelphia
                </Link>
                <Link
                  title="Data Science Course in Vijayawada"
                  to="/Data-Science-Course-Vijayawada"
                >
                  Vijayawada
                </Link>
                <Link
                  title="Data Science Course in Ireland"
                  to="/Data-Science-Course-Ireland"
                >
                  Ireland
                </Link>

                <Link
                  title="Data Science Course in Jamshedpur"
                  to="/Data-Science-Course-Jamshedpur"
                >
                  Jamshedpur
                </Link>
                <Link
                  title="Data Science Course in Kerala"
                  to="/Data-Science-Course-Kerala"
                >
                  Kerala
                </Link>
                <Link
                  title="Data Science Course in TamilNadu"
                  to="/Data-Science-Course-TamilNadu"
                >
                  TamilNadu
                </Link>

                <Link
                  title="Data Science Course in AbuDhabi"
                  to="/Data-Science-Course-AbuDhabi"
                >
                  AbuDhabi
                </Link>
                <Link
                  title="Data Science Course in Ludhiana"
                  to="/Data-Science-Course-Ludhiana"
                >
                  Ludhiana
                </Link>
                <Link
                  title="Data Science Course in Ernakulam"
                  to="/Data-Science-Course-Ernakulam"
                >
                  Ernakulam
                </Link>
                <Link
                  title="Data Science Course in Kottayam"
                  to="/Data-Science-Course-Kottayam"
                >
                  Kottayam
                </Link>
                <Link
                  title="Data Science Course in Khammam"
                  to="/Data-Science-Course-Khammam"
                >
                  Khammam
                </Link>
                <Link
                  title="Data Science Course in Jacksonville"
                  to="/Data-Science-Course-Jacksonville"
                >
                  Jacksonville
                </Link>
                <Link
                  title="Data Science Course in Newark"
                  to="/Data-Science-Course-Newark"
                >
                  Newark
                </Link>
                <Link
                  title="Data Science Course in Pittsburgh"
                  to="/Data-Science-Course-Pittsburgh"
                >
                  Pittsburgh
                </Link>
                <Link
                  title="Data Science Course in Raleigh"
                  to="/Data-Science-Course-Raleigh"
                >
                  Raleigh
                </Link>
                <Link
                  title="Data Science Course in Salem"
                  to="/Data-Science-Course-Salem"
                >
                  Salem
                </Link>
                <Link
                  title="Data Science Course in Sarasota"
                  to="/Data-Science-Course-Sarasota"
                >
                  Sarasota
                </Link>
                <Link
                  title="Data Science Course in Tacoma"
                  to="/Data-Science-Course-Tacoma"
                >
                  Tacoma
                </Link>
                <Link
                  title="Data Science Course in Tampa"
                  to="/Data-Science-Course-Tampa"
                >
                  Tampa
                </Link>
                <Link
                  title="Data Science Course in Abuja"
                  to="/Data-Science-Course-Abuja"
                >
                  Abuja
                </Link>
                <Link
                  title="Data Science Course in Lagos"
                  to="/Data-Science-Course-Lagos"
                >
                  Lagos
                </Link>
                <Link
                  title="Data Science Course in Manila"
                  to="/Data-Science-Course-Manila"
                >
                  Manila
                </Link>
                <Link
                  title="Data Science Course in CapeTown"
                  to="/Data-Science-Course-CapeTown"
                >
                  CapeTown
                </Link>
                <Link
                  title="Data Science Course in Calgary"
                  to="/Data-Science-Course-Calgary"
                >
                  Calgary
                </Link>
                <Link
                  title="Data Science Course in Montreal"
                  to="/Data-Science-Course-Montreal"
                >
                  Montreal
                </Link>
                <Link
                  title="Data Science Course in Vancouver"
                  to="/Data-Science-Course-Vancouver"
                >
                  Vancouver
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="btn-center-section" id="faq" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

      <section ref={faqSection} id="faq" className="faqnewbg py-0">
        <div className="container clearfix">
          <h2>
            <b>Logicmojo Data Science Frequently Asked Questions</b>
          </h2>
          <div className="faqnewbg-inner">
            <div className="faqnew">
              <div className="accordion" id="accordionExample2">


                
                <div className="card">
                  <div className="card-header" id="heading00">
                    <h3 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse00"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> Who should take
                        this Data Science Course ?
                      </button>
                    </h3>
                  </div>

                  <div
                    id="collapse00"
                    className="collapse"
                    aria-labelledby="heading00"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p style={{ fontsize: 14 }}>
                        The role of a Data Scientist demands a combination of
                        experience, knowledge in Data Science, and proficiency
                        in relevant tools and technologies. It is a promising
                        career path for both experienced and novice
                        professionals. Individuals with an analytical mindset
                        from any educational background are well-suited to
                        undertake Data Science Course.
                      </p>
                      <ul>
                        <li style={{ fontsize: 14 }}>IT Professionals</li>
                        <li style={{ fontsize: 14 }}>Analytics Managers</li>
                        <li style={{ fontsize: 14 }}>Business Analysts</li>
                        <li style={{ fontsize: 14 }}>Banking and Finance Professionals</li>
                        <li style={{ fontsize: 14 }}>Marketing Managers</li>
                        <li style={{ fontsize: 14 }}>Supply Chain Network Managers</li>
                        <li style={{ fontsize: 14 }}>
                          Beginners or Recent Graduates in Bachelor’s or
                          Master’s Degree
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>



                <div className="card">
                  <div className="card-header" id="heading02">
                    <h3 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse02"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> Why do you want to
                        join this course data science ?
                      </button>
                    </h3>
                  </div>

                  <div
                    id="collapse02"
                    className="collapse"
                    aria-labelledby="heading02"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p style={{ fontsize: 14 }}>
                        Due to the growing demand for data-driven solutions in
                        businesses, there is a significant increase in the need
                        for data scientists who possess the necessary skills in
                        Data Science. This online Data Science Course
                        will enable you to develop expertise in various areas,
                        such as Data Science, R programming language, Data
                        Analysis, and Big Data. Obtaining this certification can
                        expedite your career growth in this rapidly developing
                        field and propel it to the next level.
                      </p>
                      <ul>
                        <li style={{ fontsize: 14 }}>
                          The average annual salary of Data Scientists as
                          per Indeed is US$15,00,000 in India.
                        </li>
                        <li style={{ fontsize: 14 }}>
                          Data Scientist is the best job in the 21st century
                          — Harvard Business Review
                        </li>
                        <li style={{ fontsize: 14 }}>
                          The number of jobs for all data professionals in the
                          India will increase to 3.4 million — IBM
                        </li>
                        <li style={{ fontsize: 14 }}>
                          Global Big Data market achieves US$122 billion in
                          sales in 6 years — Frost & Sullivan
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading04">
                    <h3 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse04"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i>What are the
                        educational goals of this Data Science course ?
                      </button>
                    </h3>
                  </div>

                  <div
                    id="collapse04"
                    className="collapse"
                    aria-labelledby="heading04"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p style={{ fontsize: 14 }}>
                        Data Science has emerged as one of the most in-demand
                        professions this year, with the United States Bureau of
                        Labor Statistics forecasting remarkable growth and
                        predicting 11.5 million job opportunities by 2026,
                        growing at an annual rate of 28%. Logicmojo Data Science
                        course, developed in collaboration with IBM, is designed
                        to help you master essential skills critical to the job,
                        such as data mining, statistics, hypothesis testing,
                        decision trees, clustering, logistic and linear
                        regression, data wrangling, data visualization,
                        supervised and unsupervised learning, recommendation
                        engines, and more.
                      </p>
                      <p style={{ fontsize: 14 }}>
                        This comprehensive Data Science course combines both
                        live-online instructor-led classes and self-paced
                        learning videos co-developed with IBM. Additionally, it
                        concludes with a Capstone project that reinforces the
                        training by allowing you to build a relevant product
                        that encompasses all the crucial aspects learned
                        throughout the program. By mastering the skills taught
                        in this Data Science course, you can better prepare
                        yourself for the role of a Data Scientist.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading0501">
                    <h3 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse0501"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> What
                        tools/technology will you learn with Data Science
                        course?
                      </button>
                    </h3>
                  </div>

                  <div
                    id="collapse0501"
                    className="collapse"
                    aria-labelledby="heading0501"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p style={{ fontsize: 14 }}>
                        A comprehensive Data Science course equips learners with
                        various tools and technologies essential for data
                        analysis, visualization, and modeling. Here is a list of
                        some key tools and technologies you can expect to learn
                        during a Data Science course:
                      </p>
                      <ul>
                        <p style={{ fontsize: 14 }}>
                          <b>Programming Languages</b>
                        </p>
                        <ul>
                          <li style={{ fontsize: 14 }}>
                            Python : Python is a versatile, open-source
                            programming language widely used in data science due
                            to its readability, extensive libraries, and large
                            community support.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            R : R is another open-source programming language
                            specifically designed for statistical computing and
                            graphics. It is widely used for data manipulation,
                            visualization, and statistical modeling.
                          </li>
                        </ul>
                        <p style={{ fontsize: 14 }}>
                          <b>Data Manipulation and Analysis Libraries</b>
                        </p>
                        <ul>
                          <li style={{ fontsize: 14 }}>
                            Pandas (Python) : Pandas is a popular Python library
                            for data manipulation and analysis. It provides data
                            structures and functions needed to work with
                            structured data seamlessly.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            NumPy (Python) : NumPy is a fundamental library for
                            numerical computing in Python. It provides support
                            for large, multi-dimensional arrays and matrices,
                            along with a collection of mathematical functions to
                            operate on these arrays.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            dplyr (R) : dplyr is an R package for data
                            manipulation. It provides a set of tools for
                            efficiently transforming, summarizing, and
                            rearranging large datasets.
                          </li>
                        </ul>
                        <p style={{ fontsize: 14 }}>
                          <b>Data Visualization Libraries</b>
                        </p>
                        <ul>
                          <li style={{ fontsize: 14 }}>
                            Matplotlib (Python) : Matplotlib is a 2D plotting
                            library for Python that allows the creation of
                            various types of plots, histograms, and charts.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            Seaborn (Python) : Seaborn is a statistical data
                            visualization library based on Matplotlib. It
                            provides a high-level interface for creating
                            visually appealing and informative statistical
                            graphics.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            ggplot2 (R) : ggplot2 is a popular R package for
                            creating complex and professional-looking
                            visualizations using a concise syntax based on the
                            Grammar of Graphics.
                          </li>
                        </ul>
                        <p style={{ fontsize: 14 }}>
                          <b>Machine Learning Libraries</b>
                        </p>
                        <ul>
                          <li style={{ fontsize: 14 }}>
                            Scikit-learn (Python) : Scikit-learn, a prevalent
                            Python-based machine learning library, offers
                            user-friendly and effective instruments for data
                            exploration and evaluation. It accommodates an array
                            of machine learning methodologies, encompassing
                            classification, regression, and clustering
                            techniques
                          </li>
                          <li style={{ fontsize: 14 }}>
                            TensorFlow (Python) : TensorFlow is an open-source
                            machine learning library developed by Google. It is
                            widely used for deep learning applications, such as
                            neural networks and reinforcement learning.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            Keras (Python) : Keras, a sophisticated neural
                            network interface penned in Python, operates
                            seamlessly atop TensorFlow, Microsoft Cognitive
                            Toolkit, Theano, or PlaidML. Boasting
                            user-friendliness, it fosters swift trials involving
                            intricate neural networks.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            Caret (R) : Caret is an R package that streamlines
                            the process of building predictive models. It
                            provides tools for data splitting, pre-processing,
                            feature selection, model tuning, and more.
                          </li>
                        </ul>
                        <p style={{ fontsize: 14 }}>
                          <b>Big Data Technologies</b>
                        </p>
                        <ul>
                          <li style={{ fontsize: 14 }}>
                            Apache Hadoop : Apache Hadoop is an open-source
                            distributed computing framework that enables
                            processing and storage of large datasets across
                            clusters of computers using simple programming
                            models.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            Apache Spark : Apache Spark is an open-source,
                            distributed computing system that provides a fast
                            and general-purpose cluster-computing framework for
                            big data processing.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            NoSQL Databases : NoSQL databases, including MongoDB
                            and Cassandra, represent non-relational databases
                            devised to manage copious amounts of both structured
                            and unstructured data, ensuring scalability and
                            steadfast accessibility.
                          </li>
                          <li style={{ fontsize: 14 }}>
                            To sum up, a Data Science course encompasses a
                            diverse array of instruments and innovations that
                            empower learners to gather, scrutinize, depict, and
                            formulate data. Gaining proficiency in these tools
                            is crucial for aspiring data scientists as they
                            tackle intricate, real-world challenges
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </div>
                </div>

                <button
                  onClick={() => setTg(!toggle)}
                  className="btn btn-primary mb-3 viewmorebtn"
                >
                  {toggle ? "View Less" : "View More"}
                </button>

                {toggle && (
                  <div className="morefaq">
                    <div className="card">
                      <div className="card-header" id="heading07">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse07"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> The average
                            annual salary of Data Science Engineer as per Report
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse07"
                        className="collapse"
                        aria-labelledby="heading07"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            In India, the average salary of a Data Science
                            Engineer is INR : 21,42,957.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading08">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse08"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What does the
                            responsibilities as a Data Scientist in IT ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse08"
                        className="collapse"
                        aria-labelledby="heading08"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Data Scientists hold an essential position within
                            the IT realm by deriving significant understanding
                            from immense data quantities, thereby bolstering
                            informed decision-making. In this piece, we delve
                            into the primary duties of a Data Scientist in the
                            IT field
                          </p>
                          <p style={{ fontsize: 14 }}>
                            <b>Data Collection and Pre-processing</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              A Data Scientist's tasks involve gathering
                              information from diverse origins, such as
                              databases, APIs, and web extraction. Their duty is
                              to refine, prepare, and convert unprocessed data
                              into organized forms apt for subsequent
                              examination, while maintaining data precision and
                              uniformity
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Data Exploration and Analysis</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data Scientists examine and scrutinize data to
                              detect tendencies, recurring motifs, and
                              irregularities. They employ statistical methods,
                              including descriptive statistics, inferential
                              statistics, and hypothesis evaluation, to
                              encapsulate and elucidate data. This approach aids
                              in uncovering connections and prospective
                              revelations that can steer business choices
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Feature Engineering and Selection</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data Scientists examine and scrutinize data to
                              detect tendencies, recurring motifs, and
                              irregularities. They employ statistical methods,
                              including descriptive statistics, inferential
                              statistics, and hypothesis evaluation, to
                              encapsulate and elucidate data. This approach aids
                              in uncovering connections and prospective
                              revelations that can steer business choices
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>
                              Developing and Implementing Machine Learning
                              Models
                            </b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data Scientists build, train, and evaluate machine
                              learning models to solve specific business
                              problems. They choose appropriate algorithms, such
                              as regression, classification, or clustering, and
                              fine-tune model parameters to optimize
                              performance. They also validate models using
                              techniques like cross-validation and assess their
                              accuracy, precision, recall, and other relevant
                              metrics.
                            </li>
                            <p style={{ fontsize: 14 }}>
                              <b>Data Visualization and Communication</b>
                            </p>
                            <li style={{ fontsize: 14 }}>
                              Data Scientists craft visual depictions of data
                              assessments and modeled outcomes to convey
                              intricate data efficiently. Utilizing data
                              visualization instruments and libraries, like
                              Matplotlib, Seaborn, or ggplot2, they generate
                              plots, diagrams, and visual representations that
                              simplify comprehension and guide decision-making
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Collaboration with Cross-Functional Teams</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data Scientists collaborate intimately with
                              diverse teams across the organization, including
                              product managers, software engineers, and business
                              analysts. They establish project goals,
                              synchronize data-focused approaches, and guarantee
                              the triumphant execution of data-centered
                              resolutions
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Staying Updated with Emerging Technologies</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data Scientists must continuously update their
                              knowledge and skills in the rapidly evolving field
                              of data science. They should stay informed about
                              new algorithms, tools, and best practices to
                              improve their workflow and contribute effectively
                              to their organization's success.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading09">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse09"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Flexi
                            Subscription in Data Science Foundation Program?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse09"
                        className="collapse"
                        aria-labelledby="heading09"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Individuals who register for live classroom training
                            in Data Science are entitled to a Flexi Pass. This
                            pass grants access to ongoing batch information for
                            a duration of 2 years, enabling participants to
                            attend live sessions from any batch and learn at
                            their own pace. This option is particularly
                            advantageous for those who work shifts or weekends.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading10">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse10"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            prerequisites to start a career in Data Science ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse10"
                        className="collapse"
                        aria-labelledby="heading10"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            If you are interested in learning Data Science
                            course, there are several prerequisites that you
                            should consider due to the increasing demand in this
                            field:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Mathematical Skills: A strong foundation in
                              mathematical concepts like linear algebra,
                              matrices, calculus, gradients, etc. is a major
                              prerequisite for taking up Data Science course.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Programming Skills: It is essential to have a good
                              understanding of programming languages such as
                              Python, C, C++, SQL, Java, etc. to gain complete
                              knowledge and understanding throughout the Data
                              Science online course.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Data Processing: As Data Science revolves around
                              handling data, it is crucial to be familiar with
                              data mining, data modeling, data processing, etc.,
                              which will help you pursue Data Science Online
                              Course with ease.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Statistical Analysis: Possessing expertise in
                              statistical analysis is a significant advantage
                              when it comes to learning Data Science. Data
                              Science aims to extract valuable insights from
                              vast collections of data, and experience working
                              with analytical tools such as Hadoop, Python, SAS,
                              and many more can help you perform statistical
                              analytics efficiently.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Data Visualization Skills: Familiarity with data
                              visualization tools such as Matplotlib, Tableau,
                              and others can help you comprehend complex
                              outcomes and enable your audience to understand
                              the metrics.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading11">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse11"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Why should I
                            enroll for Logicmojo Data Science Course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse11"
                        className="collapse"
                        aria-labelledby="heading11"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Logicmojo provides top-notch online Data Science
                            courses for professionals seeking to broaden their
                            knowledge and establish a career in this field.
                            There are numerous compelling reasons to select
                            Logicmojo as your preferred training provider:
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>A personal mentor to track your progress</li>
                            <li style={{ fontsize: 14 }}>
                              Immersive online instructor-led sessions conducted
                              by SMEs
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Extensive LMS, allowing you to view recorded
                              sessions within 3 hours
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Real-time exercises, assignments, and projects
                            </li>
                            <li style={{ fontsize: 14 }}>24/7 learning support</li>
                            <li style={{ fontsize: 14 }}>A large community of like-minded learners</li>
                            <li style={{ fontsize: 14 }}>Industry-recognized Logicmojo badge</li>
                            <li style={{ fontsize: 14 }}>* Personalized job support</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading12">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse12"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What knowledge
                            can be gained from this top-notch Logicmojo Data
                            Science program? ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse12"
                        className="collapse"
                        aria-labelledby="heading12"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Through this Data Science Course, you will master
                            the following concepts:
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data analysis, project life cycle, and Data
                              Science in the real world.
                            </li>
                            <li style={{ fontsize: 14 }}>Machine Learning algorithms</li>
                            <li style={{ fontsize: 14 }}>
                              Techniques of evaluation, experimentation, and
                              project deployment
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Analysis segmentation using clustering and the
                              method of prediction.
                            </li>
                            <li style={{ fontsize: 14 }}>Python with Data Science.</li>
                            <li style={{ fontsize: 14 }}>Git, Storytelling</li>
                            <li style={{ fontsize: 14 }}>
                              Data Science at scale with PySpark, AI with
                              TensorFlow
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Deploying Machine Learning models on Clouds
                              (MLOps)
                            </li>
                            <li style={{ fontsize: 14 }}>Data visualization with Tableau</li>
                            <li style={{ fontsize: 14 }}>
                              Natural Language Processing and its applications
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Microsoft Excel for data analysis and data
                              transformation
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Data Science projects, analytics, and recommender
                              systems
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading14">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse14"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            Data Science course fees in India?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse14"
                        className="collapse"
                        aria-labelledby="heading14"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The Data Science course in India costs Rs.
                            74,000 (inclusive of taxes), and there are no-cost
                            EMI plans available for 3, 6, 9, and 12 months. The
                            no-cost EMI option starts at Rs. 4500 per month. If
                            you are interested in this payment option, please
                            call us toll-free at +91 8088975867
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading15">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse15"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            total duration of this Data Science course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse15"
                        className="collapse"
                        aria-labelledby="heading15"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The Data Science course spans over a period of 7
                            months and includes exclusive hackathons,
                            masterclasses, and ask-me-anything sessions by IBM.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading16">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse16"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            different paths to enter Data Science
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse16"
                        className="collapse"
                        aria-labelledby="heading16"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            We will explore the different paths to enter data
                            science.
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Online Learning: With its growing popularity in
                              recent times, online education stands as a
                              feasible gateway to data science. A plethora of
                              virtual courses and programs are available for
                              acquiring data science expertise.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Bootcamps: Data science bootcamps, characterized
                              by their intensive nature, equip you with the
                              essential skills for a data science career. These
                              programs span a brief period, typically lasting
                              from a few weeks to several months.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Formal Education: Entering data science through
                              traditional academia remains a popular choice.
                              Multiple degree options exist, including
                              bachelor's, master's, and PhD programs.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Bachelor's Degree: A bachelor's degree in a
                              pertinent field, such as mathematics, computer
                              science, or statistics, lays the groundwork for a
                              data science career. Students gain exposure to
                              programming languages like Python or R,
                              statistics, and data analysis methodologies.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Master's Degree: Pursuing a master's degree in
                              data science or a related discipline offers a
                              deeper understanding of the field. Advanced
                              techniques, including machine learning, data
                              mining, and data visualization, form the crux of
                              these programs.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              PhD: For those with aspirations in research or
                              academia, a data science PhD equips you with the
                              required expertise and knowledge. Advanced
                              research methodologies and participation in
                              groundbreaking projects are key components of
                              these programs.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Self-Learning: As an alternative, self-learning
                              also paves the way for entering data science.
                              Numerous online resources, such as blogs,
                              tutorials, and videos, are available to hone data
                              science skills. Nonetheless, self-learning demands
                              discipline and motivation.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Certifications: Securing various certifications
                              helps showcase your data science prowess to
                              potential employers. Well-regarded certifications
                              include Certified Analytics Professional (CAP),
                              IBM Data Science Professional Certificate, and
                              Microsoft Certified: Azure Data Scientist
                              Associate.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading17">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse17"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Which
                            programming language is helpful in Data Science &
                            why?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse17"
                        className="collapse"
                        aria-labelledby="heading17"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Selecting an apt programming language for data
                            science hinges on myriad factors, such as the
                            quandary's nature, the magnitude of the data set,
                            and the data scientist's prowess. Neophytes can
                            commence with Python or R, offering a gentle
                            learning gradient and a vast array of instruments
                            for data dissection. Conversely, if the data set is
                            colossal, SQL may be the prime selection for data
                            preprocessing and purification. Should the
                            undertaking necessitate statistical scrutiny, SAS
                            could be the superior alternative.
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Python: Python is an elevated programming
                              language, prevalently employed in the realm of
                              data science. Boasting a minimalist syntax, it
                              facilitates effortless learning for novices.
                              Python offers an extensive assortment of libraries
                              and frameworks for data science, encompassing
                              NumPy, Pandas, Matplotlib, and Scikit-learn.
                              Moreover, Python finds applications in web
                              development, machine learning, and artificial
                              intelligence.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              R: R, a statistical programming language, enjoys
                              widespread utilization in data science. It
                              proffers an expansive array of statistical and
                              graphical techniques for data dissection.
                              Additionally, R is employed for data
                              visualization, machine learning, and prognostic
                              modeling. Despite R's steeper learning incline
                              compared to Python, it remains a potent apparatus
                              for statistical analysis.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              SQL: SQL, a domain-specific language, excels in
                              managing and manipulating relational databases. It
                              is prevalently adopted in data science for data
                              extraction, transformation, and loading.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              SAS: SAS, a proprietary statistical software
                              suite, is employed for data administration,
                              analysis, and visualization. Industries such as
                              healthcare, finance, and marketing extensively
                              utilize SAS. Although SAS presents a steeper
                              learning curve, it offers an ample range of tools
                              for data dissection and modeling.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading18">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse18"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Which Companies
                            hire data scientist?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse18"
                        className="collapse"
                        aria-labelledby="heading18"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Data scientists employ an assortment of tools and
                            techniques to scrutinize vast datasets, extracting
                            insights that aid businesses in making well-informed
                            decisions. Their expertise spans machine learning,
                            data visualization, and statistical analysis, making
                            them highly sought after across numerous industries.
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>Google: </p>
                              <p style={{ fontsize: 14 }}>
                                As a global technology behemoth, Google
                                continually seeks exceptional talent in data
                                science. The firm maintains a dedicated team of
                                data scientists working on projects from
                                refining search algorithms to crafting machine
                                learning models for Google's cloud services.
                                Besides competitive remuneration and benefits,
                                Google fosters professional growth and career
                                progression.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>Amazon: </p>
                              <p style={{ fontsize: 14 }}>
                                Amazon, another technological titan, heavily
                                invests in data science. Data scientists operate
                                across diverse departments, including marketing,
                                advertising, operations, and logistics. They are
                                tasked with creating predictive models and
                                devising algorithms to optimize operations and
                                enhance customer experiences.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>Facebook: </p>
                              <p style={{ fontsize: 14 }}>
                                Facebook, one of the world's largest social
                                media platforms, possesses a treasure trove of
                                user data to refine its products and services.
                                The corporation maintains a vast team of data
                                scientists charged with analyzing data and
                                generating insights to better comprehend user
                                behavior. Facebook provides competitive
                                salaries, benefits, and opportunities for career
                                expansion.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>Apple: </p>
                              <p style={{ fontsize: 14 }}>
                                Apple, another tech giant, is deeply committed
                                to data science. Data scientists work across
                                various departments, from product development to
                                marketing and advertising. They are responsible
                                for constructing predictive models and
                                formulating algorithms to improve products and
                                services.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>Microsoft: </p>
                              <p style={{ fontsize: 14 }}>
                                Microsoft, a leading software company, employs a
                                data science team dedicated to developing an
                                array of products and services. Data scientists
                                tackle projects from creating machine learning
                                models for cloud services to enhancing the
                                precision of search engine results. Microsoft
                                proffers competitive salaries, benefits, and
                                opportunities for professional advancement.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>Uber: </p>
                              <p style={{ fontsize: 14 }}>
                                Uber, a company heavily reliant on data for
                                operational optimization, requires adept data
                                scientists. These specialists build predictive
                                models and design algorithms to better
                                understand user behavior and improve services.
                                Uber offers competitive remuneration, benefits,
                                and opportunities for career development.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>Netflix: </p>
                              <p style={{ fontsize: 14 }}>
                                Netflix has constructed its business around data
                                science. Data scientists work across
                                departments, from content creation to customer
                                experience management. They are charged with
                                analyzing user data and generating insights to
                                refine the company's content and services.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>LinkedIn: </p>
                              <p style={{ fontsize: 14 }}>
                                Specializing in professional networking,
                                LinkedIn necessitates skilled data scientists.
                                These experts analyze user data and develop
                                insights to help LinkedIn better understand its
                                users and enhance its services. The company
                                offers competitive salaries, benefits, and
                                opportunities for professional growth and
                                advancement.
                              </p>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading19">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse19"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            different job roles that a Data Scientist can
                            pursue?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse19"
                        className="collapse"
                        aria-labelledby="heading19"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            There are numerous job opportunities available for
                            Data Scientists,like:
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>Business Analyst.</li>
                            <li style={{ fontsize: 14 }}>Data Analyst</li>
                            <li style={{ fontsize: 14 }}>Big Data Engineer</li>
                            <li style={{ fontsize: 14 }}>Data Scientist</li>
                            <li style={{ fontsize: 14 }}>Statistician</li>
                            <li style={{ fontsize: 14 }}>Data Engineer</li>
                            <li style={{ fontsize: 14 }}>Machine Learning Engineer</li>
                            <li style={{ fontsize: 14 }}>Data Architect</li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            With the increasing demand for data science
                            professionals, many different job roles have emerged
                            in this field. In this article, we will discuss some
                            of the different job roles that a data scientist can
                            pursue.
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}>Data Scientist: </p>
                              <p style={{ fontsize: 14 }}>
                                A data scientist is responsible for collecting,
                                analyzing, and interpreting large sets of data.
                                They use various tools and techniques to extract
                                useful insights from the data and present them
                                in a way that is understandable to non-technical
                                stakeholders. They work on real-world problems
                                and help organizations make data-driven
                                decisions.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Machine Learning Engineer: </p>
                              <p style={{ fontsize: 14 }}>
                                A machine learning engineer designs and develops
                                algorithms and models that enable machines to
                                learn and make predictions from data. They work
                                closely with data scientists to create
                                predictive models that can be used to make
                                business decisions. They also optimize and
                                deploy machine learning models in production
                                environments.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Data Analyst: </p>
                              <p style={{ fontsize: 14 }}>
                                A data analyst is responsible for collecting and
                                analyzing data, and presenting it in a way that
                                is easy to understand. They work with both
                                quantitative and qualitative data to provide
                                insights that help organizations make better
                                decisions. They also identify patterns and
                                trends in data to help organizations optimize
                                their operations.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Business Intelligence Analyst: </p>
                              <p style={{ fontsize: 14 }}>
                                A business intelligence analyst is responsible
                                for collecting, analyzing, and presenting data
                                to help organizations make informed business
                                decisions. They work with data from a variety of
                                sources, including sales, marketing, and
                                operations, to identify trends and patterns that
                                can help drive business growth.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Data Engineer: </p>
                              <p style={{ fontsize: 14 }}>
                                A data engineer is responsible for designing,
                                building, and maintaining the infrastructure
                                required to store and process large amounts of
                                data. They work with data scientists and other
                                data professionals to ensure that data is stored
                                and processed efficiently and accurately.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Data Architect: </p>
                              <p style={{ fontsize: 14 }}>
                                A data architect is responsible for designing
                                and building the overall data architecture for
                                an organization. They work with data engineers
                                and other data professionals to design and
                                implement data pipelines, data storage systems,
                                and data processing frameworks that enable data
                                scientists to work efficiently.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Database Administrator: </p>
                              <p style={{ fontsize: 14 }}>
                                A database administrator is responsible for the
                                design, implementation, and maintenance of
                                databases. They ensure that data is stored
                                securely and is easily accessible by authorized
                                personnel. They also optimize database
                                performance and troubleshoot any issues that
                                arise.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Statistician: </p>
                              <p style={{ fontsize: 14 }}>
                                A statistician is responsible for designing
                                experiments and analyzing data to identify
                                patterns and trends. They work with data
                                scientists to help them develop statistical
                                models and algorithms that can be used to solve
                                business problems.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Data Journalist: </p>
                              <p style={{ fontsize: 14 }}>
                                A data journalist is responsible for collecting
                                and analyzing data to create compelling stories.
                                They use data to provide insights into current
                                events and trends, and they present their
                                findings in a way that is easy to understand for
                                the general public.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> Quantitative Analyst: </p>
                              <p style={{ fontsize: 14 }}>
                                A quantitative analyst is responsible for using
                                mathematical and statistical methods to analyze
                                financial data. They work with investment banks,
                                hedge funds, and other financial institutions to
                                help them make informed investment decisions.
                              </p>
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            In conclusion, there are many different job roles
                            that a data scientist can pursue. From data analysis
                            to machine learning, the demand for skilled
                            professionals in this field is rapidly increasing.
                            By pursuing one of these job roles, you can help
                            organizations make data-driven decisions and drive
                            business growth.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading20">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse20"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How long does
                            it take to become a Data Scientist
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse20"
                        className="collapse"
                        aria-labelledby="heading20"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            To become a data scientist, it's important to have a
                            solid background in math, statistics, computer
                            science, and programming. This usually means earning
                            a bachelor's degree in computer science, statistics,
                            math, or a related area. Data scientists also need
                            to have good analytical and critical thinking
                            abilities, and they should be able to explain
                            complicated ideas to people who aren't experts in
                            the field.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Becoming a Data Scientist can happen in a relatively
                            short time. When you finish our Data Science
                            Course, meet all the requirements, and
                            complete all the projects, you'll get a certificate
                            that's recognized by the industry. Plus, our
                            placement team is here to help you with your resume
                            and practice interviews, so you can land a
                            well-paying job as a Data Scientist.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Although, The journey to becoming a Data Scientist
                            fluctuates based on a person's history, antecedent
                            expertise, and educational trajectory. Within this
                            piece, we shall delve into the elements impacting
                            the time span needed to transform into a Data
                            Scientist while offering a rough approximation of
                            the requisite time commitment.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            <b> Educational Background</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              A robust grounding in math, statistics, and
                              computer science proves crucial for those seeking
                              a data science career. For those possessing an
                              applicable bachelor's degree, like computer
                              science, engineering, or mathematics, the learning
                              process might be expedited compared to individuals
                              hailing from dissimilar domains.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Prior Experience</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Former exposure to programming, data examination,
                              or machine learning can considerably truncate the
                              duration required to evolve into a Data Scientist.
                              Experts well-versed in these domains may merely
                              need to acquire distinct data science instruments
                              and methodologies to segue into a data science
                              position.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b> Learning Path</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Formal Education: A master's or Ph.D. program in
                              data science, statistics, or a related field
                              typically takes 2-5 years to complete. This option
                              provides in-depth knowledge and hands-on
                              experience but requires a significant time
                              commitment.
                            </li>

                            <li style={{ fontsize: 14 }}>
                              Bootcamps: Data science bootcamps offer intensive,
                              short-term training programs that usually last
                              between 3 to 6 months. These programs focus on
                              practical skills and provide a faster route to
                              enter the field compared to formal education.
                            </li>

                            <li style={{ fontsize: 14 }}>
                              Online Courses and Self-Study: Online platforms,
                              such as Coursera, edX, and Udacity, offer data
                              science courses that can be completed at your own
                              pace. The duration of this learning path depends
                              on the time you can dedicate to studying and your
                              ability to grasp new concepts.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Skill Development and Practice</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Acquiring the necessary skills for a data science
                              role, including programming languages (e.g.,
                              Python, R), data visualization, and machine
                              learning techniques, requires dedicated practice.
                              Building a portfolio of data science projects is
                              essential to showcase your skills and gain
                              practical experience. The time needed for skill
                              development and practice varies from person to
                              person.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Considering these factors, the time it takes to
                              become a Data Scientist can range from a few
                              months to several years. Individuals with relevant
                              educational backgrounds and prior experience may
                              require less time, while those starting from
                              scratch will need a longer period for learning and
                              skill development.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading21">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse21"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is this course
                            designed for individuals who are new to Data Science
                            or those who already have experience in the field
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse21"
                        className="collapse"
                        aria-labelledby="heading21"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Our Data Science course is crafted to accommodate
                            both newcomers to the field and seasoned
                            professionals aiming to boost their expertise in
                            this area.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Generally, anyone with an interest in data science
                            can find value in this course. Regardless of your
                            experience level, you have the opportunity to learn
                            new methods and broaden your skillset.
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> For beginners: </p>
                              <p style={{ fontsize: 14 }}>
                                If you're just venturing into data science, this
                                course serves as an exceptional starting point.
                                The course encompasses all the essentials of
                                data science, such as statistics, programming
                                languages like Python, data visualization, and
                                machine learning. It offers a thorough overview
                                of the field, enabling you to establish a strong
                                foundation and deepen your understanding of the
                                concepts.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> For Intermediate Learners: </p>
                              <p style={{ fontsize: 14 }}>
                                Those with some prior experience in data science
                                can also profit from this Logicmojo course. The
                                curriculum delves into more sophisticated
                                subjects like deep learning and natural language
                                processing. Additionally, hands-on experience
                                with real-world datasets helps you develop
                                practical skills that are applicable to your
                                work.
                              </p>
                            </li>

                            <li style={{ fontsize: 14 }}>
                              <p style={{ fontsize: 14 }}> For Advanced Learners: </p>
                              <p style={{ fontsize: 14 }}>
                                Even experienced data scientists can find
                                advantages in this course. The curriculum
                                explores advanced topics like big data
                                processing, distributed computing, and
                                cloud-based solutions. Furthermore, you'll gain
                                access to state-of-the-art tools and techniques,
                                ensuring you remain current with the latest
                                developments in the field.
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading22">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse22"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            process of getting into the placement pool ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse22"
                        className="collapse"
                        aria-labelledby="heading22"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            In order to qualify for our placement pool, learners
                            must successfully complete the course, including
                            submitting all projects and assignments.
                            Additionally, they must pass the Placement Readiness
                            Test (PRT) to gain access to our job portal and
                            participate in our career mentoring sessions.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading23">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse23"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            different modes of Courses that Logicmojo provides
                            for Data Science ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse23"
                        className="collapse"
                        aria-labelledby="heading23"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            At Logicmojo, you have the option to enroll in
                            either our instructor-led online course or our
                            self-paced program. Additionally, we offer
                            corporate training for organizations seeking to
                            upskill their workforce. Our trainers possess over
                            12 years of relevant industry experience and have
                            worked as consultants in the same field, making them
                            experts in their subject matter. We encourage you to
                            view our sample videos to assess the quality of our
                            trainers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading24">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse24"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I request
                            for a support session if I need to better understand
                            the topics ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse24"
                        className="collapse"
                        aria-labelledby="heading24"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            At Logicmojo, we provide 24/7 query resolution
                            services through our dedicated support team. If you
                            have any questions, you can raise a ticket at any
                            time and receive email support. If your query
                            remains unresolved, we can arrange one-on-one
                            sessions with our support team. It's important to
                            note that this 1:1 session support is available for
                            a period of 6 months from the start date of your
                            course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading25">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse25"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What kind of
                            projects are included as part of the course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse25"
                        className="collapse"
                        aria-labelledby="heading25"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Within the Logicmojo training program framework, we
                            furnish participants with contemporary and pertinent
                            real-world projects, enhancing the value of their
                            educational journey. These endeavors empower you to
                            implement the knowledge and competencies acquired in
                            an authentic industry environment. Our training
                            comprises a multitude of projects, meticulously
                            examining your skills, comprehension, and hands-on
                            experience, ensuring comprehensive preparedness for
                            the professional sphere.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Throughout the course, you'll be afforded the
                            opportunity to tackle exhilarating projects across a
                            myriad of sectors, encompassing high technology,
                            e-commerce, marketing, sales, networking, banking,
                            insurance, and beyond. Upon the triumphant
                            conclusion of these undertakings, your expertise
                            will be tantamount to six months of intense industry
                            experience.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading26">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse26"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> You May
                            Question If Data Science Course Is Worth It?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse26"
                        className="collapse"
                        aria-labelledby="heading26"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Yes, there are plenty of job opportunities available
                            in the field of Data Science and Analytics across
                            various industries globally. As businesses have
                            realized the significance of using historical data
                            for informed decision-making and improving their
                            operations, digitalization has enabled the
                            generation and analysis of vast amounts of data.
                            This has created numerous job openings in the data
                            science and analytics space. The demand for skilled
                            Data Scientists far exceeds the supply, resulting in
                            high salaries and being regarded as one of the
                            best-paying industries. The Data Scientist career
                            path is promising and rewarding as the amount of
                            online data generated is continually increasing in
                            the future.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading27">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse27"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Does Logicmojo
                            offer job assistance after completing data science
                            course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse27"
                        className="collapse"
                        aria-labelledby="heading27"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            At Logicmojo, we offer placement assistance to all
                            learners who have successfully completed our
                            course in data science. We have
                            collaborated with over 80 top MNCs worldwide,
                            ensuring that our learners get the best possible
                            opportunities to work in reputed organizations such
                            as TCS, Sony, Ericsson, Cisco, Cognizant, Mu Sigma,
                            Standard Chartered, and many more. Our team also
                            provides support with job interview preparation and
                            resume building.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading28">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse28"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is doing a Data
                            Science course worth it?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse28"
                        className="collapse"
                        aria-labelledby="heading28"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Certainly! Data Science is a highly rewarding career
                            path due to the high demand for experts in this
                            field, lucrative salaries, and the significant value
                            that it adds to businesses across diverse
                            industries.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading29">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse29"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is coding
                            required to learn Data Science ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse29"
                        className="collapse"
                        aria-labelledby="heading29"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Occasionally. Although advanced coding skills are
                            not mandatory, learners should feel at ease with
                            data analytics, management, and visualization.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Basic knowledge of programming languages like C/C++,
                            Python, R, Java, or SQL can enhance the learning
                            process. Acquiring expertise in any of these
                            programming languages can aid in organizing
                            unstructured datasets.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading30">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse30"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What skills
                            will help during the Data Science Course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse30"
                        className="collapse"
                        aria-labelledby="heading30"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Having the following skills can be advantageous for
                            your learning process.
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Math Skills: Familiarity with concepts such as
                              linear algebra, calculus, matrices, gradients,
                              etc. can be helpful in various fields.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Programming Skills: Proficiency in programming
                              languages like Python, Java, SQL, C, C++, etc. can
                              help you write efficient code and automate tasks.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Data Processing: Knowledge of data mining, data
                              processing, and data modeling techniques can
                              assist you in analyzing and deriving insights from
                              large datasets.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Statistical Analysis: Expertise in analytical
                              tools such as Hadoop, SAS, R, etc. can enable you
                              to perform advanced statistical analyses.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Data Visualization Skills: Competence in using
                              data visualization tools like Matplotlib, Tableau,
                              and others can help you represent complex data in
                              an intuitive and understandable manner.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading32">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse32"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Who should learn
                            Data Science ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse32"
                        className="collapse"
                        aria-labelledby="heading32"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            <b>
                              Professionals Looking to Enhance Their Skillset
                            </b>
                          </p>
                          <ul>
                            <p style={{ fontsize: 14 }}>
                              Current experts in many fields can greatly gain
                              from studying data science. As companies depend
                              more and more on data-based knowledge to make
                              smart choices, professionals who can comprehend,
                              examine, and make sense of data become essential
                              members of their organizations. Here are a few
                              examples:
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Marketing specialists can use data science to
                                fine-tune ad campaigns, study customer habits,
                                and predict demand.
                              </li>
                              <li style={{ fontsize: 14 }}>
                                Finance experts can take advantage of data
                                science to uncover fraud, control risk, and
                                discover investment possibilities.
                              </li>
                              <li style={{ fontsize: 14 }}>
                                Healthcare workers can employ data science to
                                enhance patient attention, find patterns in
                                medical records, and create tailored treatment
                                plans.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Students and Recent Graduates</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Learners and new graduates stepping into the job
                                market can boost their chances of getting hired
                                by acquiring data science abilities. As a
                                growing number of sectors acknowledge the
                                significance of data examination, a foundation
                                in data science can lead to well-paying and
                                thrilling job prospects. Students from fields
                                like math, computer science, engineering, or
                                even social sciences can discover their skills
                                easily adaptable to data science.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Career Changers</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                People looking for a career shift can gain from
                                studying data science too. As this area keeps
                                expanding, there's a continuous need for capable
                                data scientists in different sectors. By
                                obtaining the necessary abilities, those
                                changing careers can move into well-paid,
                                sought-after positions like data analyst, data
                                engineer, or data scientist.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Entrepreneurs and Business Owners</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Startup founders and company owners can use data
                                science to get ahead in their specific markets.
                                By grasping the details of data analysis and
                                using it for well-informed choices, they can
                                improve operations, cut expenses, and spot fresh
                                chances for expansion.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Researchers and Academics</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Scholars and researchers can utilize data
                                science to progress their domains by employing
                                advanced methods to examine and understand
                                intricate data sets. Data science can be used in
                                diverse research fields, such as social
                                sciences, natural sciences, and humanities, to
                                reveal previously concealed patterns and
                                insights.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Government and Non-Profit Organizations</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Government bodies and non-profit organizations
                                can immensely benefit from data science by
                                utilizing data-informed insights for shaping
                                public policies and efforts. By adopting data
                                science methods, these institutions can
                                recognize patterns, shifts, and connections that
                                result in enhanced and streamlined services to
                                the public.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Enthusiasts and Hobbyists</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Passionate individuals and hobbyists eager to
                                learn data science can find numerous personal
                                and professional uses for their new skills. From
                                examining sports statistics to forecasting stock
                                market movements, data science can be an
                                enjoyable and fulfilling activity for those who
                                like dealing with data and uncovering concealed
                                patterns.
                              </li>
                            </ul>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading33">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse33"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What are some
                            steps I can take to learn Data Science and become
                            proficient in it?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse33"
                        className="collapse"
                        aria-labelledby="heading33"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            <b>
                              Develop a Solid Foundation in Mathematics and
                              Statistics
                            </b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              To become proficient in data science, you must
                              have a strong understanding of mathematics and
                              statistics. These subjects form the backbone of
                              data science and provide the tools necessary for
                              data analysis and interpretation. Focus on topics
                              such as probability, linear algebra, calculus, and
                              statistical inference to build a strong
                              foundation.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Master Programming Languages</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Coding languages are crucial for handling data and
                              applying data science methods. Begin with Python
                              and R, the most popular languages in data science.
                              These languages offer strong libraries and
                              packages that assist with data handling,
                              visualization, and examination. As you improve,
                              think about learning additional languages like SQL
                              for managing databases or Scala for processing
                              large-scale data.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Acquire Data Wrangling Skills</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data wrangling, or data preprocessing, is a
                              critical step in the data science process. Raw
                              data is often messy, incomplete, or inconsistent,
                              requiring cleaning and transformation before
                              analysis. Learn to use libraries such as pandas
                              for Python and dplyr for R to manipulate data,
                              handle missing values, and transform data into a
                              suitable format for analysis.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Study Machine Learning Algorithms</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Machine learning is a core component of data
                              science, enabling the development of models that
                              can learn from data and make predictions or
                              decisions. Begin by understanding the basics of
                              machine learning and the different types of
                              algorithms, such as supervised and unsupervised
                              learning. Then, delve into popular algorithms like
                              linear regression, decision trees, and clustering
                              techniques. Familiarize yourself with machine
                              learning libraries like scikit-learn for Python
                              and caret for R.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Enhance Your Data Visualization Skills</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Effective data visualization helps communicate
                              complex data insights to a non-technical audience.
                              Master data visualization libraries like
                              Matplotlib and Seaborn for Python or ggplot2 for
                              R. Learn to create a variety of visualizations,
                              such as bar charts, scatter plots, and heatmaps,
                              to effectively present your findings.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Gain Domain Expertise</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data scientists often specialize in specific
                              domains or industries, such as finance,
                              healthcare, or marketing. Gaining domain expertise
                              allows you to apply data science techniques more
                              effectively and tailor your analyses to the unique
                              challenges of a particular industry. Stay
                              up-to-date on industry trends and develop a deep
                              understanding of the problems faced by businesses
                              in your chosen domain.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Learn Big Data Technologies</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              As the volume of data grows, data scientists need
                              to be proficient in big data technologies to
                              handle, store, and process massive datasets. Learn
                              the fundamentals of big data processing frameworks
                              like Apache Hadoop and Apache Spark. Familiarize
                              yourself with NoSQL databases such as MongoDB and
                              Cassandra for scalable data storage and retrieval.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Participate in Data Science Competitions</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Contests in data science, like those on platforms
                              such as Kaggle, present worthwhile chances to
                              utilize your abilities, gain knowledge from expert
                              data scientists, and assemble a project portfolio.
                              Engaging in these contests can assist you in
                              cultivating proficiency in diverse data science
                              methods and acquaint you with practical issues.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Network with Other Data Science Professionals</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Connecting with fellow data science experts can
                              offer understanding of industry tendencies, career
                              openings, and partnership opportunities. Join
                              local gatherings, conferences, and training
                              sessions to meet people who share your interests
                              and stay up-to-date with the newest advancements
                              in data science.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading34">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse34"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>How do I learn
                            Data Science online ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse34"
                        className="collapse"
                        aria-labelledby="heading34"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Logicmojo provides a range of online Data Science
                            courses that you can explore, along with tutorials,
                            blogs, interview guides, and community forums to
                            support your learning.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            These courses are designed to help working
                            professionals master Data Science while balancing
                            work commitments. The curriculum of these online
                            programs is aligned with industry requirements and
                            standards, ensuring that you gain practical
                            knowledge and skills that are relevant in the job
                            market.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading35">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse35"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Can you suggest
                            some effective learning paths for Data Science ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse35"
                        className="collapse"
                        aria-labelledby="heading35"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <ul>
                            <p style={{ fontsize: 14 }}>
                              <b>
                                Foundational Knowledge: Mathematics, Statistics,
                                and Programming
                              </b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Embarking on a journey to become a proficient
                                data scientist requires a strong foundation in
                                mathematics, statistics, and programming.
                                Develop your skills in linear algebra, calculus,
                                probability, and statistical inference to
                                provide a solid base for your data science
                                career. Simultaneously, master programming
                                languages such as Python and R, which are widely
                                used in the data science field.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Data Manipulation and Cleaning</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                A crucial aspect of data science is data
                                manipulation and cleaning. Raw data is often
                                messy and requires preprocessing before
                                analysis. Familiarize yourself with libraries
                                like pandas in Python and dplyr in R to
                                effectively handle, clean, and transform data
                                for subsequent analysis.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Data Visualization and Communication</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                An essential skill for data scientists is the
                                ability to create data visualizations and
                                effectively communicate their findings to both
                                technical and non-technical audiences. Learn to
                                use visualization libraries such as Matplotlib
                                and Seaborn in Python or ggplot2 in R to create
                                engaging and informative visual representations
                                of your data analysis.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Machine Learning Techniques</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Develop your expertise in machine learning, a
                                core component of data science that enables you
                                to build models capable of learning from data
                                and making predictions. Start by understanding
                                the basics of machine learning, such as
                                supervised and unsupervised learning. Then,
                                delve into popular algorithms like linear
                                regression, decision trees, and clustering
                                techniques.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>
                                Develop your expertise in machine learning, a
                                core component of data science that enables you
                                to build models capable of learning from data
                                and making predictions. Start by understanding
                                the basics of machine learning, such as
                                supervised and unsupervised learning. Then,
                                delve into popular algorithms like linear
                                regression, decision trees, and clustering
                                techniques.
                              </b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                As a data connoisseur, delving into deep
                                learning is pivotal, entailing the construction
                                of neural architectures to emulate intricate
                                patterns within data. Familiarize yourself with
                                prominent deep learning frameworks such as
                                TensorFlow and PyTorch, mastering the art of
                                devising and honing neural networks for
                                undertakings like image discernment and natural
                                language interpretation.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Big Data Processing and Analysis</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                As a data connoisseur, delving into deep
                                learning is pivotal, entailing the construction
                                of neural architectures to emulate intricate
                                patterns within data. Familiarize yourself with
                                prominent deep learning frameworks such as
                                TensorFlow and PyTorch, mastering the art of
                                devising and honing neural networks for
                                undertakings like image discernment and natural
                                language interpretation.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Domain-Specific Expertise</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Focusing on a particular sector or field, like
                                finance, healthcare, or marketing, can bolster
                                your data science vocation by allowing you to
                                employ your abilities more efficiently. Acquire
                                domain proficiency by keeping abreast of sector
                                developments and comprehending the distinct
                                hurdles confronted by enterprises in your
                                selected realm.
                              </li>
                            </ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Practical Experience and Portfolio Building</b>
                            </p>
                            <ul>
                              <li style={{ fontsize: 14 }}>
                                Hands-on experience is vital for developing your
                                data science skills and showcasing your
                                abilities to potential employers. Participate in
                                data science competitions on platforms like
                                Kaggle or work on personal projects that involve
                                real-world data. As you complete projects,
                                compile a portfolio to demonstrate your
                                expertise and the impact of your work.
                              </li>
                            </ul>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading36">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse36"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>How can I become
                            a Data Scientist?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse36"
                        className="collapse"
                        aria-labelledby="heading36"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            To embark on the path of becoming a Data Scientist,
                            the first step is to gain knowledge about Data
                            Science and its prerequisites. Once you have a basic
                            understanding, the next step is to enroll in a
                            reputable Data Science program offered by a reliable
                            institution. However, the journey doesn't end there.
                            To excel in the field, it's essential to practice
                            regularly and stay updated with the latest
                            advancements in this technology.
                          </p>
                          <ul>
                            <p style={{ fontsize: 14 }}>
                              <b>Learn Essential Machine Learning Techniques</b>
                            </p>
                            <li style={{ fontsize: 14 }}>
                              Machine learning is a core component of data
                              science. Begin by understanding the basics of
                              supervised and unsupervised learning, and then
                              dive deeper into popular algorithms such as linear
                              regression, decision trees, and clustering
                              techniques. Practice implementing these algorithms
                              and fine-tune your models for improved
                              performance.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Explore Deep Learning and Neural Networks</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Amplify your cognizance by delving into the realm
                              of deep learning and neural network architectures.
                              These methodologies empower the development of
                              models proficient in discerning intricate
                              relationships within voluminous data compilations.
                              Acquaint yourself with deep learning schemas such
                              as TensorFlow and PyTorch, and refine your skills
                              in the art of constructing and honing neural
                              networks tailored for a multitude of undertakings,
                              encompassing visual perception and linguistic
                              processing tasks.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Get Familiar with Big Data Technologies</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              As a data scientist, you must be proficient in big
                              data technologies to process, store, and analyze
                              massive datasets. Learn about big data processing
                              frameworks like Apache Hadoop and Apache Spark, as
                              well as NoSQL databases such as MongoDB and
                              Cassandra. Mastering these technologies will
                              prepare you to work with large-scale data in
                              real-world scenarios.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>Gain Domain Expertise in Your Chosen Industry</b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Cultivating proficiency in a distinct sector, be
                              it finance, healthcare, or marketing, paves the
                              way for more efficacious application of your data
                              science aptitude. Garner subject matter mastery by
                              keeping abreast of sector-specific tendencies and
                              comprehending the singular hurdles confronted by
                              enterprises within your selected domain.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}>
                            <b>
                              Participate in Data Science Competitions and
                              Projects
                            </b>
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Hands-on experience is essential for honing your
                              data science skills. Participate in data science
                              competitions on platforms like Kaggle or work on
                              personal projects involving real-world data. As
                              you complete projects, document your findings and
                              create a portfolio to showcase your expertise to
                              potential employers.
                            </li>
                          </ul>
                          <p style={{ fontsize: 14 }}> Engage with the Data Science Community</p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Forge connections with fellow data science
                              aficionados by participating in regional
                              gatherings, symposiums, and hands-on sessions.
                              Immersing yourself in the data science milieu
                              offers indispensable perspectives on sector
                              inclinations, vocational prospects, and
                              cooperative potentialities. Remain up-to-date with
                              the field's cutting-edge advancements and draw
                              wisdom from the collective experiences of your
                              peers.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading37">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse37"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What are some
                            recommended data science course by Logicmojo?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse37"
                        className="collapse"
                        aria-labelledby="heading37"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Logicmojo has partnered with highly regarded
                            institutions to offer a range of Data Science
                            programs that cater to aspiring Data Scientists, as
                            well as professionals seeking to enhance their
                            skills in the field. Here are some recommended
                            courses that might be suitable for you:
                          </p>
                          <p style={{ fontsize: 14 }}>
                            If you are unsure about which course to choose,
                            don't hesitate to contact our course advisors for
                            assistance.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading38">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse38"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Do I Need To
                            Have Strong Programming Skills To Be A Data
                            Scientist?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse38"
                        className="collapse"
                        aria-labelledby="heading38"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            To answer the question of whether programming skills
                            are required for a data science course, the answer
                            is both yes and no. Yes, because some level of
                            programming skills is necessary. However, it is not
                            required to have extremely strong programming
                            skills. At Logicmojo, we ensure that our students
                            get ample exposure to the statistical programming
                            tool called ‘Logicmojo’. We start from the basics
                            assuming that you have no prior exposure to
                            programming.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading39">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse39"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Why Should We
                            Learn Python ? Can’t We Learn Any Other Tool For
                            Data Science Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse39"
                        className="collapse"
                        aria-labelledby="heading39"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Python is a highly attractive option in the
                            analytics space, as it has around 95% market share
                            and is open source, meaning it is free to use. Many
                            job postings require experience and exposure to
                            Python, making it a valuable skill to have. On the
                            other hand, demand for other statistical tools is
                            decreasing. Therefore, it is wise to look towards
                            the future and invest time in learning Python.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading40">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse40"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Miss A
                            Live Session Classes for Data Science?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse40"
                        className="collapse"
                        aria-labelledby="heading40"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            If you happen to miss a live session for any reason
                            during your Data Science Course, it won't be an
                            issue. All sessions are recorded, and you will have
                            access to them through Logicmojo’s advanced Learning
                            Management System (LMS). This allows you to watch
                            the recorded sessions at your own pace and
                            convenience, ensuring that you don't miss any
                            important material.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading41">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse41"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Will I Get A
                            Data Science Course Completion Certification From
                            Logicmojo?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse41"
                        className="collapse"
                        aria-labelledby="heading41"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Yes ! Upon the successful completion of the course,
                            you will receive a course completion certificate
                            from Logicmojo.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading42">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse42"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Forget
                            The Data Science Concepts After Completing the
                            Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse42"
                        className="collapse"
                        aria-labelledby="heading42"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            We recognize that the human brain has limitations
                            when it comes to learning capacity. For this reason,
                            we record all our sessions and grant trainees
                            lifelong access to the e-learning materials.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading43">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse43"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Have
                            No Experience In Data Science?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse43"
                        className="collapse"
                        aria-labelledby="heading43"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The field of Data Science has only gained global
                            attention in the past two years. As a result, many
                            companies are finding it challenging to fill the gap
                            between supply and demand for skilled professionals
                            in this area. Individuals who possess training and
                            adequate exposure to data science techniques are
                            often quickly recruited by companies
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading44">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse44"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What Is The
                            Difference Between Business Analytics, Data
                            Analytics And Data Scientist?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse44"
                        className="collapse"
                        aria-labelledby="heading44"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Data Analytics, Business Analytics, and Data Science
                            are essentially three terms that refer to the same
                            field. The professionals working in this domain are
                            commonly known as Data Scientists.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading45">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse45"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            placement rate for this data science course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse45"
                        className="collapse"
                        aria-labelledby="heading45"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Logicmojo data science course can help in placement
                            in several ways. First and foremost, it provides you
                            with the necessary skills and knowledge required to
                            perform data analysis, data modeling, and data
                            visualization, which are in high demand across
                            various industries.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            In addition, Logicmojo data science course often
                            offer practical training that helps you gain
                            hands-on experience and build a portfolio of
                            real-world projects, which can make you more
                            attractive to potential employers and refer in
                            product companies
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Moreover, Logicmojo have industry partnerships,
                            which can give you access to job fairs, internships,
                            or even direct job placement.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading46">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse46"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            companies recruit from this data science course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse46"
                        className="collapse"
                        aria-labelledby="heading46"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Large technology companies, such as Google,
                            Microsoft, Amazon, and Facebook, often recruit data
                            science graduates & working professional.
                            Additionally, financial institutions, such as banks
                            and insurance companies, frequently hire data
                            scientists to help them analyze customer data and
                            make better business decisions.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Many other industries, such as healthcare, retail,
                            and transportation, are also recognizing the
                            importance of data science and are hiring
                            professionals with these skills. Startups and
                            smaller companies also looking for data science
                            talent to help them build and scale their
                            businesses.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading47">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse47"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            average salary package offered to candidates after
                            completing this data science course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse47"
                        className="collapse"
                        aria-labelledby="heading47"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The typical annual salary for a data scientist is
                            around Rs. 1698,412. However, those who are new to
                            the field and have less than a year of experience
                            can expect to earn about Rs. 1500,000 per year. On
                            the other hand, data scientists who have been in the
                            field for 1 to 4 years may earn approximately Rs.
                            2210,811 per year.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading48">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse48"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            prerequisites required for placement after
                            completing this data science course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse48"
                        className="collapse"
                        aria-labelledby="heading48"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Prerequisites for Placement After Completing a Data
                            Science Course
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Strong foundation in mathematics and statistics: A
                              solid understanding of mathematical concepts,
                              including linear algebra, calculus, and
                              probability, is crucial for working with data.
                              Additionally, proficiency in statistical methods,
                              such as hypothesis testing and regression
                              analysis, is essential for interpreting data and
                              drawing conclusions.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Programming skills: Data scientists need to be
                              proficient in at least one programming language,
                              typically Python or R, to manipulate data, create
                              visualizations, and develop machine learning
                              models.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Domain expertise: Depending on the industry you're
                              targeting, having knowledge of the specific domain
                              can give you a competitive edge. For example, a
                              background in finance will be advantageous for
                              data scientists working in the financial sector.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Communication and presentation skills: Data
                              scientists must effectively communicate their
                              findings to non-technical stakeholders. Hence,
                              strong presentation skills and the ability to
                              simplify complex concepts are vital.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Portfolio of projects: Showcasing your work
                              through a portfolio of projects is an excellent
                              way to demonstrate your skills and expertise to
                              potential employers. It also serves as evidence of
                              your hands-on experience in tackling real-world
                              data challenges.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading49">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse49"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there any
                            assistance provided by Logicmojo for resume building
                            and interview preparation for placement?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse49"
                        className="collapse"
                        aria-labelledby="heading49"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Yes , After the completion of the data science
                            course of 8 months. Candidate is ready for
                            interviews so first we conduct resume preparation
                            session 1 to 1 followed by mock interviews.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading50">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse50"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How long does
                            it take for students to get placed after completing
                            this data science course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse50"
                        className="collapse"
                        aria-labelledby="heading50"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Several factors influence the time it takes for
                            students to get placed after completing a data
                            science course. These include:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Skill Set and Expertise: The skills and expertise
                              students acquire during the course determine their
                              employability. A strong foundation in mathematics,
                              statistics, programming, machine learning, and
                              domain knowledge is essential for a successful
                              career in data science.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Portfolio of Projects: Employers look for
                              candidates who can demonstrate their skills
                              through real-world projects. Building a portfolio
                              of projects during the course can showcase your
                              expertise and increase your chances of getting
                              hired.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Internships and Work Experience: Internships and
                              prior work experience in data science or related
                              fields can give students a competitive edge in the
                              job market. These experiences help students apply
                              their skills in practical scenarios and make them
                              more attractive to potential employers.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading51">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse51"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            networking opportunities provided by the course
                            provider to connect with potential employers?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse51"
                        className="collapse"
                        aria-labelledby="heading51"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Yes, the Logicmojo offer networking opportunities to
                            connect students with potential employers. You can
                            connect alumni networks. The aim is to provide
                            students with avenues to network and build
                            connections that could help them in their job
                            search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading52">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse52"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            role of the Logicmojo in ensuring the placement of
                            its students?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse52"
                        className="collapse"
                        aria-labelledby="heading52"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Logicmojo ensure the placement of its students is to
                            offer a comprehensive education and training program
                            that equips students with the necessary skills and
                            knowledge required for the industry. Additionally,
                            the course provider may provide job placement
                            assistance, such as resume building sessions, mock
                            interviews, and networking opportunities
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading53">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse53"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can students
                            pursue internships or part-time jobs during the
                            course to enhance their chances of placement?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse53"
                        className="collapse"
                        aria-labelledby="heading53"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Yes, Internships are useful for placements for
                            students in Data Science Field.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Logicmojo data science course helps students
                            internships/pre placements
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>
                              Data Science Internships improve your employment
                              prospects in Data Science Field, pay you a real
                              wage, improve your network connections, and show
                              you how a professional workplace operates.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Logicmojo provides you with industry experience
                              and exposure for making a carrier in Data Science.
                              Theoretical knowledge is not alone sufficient.
                              Hands on experience adds on to your resume.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading54">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse54"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            additional certification programs offered along with
                            the data science course that can help with placement
                            opportunities?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse54"
                        className="collapse"
                        aria-labelledby="heading54"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Yes, Along with Data Science course completion
                            certification, Logicmojo also provide project
                            certification after completion of projects in the
                            field of Data Science related areas such as machine
                            learning, data visualization, or big data
                            technologies. These additional certifications can be
                            valuable in demonstrating specialized skills to
                            potential employers and increasing placement
                            opportunities
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading55">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse55"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What is the
                            duration of the placement support provided by
                            Logicmojo after completing the data science course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse55"
                        className="collapse"
                        aria-labelledby="heading55"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Logicmojo course duration is 7-8 months, followed by
                            a placement process for the next 6 months until all
                            students are successfully placed in suitable
                            positions. This provides ample time for students to
                            learn and develop their skills, while also ensuring
                            that they have access to placement opportunities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading56">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse56"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Are there any
                            alumni of this data science course who have
                            successfully been placed in reputed companies?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse56"
                        className="collapse"
                        aria-labelledby="heading56"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Logicmojo provide you with this information or
                            connect you with alumni who can share their
                            experiences and insights about data science
                            preparation. Additionally, you can also research
                            online or through social media platforms to find out
                            about the career trajectories of alumni from the
                            course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading57">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse57"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What kind of
                            roles and designations can students expect after
                            completing this data science course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse57"
                        className="collapse"
                        aria-labelledby="heading57"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The roles and designations that students can expect
                            after completing Logicmojo data science course may
                            vary depending on the specific program, the skills
                            and knowledge gained during the program, and the job
                            market demand. Generally, Our data science course
                            equip students with skills in areas such as
                          </p>
                          <ul>
                            <li style={{ fontsize: 14 }}>Data Scientist</li>
                            <li style={{ fontsize: 14 }}>Data Analysis</li>
                            <li style={{ fontsize: 14 }}>Machine Learning Engineer</li>
                            <li style={{ fontsize: 14 }}>Data Engineer</li>
                            <li style={{ fontsize: 14 }}>Software Developer</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading58">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse58"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What is the
                            success rate of students getting placed in their
                            preferred companies and domains after completing
                            Logicmojo data science course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse58"
                        className="collapse"
                        aria-labelledby="heading58"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The Logicmojo Data Science Course boasts an
                            impressive success rate, with a large percentage of
                            graduates securing positions in their preferred
                            companies and domains. Key factors contributing to
                            this success include:
                          </p>
                          <ol>
                            <li style={{ fontsize: 14 }}>
                              Industry-Relevant Curriculum: The course content
                              is designed to align with current industry
                              demands, ensuring students acquire the skills and
                              knowledge required by top employers.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Strong Network of Partner Companies: Logicmojo has
                              established partnerships with numerous reputed
                              companies, increasing the likelihood of successful
                              placements for their graduates.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Dedicated Career Services: The career support
                              offered by Logicmojo helps students navigate the
                              job market, preparing them for interviews and
                              connecting them with potential employers.
                            </li>
                            <li style={{ fontsize: 14 }}>
                              Alumni Network: Graduates of the Logicmojo Data
                              Science Course become part of an extensive alumni
                              network, fostering valuable connections and
                              facilitating professional growth.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading59">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse59"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Are there any
                            placement-related policies or agreements that
                            students should be aware of before enrolling in the
                            data science course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse59"
                        className="collapse"
                        aria-labelledby="heading59"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            No, We dont have any scheme such as Pay After
                            Placement for Data Science Course. After enrollment
                            of one time payment, there Data science curriculum
                            will start. After course completion placement
                            process will start.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading60">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse60"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Until when will
                            the Logicmojo students get the facility of
                            mentorship ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse60"
                        className="collapse"
                        aria-labelledby="heading60"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Depending on their specialization, our mentors will
                            provide data science coaching to the students until
                            they complete the course. After finishing the
                            course, students can connect with specialized
                            mentors for support with projects and job placement.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading61">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse61"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can a student
                            choose to study from their desired mentor ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse61"
                        className="collapse"
                        aria-labelledby="heading61"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            At Logicmojo, each batch of students is assigned a
                            dedicated mentor. However, if a student is not
                            satisfied with their mentor's teaching approach,
                            they can escalate the issue to the management. The
                            institution will work to address the concern and
                            provide alternative mentorship options for the
                            student.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading62">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse62"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            experience level of the mentors teaching the data
                            science course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse62"
                        className="collapse"
                        aria-labelledby="heading62"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The educator guiding the data science program boasts
                            copious expertise in the discipline, accumulating
                            over five years as a data savant for a variety of
                            leading product-centric corporations. Through this
                            odyssey, the instructor has garnered hands-on acumen
                            and dexterity in realms such as data examination,
                            computational learning, and statistical approaches.
                            Beyond their trade experience, the tutor holds
                            pertinent pedagogical exposure in the data science
                            ambit, equipping them to adeptly impart intricate
                            notions and offer insightful mentorship to learners.
                            In essence, the instructor's rich background and
                            proficiency render them an ideal choice to helm the
                            data science curriculum and facilitate students'
                            edification.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading63">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse63"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How many
                            mentors will be assigned to each student during the
                            course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse63"
                        className="collapse"
                        aria-labelledby="heading63"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            We can assign one dedicated instructor for data
                            Science to the batch, and if needed, we can schedule
                            multiple trainers based on the requirements. This
                            ensures that students receive appropriate attention
                            and support. Our priority is to provide high-quality
                            Data science course with effective teaching
                            methods. We are flexible and will adapt to the needs
                            of the students and the program. Please let us know
                            over slack if you have any specific requirements or
                            preferences.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading64">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse64"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support can students expect from their mentors
                            during the course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse64"
                        className="collapse"
                        aria-labelledby="heading64"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            In addition to regular live classes in the course,
                            our tutors provide support to students with all
                            their data science queries over a Slack channel
                            anytime. We understand that doubts can arise anytime
                            and we want to ensure that our students receive
                            timely support. We also schedule separate live doubt
                            sessions during weekdays after office hours to cater
                            to the needs of working professionals. Our goal is
                            to help our students succeed in their data science
                            journey.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading65">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse65"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are the mentors
                            available for one-on-one sessions outside of the
                            regular class schedule ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse65"
                        className="collapse"
                        aria-labelledby="heading65"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Yes, our mentors are available for one-on-one
                            sessions outside of the regular data science class
                            schedule. We understand that some students may have
                            specific questions or may require additional
                            support, and we want to ensure that they receive the
                            attention they need. Students can schedule
                            one-on-one sessions with their mentor at a
                            convenient time for both parties. Our mentors are
                            committed to helping students succeed and will work
                            with them to address any concerns or questions they
                            may have.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading66">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse66"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Will students
                            have access to the mentors even after completing the
                            course for data science queries ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse66"
                        className="collapse"
                        aria-labelledby="heading66"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Our data science course runs for a duration of 8
                            months, and even after its completion, our mentors
                            remain available to the students for any assistance
                            they may require. Our mentors can be reached through
                            the communication platform Slack, where students can
                            message them directly. In case of urgent queries or
                            concerns, our mentors are always just a ping away on
                            Slack. Additionally, if students prefer to
                            communicate over a call, they can schedule a call
                            with their respective trainers. We understand the
                            importance of ongoing support, and our mentors are
                            always ready to provide it to our student
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading67">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse67"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            class size of the data science course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse67"
                        className="collapse"
                        aria-labelledby="heading67"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Our data science course has varying class sizes from
                            batch to batch, depending on the number of enrolled
                            students. However, our primary target audience for
                            this course is working professionals. We recognize
                            the busy schedules of our students and offer
                            flexible learning options to accommodate their
                            needs. Our goal is to provide high-quality training
                            that is relevant to the industry and helps our
                            students advance in their careers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading68">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse68"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How often are
                            the classes held for the data science course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse68"
                        className="collapse"
                        aria-labelledby="heading68"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            We offer both weekend and weekday courses depending
                            on the availability of our students. Our weekend
                            courses are of a duration of 180 minutes, while our
                            weekday courses run for 120 minutes
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading69">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse69"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are the Data
                            Science classes conducted online or in-person
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse69"
                        className="collapse"
                        aria-labelledby="heading69"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Web-based curriculums present a multitude of
                            benefits compared to conventional in-person classes.
                            They offer adaptability and can be accessed from any
                            location, whenever desired. Frequently, these
                            courses adopt a self-directed learning approach,
                            empowering you to absorb material at a comfortable
                            pace. Moreover, online classes typically incur lower
                            expenses than traditional in-person courses, making
                            them available to a wider array of individuals.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Enrolling in a comprehensive online Data Science
                            program that encompasses vital concepts within its
                            study trajectory is a stellar method to acquire
                            proficiency in the domain. This approach affords a
                            pliable and budget-friendly avenue for learning and
                            imparts a profound grasp of the core notions and
                            abilities requisite for success as a Data Scientist.
                            Additionally, you can obtain recordings of all live
                            sessions for future reference and practice.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading70">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse70"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can students
                            interact with their peers and collaborate on
                            projects during the data science course
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse70"
                        className="collapse"
                        aria-labelledby="heading70"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Embracing the notion that education flourishes
                            through collaboration, we inspire our pupils to
                            engage with one another and jointly tackle
                            assignments within the data science curriculum.
                            Numerous avenues for connection, both within and
                            beyond the scholastic environment, are available to
                            students.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            During instructional periods, we orchestrate group
                            dialogues and exercises, stimulating learners to
                            exchange thoughts and cooperatively address
                            challenges. We contend that this immersive
                            educational experience fosters a more profound grasp
                            of the subject matter while cultivating critical
                            thinking and problem-solving aptitudes.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Beyond the classroom, we supply our students with
                            access to a Slack community for peer-to-peer
                            education and collective study sessions. This
                            virtual forum enables learners to liaise with
                            classmates, exchange insights and resources, and
                            work together on data science endeavors. Our
                            experience indicates that such cooperative learning
                            methods significantly aid students in enhancing
                            their abilities and attaining a more comprehensive
                            understanding of the course content.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading71">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse71"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            feedback system is in place for students to provide
                            feedback on the mentors and the course curriculum ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse71"
                        className="collapse"
                        aria-labelledby="heading71"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            Within our esteemed establishment, we highly regard
                            the perspectives and encounters of our scholars,
                            believing that their input is crucial for delivering
                            an unparalleled educational journey. Consequently,
                            we've instituted an all-encompassing appraisal
                            mechanism, empowering students to express their
                            viewpoints on the course syllabus and their
                            preceptors.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            This system is fashioned to be effortless and
                            approachable, with evaluations occurring after every
                            quartet of lessons within our data science cohort.
                            Throughout these sessions, learners are emboldened
                            to offer insights on myriad facets of the program,
                            encompassing the curriculum, pedagogical techniques,
                            and the efficacy of their mentors.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            To further streamline the feedback procedure, we've
                            devised a Google form for students to complete at
                            their leisure. This user-friendly questionnaire
                            poses inquiries that permit learners to divulge
                            extensive observations about their encounters.
                            Subsequently, our faculty scrutinizes the feedback,
                            refining the syllabus and instructional
                            methodologies for forthcoming groups.
                          </p>
                          <p style={{ fontsize: 14 }}>
                            Ultimately, our unwavering dedication to furnishing
                            our scholars with an exceptional educational
                            experience is evident, and our appraisal system
                            exemplifies one of the numerous ways we're striving
                            toward that objective. By heeding our students and
                            enacting modifications rooted in their suggestions,
                            we're able to cultivate a learning atmosphere that
                            is enthralling, efficacious, and fulfilling.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="heading007">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse007"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support we will get in Data Science Course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse007"
                        className="collapse"
                        aria-labelledby="heading007"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            In our Data Science Course, you can receive various
                            forms of support such as access to course materials,
                            live online classes, discussion forums, peer-to-peer
                            learning, and personalized feedback from trainers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading017">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse017"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How can I
                            access the course materials of Data Science?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse017"
                        className="collapse"
                        aria-labelledby="heading017"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            The course provider will share all course materials,
                            class recordings, and assignments in the Slack
                            channel. These materials will be available for
                            download to all members. This ensures easy access to
                            the course content and flexibility in learning.
                            Students can refer to the materials at their
                            convenience and pace. The Slack channel serves as a
                            centralized platform for course-related
                            communication and resource sharing.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading027">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse027"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Flexi
                            Subscription in Data Science Foundation Program?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse027"
                        className="collapse"
                        aria-labelledby="heading027"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            In case of emergencies such as medical issues, work
                            pressure, or on-site opportunities, users can switch
                            to another batch of Data Science. This will stop
                            their current batch and allow them to join another
                            batch at a later time. The course provider
                            understands the need for flexibility and
                            accommodates such situations. Students can resume
                            their learning journey when they are ready without
                            any penalty. The option to switch batches allows for
                            seamless continuation of the course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading037">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse037"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there a
                            discussion forum for the course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse037"
                        className="collapse"
                        aria-labelledby="heading037"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p style={{ fontsize: 14 }}>
                            We used Slack channel for communication, users can
                            interact over the Slack community to connect with
                            all their peers for any queries.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="btn-center-section" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

      <section ref={contactSection} className="supportbgnew" id="contact">
        <div className="container ">
          <h2>How to connect with Logicmojo team?</h2>
          <div className="supportbgnew-inner">
            <div className="supportbgnew-inner-img">
              <img src="assets/images/supportimg.png" alt="" />
            </div>
            <div className="supportbgnew-inner-content">
              <p>Got more questions?</p>
              <h3>Talk to our team directly</h3>
              <p style={{ fontsize: 14 }}>
                Reach us and a learning consultant will get in touch with you
                shortly
              </p>
              <a href="">
                <i className="fa fa-whatsapp"></i> Enquire now
              </a>
              <a href="" style={{ background: "#1a64c0" }}>
                <i className="fa fa-whatsapp"></i> +91 80889-75867
              </a>
            </div>
          </div>
          <center className="clearfix float-left w-100">
            <div className="social-icons">

              <i className="fa fa-youtube-play"></i><a href="https://www.youtube.com/@logicmojo/videos" target="_blank">
                Youtube
              </a>

              <i className="fa fa-facebook-f"></i><a href="https://www.facebook.com/logicmojo/" target="_blank" >
                Facebook
              </a>


              <i className="fa fa-twitter"></i><a href="https://twitter.com/logic_mojo" target="_blank" title="Follow us on Twitter">
                Twitter
              </a>


              <i className="fa fa-linkedin-square"></i><a href="https://www.linkedin.com/company/82779427" target="_blank" title="Connect with us on LinkedIn">
                LinkedIn
              </a>


              <i className="fa fa-instagram"></i><a href="https://www.instagram.com/logicmojo/" target="_blank" title="Follow us on Instagram">
                Instagram
              </a>
            </div>
          </center>
        </div>
      </section>

      <div className="footerai">
        <div className="container ">
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <p style={{ fontsize: 14 }}>
                <img src="assets/images/logo.png" alt="" />
              </p>
              <p style={{ fontsize: 14 }}>
                Enrol Now For Data Science Course, System Designing Or Full
                Stack Development Courses. Master The Most Demanding Skills Of
                Job Market And Experience And Ever Growing And Lucrative Career
                Transformation.
              </p>
              <p style={{ fontsize: 14 }}>
                <a href="mailto:info@logicmojo.com">
                  <i className="fa fa-envelope-o"></i> info@logicmojo.com
                </a>
              </p>
              <p style={{ fontsize: 14 }}>
                <a href="tel:+91 80889-75867">
                  <i className="fa fa-phone"></i> +91 80889-75867
                </a>
              </p>
            </div>
            {
              <div className="col-md-6 col-lg-4">
                <h3>Courses</h3>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Introduction-to-Data-Analytics">
                    Advance Data Science & AI Program
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Advance-Data-Science-ML-Program">
                    Advance AI & ML Program
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Master-data-Science-ai-program">
                    Master Degree Program For Data Science & AI
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/AI-Fundamental-for-Non-Data-Scientist">
                    AI Fundamental for Non Data Scientist
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Data-Science-Course-For-Managers">
                    Data Science Course For Managers
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Post-Graduate-Program-For-Data-Science">
                    Post Graduate Program For Data Science
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Basics-Introduction-to-Data-Science">
                    Basic Introduction to Data Science
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Introduction-to-Data-Analytics">
                    Introduction to Data Analytics
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Applied-Data-Science-with-Python">
                    Applied Data Science with Python
                  </Link>
                </p>
              </div>
            }
            <div className="col-md-6 col-lg-2">
              <h3>Logicmojo</h3>
              <p style={{ fontsize: 14 }}>
                <a href="https://logicmojo.com/about_us">About Us</a>
              </p>

              <p style={{ fontsize: 14 }}>
                <a href="https://logicmojo.com/blog">Blogs</a>
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Terms</h3>
              <p style={{ fontsize: 14 }}>
                <a href="https://logicmojo.com/terms_condition">
                  Terms and Conditions
                </a>
              </p>
              <p style={{ fontsize: 14 }}>
                <a href="https://logicmojo.com/refund_policy">
                  Refund/Cancellation policy
                </a>
              </p>
              <p style={{ fontsize: 14 }}>
                <a href="https://logicmojo.com/privacy_policy">
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-md-12 col-lg-12">
              <h3>Project Innovation Lab Address</h3>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }}>Pune</h4>
              <p style={{ fontsize: 14 }}>
                Sky Loft Group Floor, Creaticity Mall, Opposite Golf Course,
                Airport Rd, Shastrinagar, Yerawada, Pune, Maharashtra 411006
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }}>Mumbai</h4>
              <p style={{ fontsize: 14 }}>
                Business Centre, 3rd Floor, vinkat House, Dinshaw Vacha Road,
                Churchgate, Mumbai, Maharashtra 400020
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }}>Delhi</h4>
              <p style={{ fontsize: 14 }}>
                Business Centre Park, Arunachal Building, 8th Floor, Barakhamba
                Road, New Delhi 110001
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }}>Kolkata</h4>
              <p style={{ fontsize: 14 }}>
                Ambuja Neotia EcoCentre 5th Floor, EM-4,EM-Block, Sector 6
                Kolkata 700091
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }} className="mt-3">Hyderabad</h4>
              <p style={{ fontsize: 14 }}>
                NSL Centrum, Road No 1, Lane, Opp. Forum Mall Central Hub, KPHB
                4th Phase, Hyderabad, Telangana 500072
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4  style={{ fontsize: 14,color:"white" }} className="mt-3">Bangalore</h4>
              <p style={{ fontsize: 14 }}>
                #23, Above Veena Mobiles, 14th Main Road, Opp-White House,
                Sector 2, Hsr Layout, Bangalore 560102
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }} className="mt-3">Chennai</h4>
              <p style={{ fontsize: 14 }}>
                Cessanana Business Centre, Phone Booth, 3rd Floor, 39/12 Haddows
                Road, Nungambakkam, Chennai 600 006
              </p>
            </div>
          </div>

          <hr />

          <div className="row">
            {/* <div className='col-md-6 col-lg-3'>
                <h3>Bangalore</h3>
                <p style={{ fontsize: 14 }}><a href="#">Data Science Course Training In Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Machine Learning Course Training In Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Data Analytics Course Training In Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Business Analytics Course Training In Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Artificial Intelligence AI Course Training Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Full-Stack Software Developer Course In Bangalore</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Hyderabad</h3>
                <p style={{ fontsize: 14 }}><Link to="/Data-Science-Course-Hydrabad">Data Science Course Training In Hyderabad</Link></p>
                <p style={{ fontsize: 14 }}><a href="#">Machine Learning Course Training In Hyderabad</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Data Analytics Course Training In Hyderabad</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Business Analytics Course Training In Hyderabad</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Artificial Intelligence AI Course Training Hyderabad</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Full-Stack Software Developer Course In Hyderabad</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Dubai</h3>
                <p style={{ fontsize: 14 }}><a href="#">Data Science Course Training In Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Machine Learning Course Training In Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Data Analytics Course Training In Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Business Analytics Course Training In Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Artificial Intelligence AI Course Training Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Full-Stack Software Developer Course In Dubai</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Delhi</h3>
                <p style={{ fontsize: 14 }}><a href="#">Data Science Course Training In Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Machine Learning Course Training In Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Data Analytics Course Training In Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Business Analytics Course Training In Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Artificial Intelligence AI Course Training Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Full-Stack Software Developer Course In Delhi</a></p>
            </div> */}
          </div>

          <hr />

          <div className="row">
            <div className="col-lg-12">
              <p className="m-0">© 2024 LOGICMOJO. ALL RIGHTS RESERVED</p>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="counsellingpopup">
        <div className="modal-dialog modal-lg modal_width">
          <div className="modal-content">
            <div className="modal-body">
              <div className="counsellingpopupbg">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <div className="counsellingpopupbg-img">
                  <img
                    loading="lazy"
                    src="assets/images/counselling_new.jpeg"
                    alt="counselling_new"
                  />
                </div>
                <div className="counsellingpopupbg-form counseling_thanks">
                  <h3>
                    Schedule Call Back From Experts For Live Classes Queries
                  </h3>

                  <iframe
                    src="https://logicmojo.com/counsellingpopup"
                    className="counsellingpopupbgIframe"
                    title="popup form"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*
      <div className="modal" id="welcomepopup">
        <div className="modal-header">
        <p style={{ fontsize: 14 }}><span className="yallowbox">Early Bird Discount &#127881;  </span></p>
          <button type="button" className="close" data-dismiss="modal">
            &times;
          </button>
        </div>

        <div className="modal-body">
         
          <p style={{ fontsize: 14 }}>
            Data Science, Machine Learning &amp; AI Course
            <br />
            <b>
              <a href="#" style={{ color: "#007bff" }}>
                (Duration: 7 months)
              </a>
            </b>
          </p>


          <p style={{ textAlign: "center" }}>
            <span className="yallowbox">15% OFF On All Courses</span>
          </p>

          <b>
            <p style={{ textAlign: "left" }}>
              <span>Batch starts from <u>26th April</u></span>
            </p>
          </b>
          <p style={{ fontsize: 14 }}>Weekend Batch : 9 AM - 12 PM (IST)</p>
        </div>

        <div className="modal-footer">
          <a
            target="_default"
            href="https://calendly.com/logicmojo/career-counselling-live-classes?month=2023-11"
            className="btn btn-primary"
          //data-toggle="modal"
          //data-target="#counsellingpopup"
          >
            <b>Apply Now</b>
          </a>
        </div>
      </div>
          */}


      <div className="footerstrip-formob">
        <a href="https://api.whatsapp.com/send?phone=+918088975867&amp;text=Hi%20Logicmojo">
          Chat with us{" "}
          <img
            src="assets/images/whatsapp logo.png"
            width="30"
          />
        </a>{" "}
        |{" "}
        <a
          target="_default"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
        >
          Call Back{" "}
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_iRdNR098BeHs9symwbCwLZ3YJCYDfVeqjQ&amp;usqp=CAU"
            width="30"
          />
        </a>
      </div>
      <div className="footerstrip">
        <a
          target="_default"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
        >
          <span>
            <i className="fa fa-hand-o-right" aria-hidden="true"></i>{" "}
            <b>
              <u>+91 8088975867</u>
            </b>
          </span>
          <span>
            <i className="fa fa-volume-control-phone" aria-hidden="true"></i>{" "}
            <b>Talk To Our Tech Team</b>{" "}
          </span>
          <span>
            <i className="fa fa-question-circle" aria-hidden="true"></i> Any query
            related to live classes
          </span>
        </a>
      </div>
    </div>
  );
}



export default DataScienceCourseBangalore